/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as FoodAppImport } from './routes/food-app'
import { Route as InventoryRouteImport } from './routes/inventory/route'
import { Route as DevicesRouteImport } from './routes/devices/route'
import { Route as BrewcontrolRouteImport } from './routes/brewcontrol/route'
import { Route as AnalyticsRouteImport } from './routes/analytics/route'
import { Route as IndexImport } from './routes/index'
import { Route as SettingsIndexImport } from './routes/settings/index'
import { Route as InventoryIndexImport } from './routes/inventory/index'
import { Route as HarvestsIndexImport } from './routes/harvests/index'
import { Route as FoodAppIndexImport } from './routes/food-app/index'
import { Route as FermentationsIndexImport } from './routes/fermentations/index'
import { Route as DevicesIndexImport } from './routes/devices/index'
import { Route as BrewcontrolIndexImport } from './routes/brewcontrol/index'
import { Route as BatchesIndexImport } from './routes/batches/index'
import { Route as AnalyticsIndexImport } from './routes/analytics/index'
import { Route as UploadTokenImport } from './routes/upload/$token'
import { Route as TestsSplatImport } from './routes/tests/$'
import { Route as StagePreviewStageImport } from './routes/stage/preview-stage'
import { Route as SettingsOperatorsImport } from './routes/settings/operators'
import { Route as SettingsFermentationParametersImport } from './routes/settings/fermentation-parameters'
import { Route as SettingsDevicesImport } from './routes/settings/devices'
import { Route as SensoryTokenImport } from './routes/sensory/$token'
import { Route as InventorySuppliersImport } from './routes/inventory/suppliers'
import { Route as InventoryReceivingImport } from './routes/inventory/receiving'
import { Route as InventoryProductsImport } from './routes/inventory/products'
import { Route as InventoryOrganismsImport } from './routes/inventory/organisms'
import { Route as InventoryOrdersImport } from './routes/inventory/orders'
import { Route as InventoryAnalyticsImport } from './routes/inventory/analytics'
import { Route as HarvestsBrothImport } from './routes/harvests/broth'
import { Route as FoodAppTastingsImport } from './routes/food-app/tastings'
import { Route as FoodAppTastersImport } from './routes/food-app/tasters'
import { Route as FoodAppSensoryImport } from './routes/food-app/sensory'
import { Route as FoodAppProjectsImport } from './routes/food-app/projects'
import { Route as FoodAppIngredientsImport } from './routes/food-app/ingredients'
import { Route as FoodAppConfigurationImport } from './routes/food-app/configuration'
import { Route as FermentationsMethanolSuggestionsImport } from './routes/fermentations/methanol-suggestions'
import { Route as FermentationsCanvasImport } from './routes/fermentations/canvas'
import { Route as FermentationsBottlesImport } from './routes/fermentations/bottles'
import { Route as FermentationsBoardImport } from './routes/fermentations/board'
import { Route as DevicesDeviceIdImport } from './routes/devices/$deviceId'
import { Route as ConsentSharecodeImport } from './routes/consent/$share_code'
import { Route as BrewcontrolEnrolImport } from './routes/brewcontrol/enrol'
import { Route as BatchesBatchidImport } from './routes/batches/$batch_id'
import { Route as AnalyticsLabsImport } from './routes/analytics/labs'
import { Route as AnalyticsCatalogueImport } from './routes/analytics/catalogue'
import { Route as AnalyticsSlugImport } from './routes/analytics/$slug'
import { Route as AlertTokenImport } from './routes/alert/$token'
import { Route as HarvestsSessionidRouteImport } from './routes/harvests/$session_id/route'
import { Route as FermentationsGroupidRouteImport } from './routes/fermentations/$group_id/route'
import { Route as BrewcontrolNodeIdRouteImport } from './routes/brewcontrol/$nodeId/route'
import { Route as SettingsFormulaTemplatesIndexImport } from './routes/settings/formula-templates/index'
import { Route as SettingsDocumentsIndexImport } from './routes/settings/documents/index'
import { Route as SettingsCleaningProceduresIndexImport } from './routes/settings/cleaning-procedures/index'
import { Route as SettingsBatchClearanceIndexImport } from './routes/settings/batch-clearance/index'
import { Route as InventoryRecipesIndexImport } from './routes/inventory/recipes/index'
import { Route as InventoryEquipmentIndexImport } from './routes/inventory/equipment.index'
import { Route as HarvestsProtocolsIndexImport } from './routes/harvests/protocols/index'
import { Route as HarvestsOperationTemplatesIndexImport } from './routes/harvests/operation-templates/index'
import { Route as HarvestsBatchesIndexImport } from './routes/harvests/batches/index'
import { Route as HarvestsSessionidIndexImport } from './routes/harvests/$session_id/index'
import { Route as FoodAppTastingsIndexImport } from './routes/food-app/tastings/index'
import { Route as FoodAppTastersIndexImport } from './routes/food-app/tasters/index'
import { Route as FoodAppSensoryIndexImport } from './routes/food-app/sensory/index'
import { Route as FoodAppProjectsIndexImport } from './routes/food-app/projects/index'
import { Route as FoodAppIngredientsIndexImport } from './routes/food-app/ingredients/index'
import { Route as FermentationsProtocolsIndexImport } from './routes/fermentations/protocols/index'
import { Route as FermentationsProceduresIndexImport } from './routes/fermentations/procedures/index'
import { Route as FermentationsMediumRecipesIndexImport } from './routes/fermentations/medium-recipes/index'
import { Route as FermentationsInvestigationsIndexImport } from './routes/fermentations/investigations/index'
import { Route as FermentationsDashboardsIndexImport } from './routes/fermentations/dashboards/index'
import { Route as FermentationsGroupidIndexImport } from './routes/fermentations/$group_id/index'
import { Route as BrewcontrolWiringsIndexImport } from './routes/brewcontrol/wirings/index'
import { Route as BrewcontrolNodeIdIndexImport } from './routes/brewcontrol/$nodeId/index'
import { Route as AnalyticsTemplatesIndexImport } from './routes/analytics/templates/index'
import { Route as AnalyticsExternalIndexImport } from './routes/analytics/external/index'
import { Route as AnalyticsClassicIndexImport } from './routes/analytics/classic/index'
import { Route as AnalyticsBlueprintsIndexImport } from './routes/analytics/blueprints.index'
import { Route as StageTastingTastingidImport } from './routes/stage/tasting/$tasting_id'
import { Route as StagePreviewTastingidImport } from './routes/stage/preview/$tasting_id'
import { Route as SettingsInventorySterilizationImport } from './routes/settings/inventory/sterilization'
import { Route as SettingsInventoryResourcesImport } from './routes/settings/inventory/resources'
import { Route as SettingsInventoryManufacturersImport } from './routes/settings/inventory/manufacturers'
import { Route as SettingsInventoryLocationsImport } from './routes/settings/inventory/locations'
import { Route as SettingsInventoryEquipmentTypesImport } from './routes/settings/inventory/equipment-types'
import { Route as SettingsInventoryEquipmentModelsImport } from './routes/settings/inventory/equipment-models'
import { Route as SettingsInventoryCertificateTypesImport } from './routes/settings/inventory/certificate-types'
import { Route as SettingsFormulaTemplatesTemplateidImport } from './routes/settings/formula-templates/$template_id'
import { Route as SettingsBatchClearanceClearancedefintionidImport } from './routes/settings/batch-clearance/$clearance_defintion_id'
import { Route as SensoryJoinJoincodeImport } from './routes/sensory/join/$join_code'
import { Route as InventoryRecipesRecipeIdImport } from './routes/inventory/recipes/$recipeId'
import { Route as InventoryPurchasedNewImport } from './routes/inventory/purchased.new'
import { Route as InventoryPrepareRecipeImport } from './routes/inventory/prepare.recipe'
import { Route as InventoryPrepareDilutionImport } from './routes/inventory/prepare.dilution'
import { Route as InventoryOrdersNewImport } from './routes/inventory/orders.new'
import { Route as HarvestsBatchesBatchidImport } from './routes/harvests/batches/$batch_id'
import { Route as HarvestsSessionidSamplesImport } from './routes/harvests/$session_id/samples'
import { Route as HarvestsSessionidPreCleaningImport } from './routes/harvests/$session_id/pre-cleaning'
import { Route as HarvestsSessionidPostCleaningImport } from './routes/harvests/$session_id/post-cleaning'
import { Route as HarvestsSessionidLiveImport } from './routes/harvests/$session_id/live'
import { Route as HarvestsSessionidBatchesImport } from './routes/harvests/$session_id/batches'
import { Route as HarvestsSessionidAnalysisImport } from './routes/harvests/$session_id/analysis'
import { Route as FoodAppTastingsTastingidImport } from './routes/food-app/tastings/$tasting_id'
import { Route as FoodAppTastersTasteridImport } from './routes/food-app/tasters/$taster_id'
import { Route as FoodAppSensoryTemplatesImport } from './routes/food-app/sensory/templates'
import { Route as FoodAppSensoryBrewsensorysessionidImport } from './routes/food-app/sensory/$brew_sensory_session_id'
import { Route as FoodAppIngredientsProductidImport } from './routes/food-app/ingredients/$product_id'
import { Route as FermentationsMediumRecipesRecipeidImport } from './routes/fermentations/medium-recipes/$recipe_id'
import { Route as FermentationsInvestigationsInvestigationidImport } from './routes/fermentations/investigations/$investigation_id'
import { Route as FermentationsDashboardsDashboardIdImport } from './routes/fermentations/dashboards/$dashboardId'
import { Route as FermentationsGroupidTimelineImport } from './routes/fermentations/$group_id/timeline'
import { Route as DevicesRigsRigIdImport } from './routes/devices/rigs/$rigId'
import { Route as BrewcontrolNodeIdLogsImport } from './routes/brewcontrol/$nodeId/logs'
import { Route as BrewcontrolNodeIdDevicesImport } from './routes/brewcontrol/$nodeId/devices'
import { Route as BrewcontrolNodeIdConfigImport } from './routes/brewcontrol/$nodeId/config'
import { Route as BrewcontrolNodeIdCalibrationImport } from './routes/brewcontrol/$nodeId/calibration'
import { Route as AnalyticsMethodsTemplateidImport } from './routes/analytics/methods.$template_id'
import { Route as AnalyticsClassicSlugImport } from './routes/analytics/classic/$slug'
import { Route as AnalyticsBlueprintsBlueprintidImport } from './routes/analytics/blueprints.$blueprint_id'
import { Route as SettingsCleaningProceduresProcedureidRouteImport } from './routes/settings/cleaning-procedures/$procedure_id/route'
import { Route as InventoryEquipmentEquipmentidRouteImport } from './routes/inventory/equipment/$equipment_id/route'
import { Route as HarvestsProtocolsProtocolidRouteImport } from './routes/harvests/protocols/$protocol_id/route'
import { Route as HarvestsOperationTemplatesTemplateidRouteImport } from './routes/harvests/operation-templates/$template_id/route'
import { Route as FoodAppSessionsSessionidRouteImport } from './routes/food-app/sessions/$session_id/route'
import { Route as FoodAppProjectsProjectidRouteImport } from './routes/food-app/projects/$project_id/route'
import { Route as FermentationsProtocolsProtocolidRouteImport } from './routes/fermentations/protocols/$protocol_id/route'
import { Route as FermentationsProceduresProcedureidRouteImport } from './routes/fermentations/procedures/$procedure_id/route'
import { Route as FermentationsGroupidSetupRouteImport } from './routes/fermentations/$group_id/setup/route'
import { Route as FermentationsGroupidResultsRouteImport } from './routes/fermentations/$group_id/results/route'
import { Route as FermentationsGroupidPlanningRouteImport } from './routes/fermentations/$group_id/planning/route'
import { Route as FermentationsGroupidAftercareRouteImport } from './routes/fermentations/$group_id/aftercare/route'
import { Route as BrewcontrolWiringsModelIdRouteImport } from './routes/brewcontrol/wirings/$modelId/route'
import { Route as AnalyticsTemplatesTemplateidRouteImport } from './routes/analytics/templates/$template_id/route'
import { Route as SettingsCleaningProceduresProcedureidIndexImport } from './routes/settings/cleaning-procedures/$procedure_id/index'
import { Route as InventoryEquipmentEquipmentidIndexImport } from './routes/inventory/equipment/$equipment_id/index'
import { Route as HarvestsProtocolsProtocolidIndexImport } from './routes/harvests/protocols/$protocol_id/index'
import { Route as HarvestsOperationTemplatesTemplateidIndexImport } from './routes/harvests/operation-templates/$template_id/index'
import { Route as FoodAppSessionsSessionidIndexImport } from './routes/food-app/sessions/$session_id/index'
import { Route as FoodAppProjectsProjectidIndexImport } from './routes/food-app/projects/$project_id/index'
import { Route as FermentationsProtocolsProtocolidIndexImport } from './routes/fermentations/protocols/$protocol_id/index'
import { Route as FermentationsProceduresProcedureidIndexImport } from './routes/fermentations/procedures/$procedure_id/index'
import { Route as FermentationsGroupidSetupIndexImport } from './routes/fermentations/$group_id/setup/index'
import { Route as FermentationsGroupidResultsIndexImport } from './routes/fermentations/$group_id/results/index'
import { Route as FermentationsGroupidPlanningIndexImport } from './routes/fermentations/$group_id/planning/index'
import { Route as FermentationsGroupidAftercareIndexImport } from './routes/fermentations/$group_id/aftercare/index'
import { Route as BrewcontrolWiringsModelIdIndexImport } from './routes/brewcontrol/wirings/$modelId/index'
import { Route as AnalyticsTemplatesTemplateidIndexImport } from './routes/analytics/templates/$template_id/index'
import { Route as SettingsInventorySuppliersIdImport } from './routes/settings/inventory/suppliers.$id'
import { Route as SettingsCleaningProceduresProcedureidFieldsImport } from './routes/settings/cleaning-procedures/$procedure_id/fields'
import { Route as SensoryJoinBrewSensorysessionidImport } from './routes/sensory/join/brew/$sensory_session_id'
import { Route as InventoryEquipmentEquipmentidMaintenanceImport } from './routes/inventory/equipment/$equipment_id/maintenance'
import { Route as HarvestsProtocolsProtocolidKpisImport } from './routes/harvests/protocols/$protocol_id/kpis'
import { Route as HarvestsProtocolsProtocolidCleaningImport } from './routes/harvests/protocols/$protocol_id/cleaning'
import { Route as HarvestsOperationTemplatesTemplateidSamplesImport } from './routes/harvests/operation-templates/$template_id/samples'
import { Route as HarvestsOperationTemplatesTemplateidKpisImport } from './routes/harvests/operation-templates/$template_id/kpis'
import { Route as HarvestsOperationTemplatesTemplateidAttributesImport } from './routes/harvests/operation-templates/$template_id/attributes'
import { Route as HarvestsSessionidStagesStageidImport } from './routes/harvests/$session_id/stages/$stage_id'
import { Route as FoodAppSessionsSessionidSetupImport } from './routes/food-app/sessions/$session_id/setup'
import { Route as FoodAppSessionsSessionidRunningImport } from './routes/food-app/sessions/$session_id/running'
import { Route as FoodAppSessionsSessionidResultsImport } from './routes/food-app/sessions/$session_id/results'
import { Route as FoodAppSessionsSessionidGeneralImport } from './routes/food-app/sessions/$session_id/general'
import { Route as FoodAppSessionsSessionidAnalysisImport } from './routes/food-app/sessions/$session_id/analysis'
import { Route as FermentationsProtocolsProtocolidParametersImport } from './routes/fermentations/protocols/$protocol_id/parameters'
import { Route as FermentationsProtocolsProtocolidOverviewImport } from './routes/fermentations/protocols/$protocol_id/overview'
import { Route as FermentationsProceduresProcedureidTasksImport } from './routes/fermentations/procedures/$procedure_id/tasks'
import { Route as FermentationsProceduresProcedureidProtocolsImport } from './routes/fermentations/procedures/$procedure_id/protocols'
import { Route as FermentationsProceduresProcedureidOverviewImport } from './routes/fermentations/procedures/$procedure_id/overview'
import { Route as FermentationsProceduresProcedureidLinesImport } from './routes/fermentations/procedures/$procedure_id/lines'
import { Route as FermentationsProceduresProcedureidKpisImport } from './routes/fermentations/procedures/$procedure_id/kpis'
import { Route as FermentationsProceduresProcedureidDashboardImport } from './routes/fermentations/procedures/$procedure_id/dashboard'
import { Route as FermentationsProceduresProcedureidAlertsImport } from './routes/fermentations/procedures/$procedure_id/alerts'
import { Route as FermentationsGroupidSetupSeedFlaskImport } from './routes/fermentations/$group_id/setup/seed-flask'
import { Route as FermentationsGroupidSetupPreparationImport } from './routes/fermentations/$group_id/setup/preparation'
import { Route as FermentationsGroupidSetupPreCleaningImport } from './routes/fermentations/$group_id/setup/pre-cleaning'
import { Route as FermentationsGroupidSetupInoculationImport } from './routes/fermentations/$group_id/setup/inoculation'
import { Route as FermentationsGroupidSetupCalibrationImport } from './routes/fermentations/$group_id/setup/calibration'
import { Route as FermentationsGroupidResultsTestsImport } from './routes/fermentations/$group_id/results/tests'
import { Route as FermentationsGroupidResultsKpisImport } from './routes/fermentations/$group_id/results/kpis'
import { Route as FermentationsGroupidResultsDataImport } from './routes/fermentations/$group_id/results/data'
import { Route as FermentationsGroupidResultsChartsImport } from './routes/fermentations/$group_id/results/charts'
import { Route as FermentationsGroupidResultsAnalysisImport } from './routes/fermentations/$group_id/results/analysis'
import { Route as FermentationsGroupidPlanningProtocolImport } from './routes/fermentations/$group_id/planning/protocol'
import { Route as FermentationsGroupidPlanningGeneralImport } from './routes/fermentations/$group_id/planning/general'
import { Route as FermentationsGroupidPlanningAlertsImport } from './routes/fermentations/$group_id/planning/alerts'
import { Route as FermentationsGroupidAftercareWeightsImport } from './routes/fermentations/$group_id/aftercare/weights'
import { Route as FermentationsGroupidAftercareCipImport } from './routes/fermentations/$group_id/aftercare/cip'
import { Route as BrewcontrolWiringsModelIdCalibrationImport } from './routes/brewcontrol/wirings/$modelId/calibration'
import { Route as AnalyticsTemplatesTemplateidCurvesImport } from './routes/analytics/templates/$template_id/curves'
import { Route as AnalyticsTemplatesTemplateidBlueprintImport } from './routes/analytics/templates/$template_id/blueprint'
import { Route as AnalyticsTemplatesTemplateidAttributesImport } from './routes/analytics/templates/$template_id/attributes'
import { Route as AnalyticsExternalOrdersSessionidImport } from './routes/analytics/external/orders.$session_id'
import { Route as AnalyticsExternalImportsImportidImport } from './routes/analytics/external/imports.$import_id'
import { Route as InventoryEquipmentEquipmentidCleaningIndexImport } from './routes/inventory/equipment/$equipment_id/cleaning/index'
import { Route as SettingsCleaningProceduresProcedureidFormsFormidImport } from './routes/settings/cleaning-procedures/$procedure_id/forms/$form_id'
import { Route as InventoryEquipmentEquipmentidCleaningNewImport } from './routes/inventory/equipment/$equipment_id/cleaning/new'
import { Route as InventoryEquipmentEquipmentidCleaningRecordidImport } from './routes/inventory/equipment/$equipment_id/cleaning/$record_id'
import { Route as FoodAppProjectsProjectidSensorySensorysessionidImport } from './routes/food-app/projects/$project_id/sensory.$sensory_session_id'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const FoodAppRoute = FoodAppImport.update({
  id: '/food-app',
  path: '/food-app',
  getParentRoute: () => rootRoute,
} as any)

const InventoryRouteRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRoute,
} as any)

const DevicesRouteRoute = DevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => rootRoute,
} as any)

const BrewcontrolRouteRoute = BrewcontrolRouteImport.update({
  id: '/brewcontrol',
  path: '/brewcontrol',
  getParentRoute: () => rootRoute,
} as any)

const AnalyticsRouteRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsIndexRoute = SettingsIndexImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRoute,
} as any)

const InventoryIndexRoute = InventoryIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const HarvestsIndexRoute = HarvestsIndexImport.update({
  id: '/harvests/',
  path: '/harvests/',
  getParentRoute: () => rootRoute,
} as any)

const FoodAppIndexRoute = FoodAppIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FoodAppRoute,
} as any)

const FermentationsIndexRoute = FermentationsIndexImport.update({
  id: '/fermentations/',
  path: '/fermentations/',
  getParentRoute: () => rootRoute,
} as any)

const DevicesIndexRoute = DevicesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevicesRouteRoute,
} as any)

const BrewcontrolIndexRoute = BrewcontrolIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BrewcontrolRouteRoute,
} as any)

const BatchesIndexRoute = BatchesIndexImport.update({
  id: '/batches/',
  path: '/batches/',
  getParentRoute: () => rootRoute,
} as any)

const AnalyticsIndexRoute = AnalyticsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AnalyticsRouteRoute,
} as any)

const UploadTokenRoute = UploadTokenImport.update({
  id: '/upload/$token',
  path: '/upload/$token',
  getParentRoute: () => rootRoute,
} as any)

const TestsSplatRoute = TestsSplatImport.update({
  id: '/tests/$',
  path: '/tests/$',
  getParentRoute: () => rootRoute,
} as any)

const StagePreviewStageRoute = StagePreviewStageImport.update({
  id: '/stage/preview-stage',
  path: '/stage/preview-stage',
  getParentRoute: () => rootRoute,
} as any)

const SettingsOperatorsRoute = SettingsOperatorsImport.update({
  id: '/settings/operators',
  path: '/settings/operators',
  getParentRoute: () => rootRoute,
} as any)

const SettingsFermentationParametersRoute =
  SettingsFermentationParametersImport.update({
    id: '/settings/fermentation-parameters',
    path: '/settings/fermentation-parameters',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsDevicesRoute = SettingsDevicesImport.update({
  id: '/settings/devices',
  path: '/settings/devices',
  getParentRoute: () => rootRoute,
} as any)

const SensoryTokenRoute = SensoryTokenImport.update({
  id: '/sensory/$token',
  path: '/sensory/$token',
  getParentRoute: () => rootRoute,
} as any)

const InventorySuppliersRoute = InventorySuppliersImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryReceivingRoute = InventoryReceivingImport.update({
  id: '/receiving',
  path: '/receiving',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryProductsRoute = InventoryProductsImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryOrganismsRoute = InventoryOrganismsImport.update({
  id: '/organisms',
  path: '/organisms',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryOrdersRoute = InventoryOrdersImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryAnalyticsRoute = InventoryAnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const HarvestsBrothRoute = HarvestsBrothImport.update({
  id: '/harvests/broth',
  path: '/harvests/broth',
  getParentRoute: () => rootRoute,
} as any)

const FoodAppTastingsRoute = FoodAppTastingsImport.update({
  id: '/tastings',
  path: '/tastings',
  getParentRoute: () => FoodAppRoute,
} as any)

const FoodAppTastersRoute = FoodAppTastersImport.update({
  id: '/tasters',
  path: '/tasters',
  getParentRoute: () => FoodAppRoute,
} as any)

const FoodAppSensoryRoute = FoodAppSensoryImport.update({
  id: '/sensory',
  path: '/sensory',
  getParentRoute: () => FoodAppRoute,
} as any)

const FoodAppProjectsRoute = FoodAppProjectsImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => FoodAppRoute,
} as any)

const FoodAppIngredientsRoute = FoodAppIngredientsImport.update({
  id: '/ingredients',
  path: '/ingredients',
  getParentRoute: () => FoodAppRoute,
} as any)

const FoodAppConfigurationRoute = FoodAppConfigurationImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => FoodAppRoute,
} as any)

const FermentationsMethanolSuggestionsRoute =
  FermentationsMethanolSuggestionsImport.update({
    id: '/fermentations/methanol-suggestions',
    path: '/fermentations/methanol-suggestions',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsCanvasRoute = FermentationsCanvasImport.update({
  id: '/fermentations/canvas',
  path: '/fermentations/canvas',
  getParentRoute: () => rootRoute,
} as any)

const FermentationsBottlesRoute = FermentationsBottlesImport.update({
  id: '/fermentations/bottles',
  path: '/fermentations/bottles',
  getParentRoute: () => rootRoute,
} as any)

const FermentationsBoardRoute = FermentationsBoardImport.update({
  id: '/fermentations/board',
  path: '/fermentations/board',
  getParentRoute: () => rootRoute,
} as any)

const DevicesDeviceIdRoute = DevicesDeviceIdImport.update({
  id: '/$deviceId',
  path: '/$deviceId',
  getParentRoute: () => DevicesRouteRoute,
} as any)

const ConsentSharecodeRoute = ConsentSharecodeImport.update({
  id: '/consent/$share_code',
  path: '/consent/$share_code',
  getParentRoute: () => rootRoute,
} as any)

const BrewcontrolEnrolRoute = BrewcontrolEnrolImport.update({
  id: '/enrol',
  path: '/enrol',
  getParentRoute: () => BrewcontrolRouteRoute,
} as any)

const BatchesBatchidRoute = BatchesBatchidImport.update({
  id: '/batches/$batch_id',
  path: '/batches/$batch_id',
  getParentRoute: () => rootRoute,
} as any)

const AnalyticsLabsRoute = AnalyticsLabsImport.update({
  id: '/labs',
  path: '/labs',
  getParentRoute: () => AnalyticsRouteRoute,
} as any)

const AnalyticsCatalogueRoute = AnalyticsCatalogueImport.update({
  id: '/catalogue',
  path: '/catalogue',
  getParentRoute: () => AnalyticsRouteRoute,
} as any)

const AnalyticsSlugRoute = AnalyticsSlugImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AnalyticsRouteRoute,
} as any)

const AlertTokenRoute = AlertTokenImport.update({
  id: '/alert/$token',
  path: '/alert/$token',
  getParentRoute: () => rootRoute,
} as any)

const HarvestsSessionidRouteRoute = HarvestsSessionidRouteImport.update({
  id: '/harvests/$session_id',
  path: '/harvests/$session_id',
  getParentRoute: () => rootRoute,
} as any)

const FermentationsGroupidRouteRoute = FermentationsGroupidRouteImport.update({
  id: '/fermentations/$group_id',
  path: '/fermentations/$group_id',
  getParentRoute: () => rootRoute,
} as any)

const BrewcontrolNodeIdRouteRoute = BrewcontrolNodeIdRouteImport.update({
  id: '/$nodeId',
  path: '/$nodeId',
  getParentRoute: () => BrewcontrolRouteRoute,
} as any)

const SettingsFormulaTemplatesIndexRoute =
  SettingsFormulaTemplatesIndexImport.update({
    id: '/settings/formula-templates/',
    path: '/settings/formula-templates/',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsDocumentsIndexRoute = SettingsDocumentsIndexImport.update({
  id: '/settings/documents/',
  path: '/settings/documents/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsCleaningProceduresIndexRoute =
  SettingsCleaningProceduresIndexImport.update({
    id: '/settings/cleaning-procedures/',
    path: '/settings/cleaning-procedures/',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsBatchClearanceIndexRoute =
  SettingsBatchClearanceIndexImport.update({
    id: '/settings/batch-clearance/',
    path: '/settings/batch-clearance/',
    getParentRoute: () => rootRoute,
  } as any)

const InventoryRecipesIndexRoute = InventoryRecipesIndexImport.update({
  id: '/recipes/',
  path: '/recipes/',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryEquipmentIndexRoute = InventoryEquipmentIndexImport.update({
  id: '/equipment/',
  path: '/equipment/',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const HarvestsProtocolsIndexRoute = HarvestsProtocolsIndexImport.update({
  id: '/harvests/protocols/',
  path: '/harvests/protocols/',
  getParentRoute: () => rootRoute,
} as any)

const HarvestsOperationTemplatesIndexRoute =
  HarvestsOperationTemplatesIndexImport.update({
    id: '/harvests/operation-templates/',
    path: '/harvests/operation-templates/',
    getParentRoute: () => rootRoute,
  } as any)

const HarvestsBatchesIndexRoute = HarvestsBatchesIndexImport.update({
  id: '/harvests/batches/',
  path: '/harvests/batches/',
  getParentRoute: () => rootRoute,
} as any)

const HarvestsSessionidIndexRoute = HarvestsSessionidIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HarvestsSessionidRouteRoute,
} as any)

const FoodAppTastingsIndexRoute = FoodAppTastingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FoodAppTastingsRoute,
} as any)

const FoodAppTastersIndexRoute = FoodAppTastersIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FoodAppTastersRoute,
} as any)

const FoodAppSensoryIndexRoute = FoodAppSensoryIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FoodAppSensoryRoute,
} as any)

const FoodAppProjectsIndexRoute = FoodAppProjectsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FoodAppProjectsRoute,
} as any)

const FoodAppIngredientsIndexRoute = FoodAppIngredientsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FoodAppIngredientsRoute,
} as any)

const FermentationsProtocolsIndexRoute =
  FermentationsProtocolsIndexImport.update({
    id: '/fermentations/protocols/',
    path: '/fermentations/protocols/',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsProceduresIndexRoute =
  FermentationsProceduresIndexImport.update({
    id: '/fermentations/procedures/',
    path: '/fermentations/procedures/',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsMediumRecipesIndexRoute =
  FermentationsMediumRecipesIndexImport.update({
    id: '/fermentations/medium-recipes/',
    path: '/fermentations/medium-recipes/',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsInvestigationsIndexRoute =
  FermentationsInvestigationsIndexImport.update({
    id: '/fermentations/investigations/',
    path: '/fermentations/investigations/',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsDashboardsIndexRoute =
  FermentationsDashboardsIndexImport.update({
    id: '/fermentations/dashboards/',
    path: '/fermentations/dashboards/',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsGroupidIndexRoute = FermentationsGroupidIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FermentationsGroupidRouteRoute,
} as any)

const BrewcontrolWiringsIndexRoute = BrewcontrolWiringsIndexImport.update({
  id: '/wirings/',
  path: '/wirings/',
  getParentRoute: () => BrewcontrolRouteRoute,
} as any)

const BrewcontrolNodeIdIndexRoute = BrewcontrolNodeIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BrewcontrolNodeIdRouteRoute,
} as any)

const AnalyticsTemplatesIndexRoute = AnalyticsTemplatesIndexImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => AnalyticsRouteRoute,
} as any)

const AnalyticsExternalIndexRoute = AnalyticsExternalIndexImport.update({
  id: '/external/',
  path: '/external/',
  getParentRoute: () => AnalyticsRouteRoute,
} as any)

const AnalyticsClassicIndexRoute = AnalyticsClassicIndexImport.update({
  id: '/classic/',
  path: '/classic/',
  getParentRoute: () => AnalyticsRouteRoute,
} as any)

const AnalyticsBlueprintsIndexRoute = AnalyticsBlueprintsIndexImport.update({
  id: '/blueprints/',
  path: '/blueprints/',
  getParentRoute: () => AnalyticsRouteRoute,
} as any)

const StageTastingTastingidRoute = StageTastingTastingidImport.update({
  id: '/stage/tasting/$tasting_id',
  path: '/stage/tasting/$tasting_id',
  getParentRoute: () => rootRoute,
} as any)

const StagePreviewTastingidRoute = StagePreviewTastingidImport.update({
  id: '/stage/preview/$tasting_id',
  path: '/stage/preview/$tasting_id',
  getParentRoute: () => rootRoute,
} as any)

const SettingsInventorySterilizationRoute =
  SettingsInventorySterilizationImport.update({
    id: '/settings/inventory/sterilization',
    path: '/settings/inventory/sterilization',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsInventoryResourcesRoute = SettingsInventoryResourcesImport.update(
  {
    id: '/settings/inventory/resources',
    path: '/settings/inventory/resources',
    getParentRoute: () => rootRoute,
  } as any,
)

const SettingsInventoryManufacturersRoute =
  SettingsInventoryManufacturersImport.update({
    id: '/settings/inventory/manufacturers',
    path: '/settings/inventory/manufacturers',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsInventoryLocationsRoute = SettingsInventoryLocationsImport.update(
  {
    id: '/settings/inventory/locations',
    path: '/settings/inventory/locations',
    getParentRoute: () => rootRoute,
  } as any,
)

const SettingsInventoryEquipmentTypesRoute =
  SettingsInventoryEquipmentTypesImport.update({
    id: '/settings/inventory/equipment-types',
    path: '/settings/inventory/equipment-types',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsInventoryEquipmentModelsRoute =
  SettingsInventoryEquipmentModelsImport.update({
    id: '/settings/inventory/equipment-models',
    path: '/settings/inventory/equipment-models',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsInventoryCertificateTypesRoute =
  SettingsInventoryCertificateTypesImport.update({
    id: '/settings/inventory/certificate-types',
    path: '/settings/inventory/certificate-types',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsFormulaTemplatesTemplateidRoute =
  SettingsFormulaTemplatesTemplateidImport.update({
    id: '/settings/formula-templates/$template_id',
    path: '/settings/formula-templates/$template_id',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsBatchClearanceClearancedefintionidRoute =
  SettingsBatchClearanceClearancedefintionidImport.update({
    id: '/settings/batch-clearance/$clearance_defintion_id',
    path: '/settings/batch-clearance/$clearance_defintion_id',
    getParentRoute: () => rootRoute,
  } as any)

const SensoryJoinJoincodeRoute = SensoryJoinJoincodeImport.update({
  id: '/sensory/join/$join_code',
  path: '/sensory/join/$join_code',
  getParentRoute: () => rootRoute,
} as any)

const InventoryRecipesRecipeIdRoute = InventoryRecipesRecipeIdImport.update({
  id: '/recipes/$recipeId',
  path: '/recipes/$recipeId',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryPurchasedNewRoute = InventoryPurchasedNewImport.update({
  id: '/purchased/new',
  path: '/purchased/new',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryPrepareRecipeRoute = InventoryPrepareRecipeImport.update({
  id: '/prepare/recipe',
  path: '/prepare/recipe',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryPrepareDilutionRoute = InventoryPrepareDilutionImport.update({
  id: '/prepare/dilution',
  path: '/prepare/dilution',
  getParentRoute: () => InventoryRouteRoute,
} as any)

const InventoryOrdersNewRoute = InventoryOrdersNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => InventoryOrdersRoute,
} as any)

const HarvestsBatchesBatchidRoute = HarvestsBatchesBatchidImport.update({
  id: '/harvests/batches/$batch_id',
  path: '/harvests/batches/$batch_id',
  getParentRoute: () => rootRoute,
} as any)

const HarvestsSessionidSamplesRoute = HarvestsSessionidSamplesImport.update({
  id: '/samples',
  path: '/samples',
  getParentRoute: () => HarvestsSessionidRouteRoute,
} as any)

const HarvestsSessionidPreCleaningRoute =
  HarvestsSessionidPreCleaningImport.update({
    id: '/pre-cleaning',
    path: '/pre-cleaning',
    getParentRoute: () => HarvestsSessionidRouteRoute,
  } as any)

const HarvestsSessionidPostCleaningRoute =
  HarvestsSessionidPostCleaningImport.update({
    id: '/post-cleaning',
    path: '/post-cleaning',
    getParentRoute: () => HarvestsSessionidRouteRoute,
  } as any)

const HarvestsSessionidLiveRoute = HarvestsSessionidLiveImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => HarvestsSessionidRouteRoute,
} as any)

const HarvestsSessionidBatchesRoute = HarvestsSessionidBatchesImport.update({
  id: '/batches',
  path: '/batches',
  getParentRoute: () => HarvestsSessionidRouteRoute,
} as any)

const HarvestsSessionidAnalysisRoute = HarvestsSessionidAnalysisImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => HarvestsSessionidRouteRoute,
} as any)

const FoodAppTastingsTastingidRoute = FoodAppTastingsTastingidImport.update({
  id: '/$tasting_id',
  path: '/$tasting_id',
  getParentRoute: () => FoodAppTastingsRoute,
} as any)

const FoodAppTastersTasteridRoute = FoodAppTastersTasteridImport.update({
  id: '/$taster_id',
  path: '/$taster_id',
  getParentRoute: () => FoodAppTastersRoute,
} as any)

const FoodAppSensoryTemplatesRoute = FoodAppSensoryTemplatesImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => FoodAppSensoryRoute,
} as any)

const FoodAppSensoryBrewsensorysessionidRoute =
  FoodAppSensoryBrewsensorysessionidImport.update({
    id: '/$brew_sensory_session_id',
    path: '/$brew_sensory_session_id',
    getParentRoute: () => FoodAppSensoryRoute,
  } as any)

const FoodAppIngredientsProductidRoute =
  FoodAppIngredientsProductidImport.update({
    id: '/$product_id',
    path: '/$product_id',
    getParentRoute: () => FoodAppIngredientsRoute,
  } as any)

const FermentationsMediumRecipesRecipeidRoute =
  FermentationsMediumRecipesRecipeidImport.update({
    id: '/fermentations/medium-recipes/$recipe_id',
    path: '/fermentations/medium-recipes/$recipe_id',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsInvestigationsInvestigationidRoute =
  FermentationsInvestigationsInvestigationidImport.update({
    id: '/fermentations/investigations/$investigation_id',
    path: '/fermentations/investigations/$investigation_id',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsDashboardsDashboardIdRoute =
  FermentationsDashboardsDashboardIdImport.update({
    id: '/fermentations/dashboards/$dashboardId',
    path: '/fermentations/dashboards/$dashboardId',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsGroupidTimelineRoute =
  FermentationsGroupidTimelineImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => FermentationsGroupidRouteRoute,
  } as any)

const DevicesRigsRigIdRoute = DevicesRigsRigIdImport.update({
  id: '/rigs/$rigId',
  path: '/rigs/$rigId',
  getParentRoute: () => DevicesRouteRoute,
} as any)

const BrewcontrolNodeIdLogsRoute = BrewcontrolNodeIdLogsImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => BrewcontrolNodeIdRouteRoute,
} as any)

const BrewcontrolNodeIdDevicesRoute = BrewcontrolNodeIdDevicesImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => BrewcontrolNodeIdRouteRoute,
} as any)

const BrewcontrolNodeIdConfigRoute = BrewcontrolNodeIdConfigImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => BrewcontrolNodeIdRouteRoute,
} as any)

const BrewcontrolNodeIdCalibrationRoute =
  BrewcontrolNodeIdCalibrationImport.update({
    id: '/calibration',
    path: '/calibration',
    getParentRoute: () => BrewcontrolNodeIdRouteRoute,
  } as any)

const AnalyticsMethodsTemplateidRoute = AnalyticsMethodsTemplateidImport.update(
  {
    id: '/methods/$template_id',
    path: '/methods/$template_id',
    getParentRoute: () => AnalyticsRouteRoute,
  } as any,
)

const AnalyticsClassicSlugRoute = AnalyticsClassicSlugImport.update({
  id: '/classic/$slug',
  path: '/classic/$slug',
  getParentRoute: () => AnalyticsRouteRoute,
} as any)

const AnalyticsBlueprintsBlueprintidRoute =
  AnalyticsBlueprintsBlueprintidImport.update({
    id: '/blueprints/$blueprint_id',
    path: '/blueprints/$blueprint_id',
    getParentRoute: () => AnalyticsRouteRoute,
  } as any)

const SettingsCleaningProceduresProcedureidRouteRoute =
  SettingsCleaningProceduresProcedureidRouteImport.update({
    id: '/settings/cleaning-procedures/$procedure_id',
    path: '/settings/cleaning-procedures/$procedure_id',
    getParentRoute: () => rootRoute,
  } as any)

const InventoryEquipmentEquipmentidRouteRoute =
  InventoryEquipmentEquipmentidRouteImport.update({
    id: '/equipment/$equipment_id',
    path: '/equipment/$equipment_id',
    getParentRoute: () => InventoryRouteRoute,
  } as any)

const HarvestsProtocolsProtocolidRouteRoute =
  HarvestsProtocolsProtocolidRouteImport.update({
    id: '/harvests/protocols/$protocol_id',
    path: '/harvests/protocols/$protocol_id',
    getParentRoute: () => rootRoute,
  } as any)

const HarvestsOperationTemplatesTemplateidRouteRoute =
  HarvestsOperationTemplatesTemplateidRouteImport.update({
    id: '/harvests/operation-templates/$template_id',
    path: '/harvests/operation-templates/$template_id',
    getParentRoute: () => rootRoute,
  } as any)

const FoodAppSessionsSessionidRouteRoute =
  FoodAppSessionsSessionidRouteImport.update({
    id: '/sessions/$session_id',
    path: '/sessions/$session_id',
    getParentRoute: () => FoodAppRoute,
  } as any)

const FoodAppProjectsProjectidRouteRoute =
  FoodAppProjectsProjectidRouteImport.update({
    id: '/$project_id',
    path: '/$project_id',
    getParentRoute: () => FoodAppProjectsRoute,
  } as any)

const FermentationsProtocolsProtocolidRouteRoute =
  FermentationsProtocolsProtocolidRouteImport.update({
    id: '/fermentations/protocols/$protocol_id',
    path: '/fermentations/protocols/$protocol_id',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsProceduresProcedureidRouteRoute =
  FermentationsProceduresProcedureidRouteImport.update({
    id: '/fermentations/procedures/$procedure_id',
    path: '/fermentations/procedures/$procedure_id',
    getParentRoute: () => rootRoute,
  } as any)

const FermentationsGroupidSetupRouteRoute =
  FermentationsGroupidSetupRouteImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => FermentationsGroupidRouteRoute,
  } as any)

const FermentationsGroupidResultsRouteRoute =
  FermentationsGroupidResultsRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => FermentationsGroupidRouteRoute,
  } as any)

const FermentationsGroupidPlanningRouteRoute =
  FermentationsGroupidPlanningRouteImport.update({
    id: '/planning',
    path: '/planning',
    getParentRoute: () => FermentationsGroupidRouteRoute,
  } as any)

const FermentationsGroupidAftercareRouteRoute =
  FermentationsGroupidAftercareRouteImport.update({
    id: '/aftercare',
    path: '/aftercare',
    getParentRoute: () => FermentationsGroupidRouteRoute,
  } as any)

const BrewcontrolWiringsModelIdRouteRoute =
  BrewcontrolWiringsModelIdRouteImport.update({
    id: '/wirings/$modelId',
    path: '/wirings/$modelId',
    getParentRoute: () => BrewcontrolRouteRoute,
  } as any)

const AnalyticsTemplatesTemplateidRouteRoute =
  AnalyticsTemplatesTemplateidRouteImport.update({
    id: '/templates/$template_id',
    path: '/templates/$template_id',
    getParentRoute: () => AnalyticsRouteRoute,
  } as any)

const SettingsCleaningProceduresProcedureidIndexRoute =
  SettingsCleaningProceduresProcedureidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SettingsCleaningProceduresProcedureidRouteRoute,
  } as any)

const InventoryEquipmentEquipmentidIndexRoute =
  InventoryEquipmentEquipmentidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InventoryEquipmentEquipmentidRouteRoute,
  } as any)

const HarvestsProtocolsProtocolidIndexRoute =
  HarvestsProtocolsProtocolidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HarvestsProtocolsProtocolidRouteRoute,
  } as any)

const HarvestsOperationTemplatesTemplateidIndexRoute =
  HarvestsOperationTemplatesTemplateidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HarvestsOperationTemplatesTemplateidRouteRoute,
  } as any)

const FoodAppSessionsSessionidIndexRoute =
  FoodAppSessionsSessionidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FoodAppSessionsSessionidRouteRoute,
  } as any)

const FoodAppProjectsProjectidIndexRoute =
  FoodAppProjectsProjectidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FoodAppProjectsProjectidRouteRoute,
  } as any)

const FermentationsProtocolsProtocolidIndexRoute =
  FermentationsProtocolsProtocolidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FermentationsProtocolsProtocolidRouteRoute,
  } as any)

const FermentationsProceduresProcedureidIndexRoute =
  FermentationsProceduresProcedureidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FermentationsProceduresProcedureidRouteRoute,
  } as any)

const FermentationsGroupidSetupIndexRoute =
  FermentationsGroupidSetupIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FermentationsGroupidSetupRouteRoute,
  } as any)

const FermentationsGroupidResultsIndexRoute =
  FermentationsGroupidResultsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FermentationsGroupidResultsRouteRoute,
  } as any)

const FermentationsGroupidPlanningIndexRoute =
  FermentationsGroupidPlanningIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FermentationsGroupidPlanningRouteRoute,
  } as any)

const FermentationsGroupidAftercareIndexRoute =
  FermentationsGroupidAftercareIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FermentationsGroupidAftercareRouteRoute,
  } as any)

const BrewcontrolWiringsModelIdIndexRoute =
  BrewcontrolWiringsModelIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BrewcontrolWiringsModelIdRouteRoute,
  } as any)

const AnalyticsTemplatesTemplateidIndexRoute =
  AnalyticsTemplatesTemplateidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AnalyticsTemplatesTemplateidRouteRoute,
  } as any)

const SettingsInventorySuppliersIdRoute =
  SettingsInventorySuppliersIdImport.update({
    id: '/settings/inventory/suppliers/$id',
    path: '/settings/inventory/suppliers/$id',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsCleaningProceduresProcedureidFieldsRoute =
  SettingsCleaningProceduresProcedureidFieldsImport.update({
    id: '/fields',
    path: '/fields',
    getParentRoute: () => SettingsCleaningProceduresProcedureidRouteRoute,
  } as any)

const SensoryJoinBrewSensorysessionidRoute =
  SensoryJoinBrewSensorysessionidImport.update({
    id: '/sensory/join/brew/$sensory_session_id',
    path: '/sensory/join/brew/$sensory_session_id',
    getParentRoute: () => rootRoute,
  } as any)

const InventoryEquipmentEquipmentidMaintenanceRoute =
  InventoryEquipmentEquipmentidMaintenanceImport.update({
    id: '/maintenance',
    path: '/maintenance',
    getParentRoute: () => InventoryEquipmentEquipmentidRouteRoute,
  } as any)

const HarvestsProtocolsProtocolidKpisRoute =
  HarvestsProtocolsProtocolidKpisImport.update({
    id: '/kpis',
    path: '/kpis',
    getParentRoute: () => HarvestsProtocolsProtocolidRouteRoute,
  } as any)

const HarvestsProtocolsProtocolidCleaningRoute =
  HarvestsProtocolsProtocolidCleaningImport.update({
    id: '/cleaning',
    path: '/cleaning',
    getParentRoute: () => HarvestsProtocolsProtocolidRouteRoute,
  } as any)

const HarvestsOperationTemplatesTemplateidSamplesRoute =
  HarvestsOperationTemplatesTemplateidSamplesImport.update({
    id: '/samples',
    path: '/samples',
    getParentRoute: () => HarvestsOperationTemplatesTemplateidRouteRoute,
  } as any)

const HarvestsOperationTemplatesTemplateidKpisRoute =
  HarvestsOperationTemplatesTemplateidKpisImport.update({
    id: '/kpis',
    path: '/kpis',
    getParentRoute: () => HarvestsOperationTemplatesTemplateidRouteRoute,
  } as any)

const HarvestsOperationTemplatesTemplateidAttributesRoute =
  HarvestsOperationTemplatesTemplateidAttributesImport.update({
    id: '/attributes',
    path: '/attributes',
    getParentRoute: () => HarvestsOperationTemplatesTemplateidRouteRoute,
  } as any)

const HarvestsSessionidStagesStageidRoute =
  HarvestsSessionidStagesStageidImport.update({
    id: '/stages/$stage_id',
    path: '/stages/$stage_id',
    getParentRoute: () => HarvestsSessionidRouteRoute,
  } as any)

const FoodAppSessionsSessionidSetupRoute =
  FoodAppSessionsSessionidSetupImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => FoodAppSessionsSessionidRouteRoute,
  } as any)

const FoodAppSessionsSessionidRunningRoute =
  FoodAppSessionsSessionidRunningImport.update({
    id: '/running',
    path: '/running',
    getParentRoute: () => FoodAppSessionsSessionidRouteRoute,
  } as any)

const FoodAppSessionsSessionidResultsRoute =
  FoodAppSessionsSessionidResultsImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => FoodAppSessionsSessionidRouteRoute,
  } as any)

const FoodAppSessionsSessionidGeneralRoute =
  FoodAppSessionsSessionidGeneralImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => FoodAppSessionsSessionidRouteRoute,
  } as any)

const FoodAppSessionsSessionidAnalysisRoute =
  FoodAppSessionsSessionidAnalysisImport.update({
    id: '/analysis',
    path: '/analysis',
    getParentRoute: () => FoodAppSessionsSessionidRouteRoute,
  } as any)

const FermentationsProtocolsProtocolidParametersRoute =
  FermentationsProtocolsProtocolidParametersImport.update({
    id: '/parameters',
    path: '/parameters',
    getParentRoute: () => FermentationsProtocolsProtocolidRouteRoute,
  } as any)

const FermentationsProtocolsProtocolidOverviewRoute =
  FermentationsProtocolsProtocolidOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => FermentationsProtocolsProtocolidRouteRoute,
  } as any)

const FermentationsProceduresProcedureidTasksRoute =
  FermentationsProceduresProcedureidTasksImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => FermentationsProceduresProcedureidRouteRoute,
  } as any)

const FermentationsProceduresProcedureidProtocolsRoute =
  FermentationsProceduresProcedureidProtocolsImport.update({
    id: '/protocols',
    path: '/protocols',
    getParentRoute: () => FermentationsProceduresProcedureidRouteRoute,
  } as any)

const FermentationsProceduresProcedureidOverviewRoute =
  FermentationsProceduresProcedureidOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => FermentationsProceduresProcedureidRouteRoute,
  } as any)

const FermentationsProceduresProcedureidLinesRoute =
  FermentationsProceduresProcedureidLinesImport.update({
    id: '/lines',
    path: '/lines',
    getParentRoute: () => FermentationsProceduresProcedureidRouteRoute,
  } as any)

const FermentationsProceduresProcedureidKpisRoute =
  FermentationsProceduresProcedureidKpisImport.update({
    id: '/kpis',
    path: '/kpis',
    getParentRoute: () => FermentationsProceduresProcedureidRouteRoute,
  } as any)

const FermentationsProceduresProcedureidDashboardRoute =
  FermentationsProceduresProcedureidDashboardImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => FermentationsProceduresProcedureidRouteRoute,
  } as any)

const FermentationsProceduresProcedureidAlertsRoute =
  FermentationsProceduresProcedureidAlertsImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => FermentationsProceduresProcedureidRouteRoute,
  } as any)

const FermentationsGroupidSetupSeedFlaskRoute =
  FermentationsGroupidSetupSeedFlaskImport.update({
    id: '/seed-flask',
    path: '/seed-flask',
    getParentRoute: () => FermentationsGroupidSetupRouteRoute,
  } as any)

const FermentationsGroupidSetupPreparationRoute =
  FermentationsGroupidSetupPreparationImport.update({
    id: '/preparation',
    path: '/preparation',
    getParentRoute: () => FermentationsGroupidSetupRouteRoute,
  } as any)

const FermentationsGroupidSetupPreCleaningRoute =
  FermentationsGroupidSetupPreCleaningImport.update({
    id: '/pre-cleaning',
    path: '/pre-cleaning',
    getParentRoute: () => FermentationsGroupidSetupRouteRoute,
  } as any)

const FermentationsGroupidSetupInoculationRoute =
  FermentationsGroupidSetupInoculationImport.update({
    id: '/inoculation',
    path: '/inoculation',
    getParentRoute: () => FermentationsGroupidSetupRouteRoute,
  } as any)

const FermentationsGroupidSetupCalibrationRoute =
  FermentationsGroupidSetupCalibrationImport.update({
    id: '/calibration',
    path: '/calibration',
    getParentRoute: () => FermentationsGroupidSetupRouteRoute,
  } as any)

const FermentationsGroupidResultsTestsRoute =
  FermentationsGroupidResultsTestsImport.update({
    id: '/tests',
    path: '/tests',
    getParentRoute: () => FermentationsGroupidResultsRouteRoute,
  } as any)

const FermentationsGroupidResultsKpisRoute =
  FermentationsGroupidResultsKpisImport.update({
    id: '/kpis',
    path: '/kpis',
    getParentRoute: () => FermentationsGroupidResultsRouteRoute,
  } as any)

const FermentationsGroupidResultsDataRoute =
  FermentationsGroupidResultsDataImport.update({
    id: '/data',
    path: '/data',
    getParentRoute: () => FermentationsGroupidResultsRouteRoute,
  } as any)

const FermentationsGroupidResultsChartsRoute =
  FermentationsGroupidResultsChartsImport.update({
    id: '/charts',
    path: '/charts',
    getParentRoute: () => FermentationsGroupidResultsRouteRoute,
  } as any)

const FermentationsGroupidResultsAnalysisRoute =
  FermentationsGroupidResultsAnalysisImport.update({
    id: '/analysis',
    path: '/analysis',
    getParentRoute: () => FermentationsGroupidResultsRouteRoute,
  } as any)

const FermentationsGroupidPlanningProtocolRoute =
  FermentationsGroupidPlanningProtocolImport.update({
    id: '/protocol',
    path: '/protocol',
    getParentRoute: () => FermentationsGroupidPlanningRouteRoute,
  } as any)

const FermentationsGroupidPlanningGeneralRoute =
  FermentationsGroupidPlanningGeneralImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => FermentationsGroupidPlanningRouteRoute,
  } as any)

const FermentationsGroupidPlanningAlertsRoute =
  FermentationsGroupidPlanningAlertsImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => FermentationsGroupidPlanningRouteRoute,
  } as any)

const FermentationsGroupidAftercareWeightsRoute =
  FermentationsGroupidAftercareWeightsImport.update({
    id: '/weights',
    path: '/weights',
    getParentRoute: () => FermentationsGroupidAftercareRouteRoute,
  } as any)

const FermentationsGroupidAftercareCipRoute =
  FermentationsGroupidAftercareCipImport.update({
    id: '/cip',
    path: '/cip',
    getParentRoute: () => FermentationsGroupidAftercareRouteRoute,
  } as any)

const BrewcontrolWiringsModelIdCalibrationRoute =
  BrewcontrolWiringsModelIdCalibrationImport.update({
    id: '/calibration',
    path: '/calibration',
    getParentRoute: () => BrewcontrolWiringsModelIdRouteRoute,
  } as any)

const AnalyticsTemplatesTemplateidCurvesRoute =
  AnalyticsTemplatesTemplateidCurvesImport.update({
    id: '/curves',
    path: '/curves',
    getParentRoute: () => AnalyticsTemplatesTemplateidRouteRoute,
  } as any)

const AnalyticsTemplatesTemplateidBlueprintRoute =
  AnalyticsTemplatesTemplateidBlueprintImport.update({
    id: '/blueprint',
    path: '/blueprint',
    getParentRoute: () => AnalyticsTemplatesTemplateidRouteRoute,
  } as any)

const AnalyticsTemplatesTemplateidAttributesRoute =
  AnalyticsTemplatesTemplateidAttributesImport.update({
    id: '/attributes',
    path: '/attributes',
    getParentRoute: () => AnalyticsTemplatesTemplateidRouteRoute,
  } as any)

const AnalyticsExternalOrdersSessionidRoute =
  AnalyticsExternalOrdersSessionidImport.update({
    id: '/external/orders/$session_id',
    path: '/external/orders/$session_id',
    getParentRoute: () => AnalyticsRouteRoute,
  } as any)

const AnalyticsExternalImportsImportidRoute =
  AnalyticsExternalImportsImportidImport.update({
    id: '/external/imports/$import_id',
    path: '/external/imports/$import_id',
    getParentRoute: () => AnalyticsRouteRoute,
  } as any)

const InventoryEquipmentEquipmentidCleaningIndexRoute =
  InventoryEquipmentEquipmentidCleaningIndexImport.update({
    id: '/cleaning/',
    path: '/cleaning/',
    getParentRoute: () => InventoryEquipmentEquipmentidRouteRoute,
  } as any)

const SettingsCleaningProceduresProcedureidFormsFormidRoute =
  SettingsCleaningProceduresProcedureidFormsFormidImport.update({
    id: '/forms/$form_id',
    path: '/forms/$form_id',
    getParentRoute: () => SettingsCleaningProceduresProcedureidRouteRoute,
  } as any)

const InventoryEquipmentEquipmentidCleaningNewRoute =
  InventoryEquipmentEquipmentidCleaningNewImport.update({
    id: '/cleaning/new',
    path: '/cleaning/new',
    getParentRoute: () => InventoryEquipmentEquipmentidRouteRoute,
  } as any)

const InventoryEquipmentEquipmentidCleaningRecordidRoute =
  InventoryEquipmentEquipmentidCleaningRecordidImport.update({
    id: '/cleaning/$record_id',
    path: '/cleaning/$record_id',
    getParentRoute: () => InventoryEquipmentEquipmentidRouteRoute,
  } as any)

const FoodAppProjectsProjectidSensorySensorysessionidRoute =
  FoodAppProjectsProjectidSensorySensorysessionidImport.update({
    id: '/sensory/$sensory_session_id',
    path: '/sensory/$sensory_session_id',
    getParentRoute: () => FoodAppProjectsProjectidRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRoute
    }
    '/brewcontrol': {
      id: '/brewcontrol'
      path: '/brewcontrol'
      fullPath: '/brewcontrol'
      preLoaderRoute: typeof BrewcontrolRouteImport
      parentRoute: typeof rootRoute
    }
    '/devices': {
      id: '/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof DevicesRouteImport
      parentRoute: typeof rootRoute
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRoute
    }
    '/food-app': {
      id: '/food-app'
      path: '/food-app'
      fullPath: '/food-app'
      preLoaderRoute: typeof FoodAppImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/brewcontrol/$nodeId': {
      id: '/brewcontrol/$nodeId'
      path: '/$nodeId'
      fullPath: '/brewcontrol/$nodeId'
      preLoaderRoute: typeof BrewcontrolNodeIdRouteImport
      parentRoute: typeof BrewcontrolRouteImport
    }
    '/fermentations/$group_id': {
      id: '/fermentations/$group_id'
      path: '/fermentations/$group_id'
      fullPath: '/fermentations/$group_id'
      preLoaderRoute: typeof FermentationsGroupidRouteImport
      parentRoute: typeof rootRoute
    }
    '/harvests/$session_id': {
      id: '/harvests/$session_id'
      path: '/harvests/$session_id'
      fullPath: '/harvests/$session_id'
      preLoaderRoute: typeof HarvestsSessionidRouteImport
      parentRoute: typeof rootRoute
    }
    '/alert/$token': {
      id: '/alert/$token'
      path: '/alert/$token'
      fullPath: '/alert/$token'
      preLoaderRoute: typeof AlertTokenImport
      parentRoute: typeof rootRoute
    }
    '/analytics/$slug': {
      id: '/analytics/$slug'
      path: '/$slug'
      fullPath: '/analytics/$slug'
      preLoaderRoute: typeof AnalyticsSlugImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/analytics/catalogue': {
      id: '/analytics/catalogue'
      path: '/catalogue'
      fullPath: '/analytics/catalogue'
      preLoaderRoute: typeof AnalyticsCatalogueImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/analytics/labs': {
      id: '/analytics/labs'
      path: '/labs'
      fullPath: '/analytics/labs'
      preLoaderRoute: typeof AnalyticsLabsImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/batches/$batch_id': {
      id: '/batches/$batch_id'
      path: '/batches/$batch_id'
      fullPath: '/batches/$batch_id'
      preLoaderRoute: typeof BatchesBatchidImport
      parentRoute: typeof rootRoute
    }
    '/brewcontrol/enrol': {
      id: '/brewcontrol/enrol'
      path: '/enrol'
      fullPath: '/brewcontrol/enrol'
      preLoaderRoute: typeof BrewcontrolEnrolImport
      parentRoute: typeof BrewcontrolRouteImport
    }
    '/consent/$share_code': {
      id: '/consent/$share_code'
      path: '/consent/$share_code'
      fullPath: '/consent/$share_code'
      preLoaderRoute: typeof ConsentSharecodeImport
      parentRoute: typeof rootRoute
    }
    '/devices/$deviceId': {
      id: '/devices/$deviceId'
      path: '/$deviceId'
      fullPath: '/devices/$deviceId'
      preLoaderRoute: typeof DevicesDeviceIdImport
      parentRoute: typeof DevicesRouteImport
    }
    '/fermentations/board': {
      id: '/fermentations/board'
      path: '/fermentations/board'
      fullPath: '/fermentations/board'
      preLoaderRoute: typeof FermentationsBoardImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/bottles': {
      id: '/fermentations/bottles'
      path: '/fermentations/bottles'
      fullPath: '/fermentations/bottles'
      preLoaderRoute: typeof FermentationsBottlesImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/canvas': {
      id: '/fermentations/canvas'
      path: '/fermentations/canvas'
      fullPath: '/fermentations/canvas'
      preLoaderRoute: typeof FermentationsCanvasImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/methanol-suggestions': {
      id: '/fermentations/methanol-suggestions'
      path: '/fermentations/methanol-suggestions'
      fullPath: '/fermentations/methanol-suggestions'
      preLoaderRoute: typeof FermentationsMethanolSuggestionsImport
      parentRoute: typeof rootRoute
    }
    '/food-app/configuration': {
      id: '/food-app/configuration'
      path: '/configuration'
      fullPath: '/food-app/configuration'
      preLoaderRoute: typeof FoodAppConfigurationImport
      parentRoute: typeof FoodAppImport
    }
    '/food-app/ingredients': {
      id: '/food-app/ingredients'
      path: '/ingredients'
      fullPath: '/food-app/ingredients'
      preLoaderRoute: typeof FoodAppIngredientsImport
      parentRoute: typeof FoodAppImport
    }
    '/food-app/projects': {
      id: '/food-app/projects'
      path: '/projects'
      fullPath: '/food-app/projects'
      preLoaderRoute: typeof FoodAppProjectsImport
      parentRoute: typeof FoodAppImport
    }
    '/food-app/sensory': {
      id: '/food-app/sensory'
      path: '/sensory'
      fullPath: '/food-app/sensory'
      preLoaderRoute: typeof FoodAppSensoryImport
      parentRoute: typeof FoodAppImport
    }
    '/food-app/tasters': {
      id: '/food-app/tasters'
      path: '/tasters'
      fullPath: '/food-app/tasters'
      preLoaderRoute: typeof FoodAppTastersImport
      parentRoute: typeof FoodAppImport
    }
    '/food-app/tastings': {
      id: '/food-app/tastings'
      path: '/tastings'
      fullPath: '/food-app/tastings'
      preLoaderRoute: typeof FoodAppTastingsImport
      parentRoute: typeof FoodAppImport
    }
    '/harvests/broth': {
      id: '/harvests/broth'
      path: '/harvests/broth'
      fullPath: '/harvests/broth'
      preLoaderRoute: typeof HarvestsBrothImport
      parentRoute: typeof rootRoute
    }
    '/inventory/analytics': {
      id: '/inventory/analytics'
      path: '/analytics'
      fullPath: '/inventory/analytics'
      preLoaderRoute: typeof InventoryAnalyticsImport
      parentRoute: typeof InventoryRouteImport
    }
    '/inventory/orders': {
      id: '/inventory/orders'
      path: '/orders'
      fullPath: '/inventory/orders'
      preLoaderRoute: typeof InventoryOrdersImport
      parentRoute: typeof InventoryRouteImport
    }
    '/inventory/organisms': {
      id: '/inventory/organisms'
      path: '/organisms'
      fullPath: '/inventory/organisms'
      preLoaderRoute: typeof InventoryOrganismsImport
      parentRoute: typeof InventoryRouteImport
    }
    '/inventory/products': {
      id: '/inventory/products'
      path: '/products'
      fullPath: '/inventory/products'
      preLoaderRoute: typeof InventoryProductsImport
      parentRoute: typeof InventoryRouteImport
    }
    '/inventory/receiving': {
      id: '/inventory/receiving'
      path: '/receiving'
      fullPath: '/inventory/receiving'
      preLoaderRoute: typeof InventoryReceivingImport
      parentRoute: typeof InventoryRouteImport
    }
    '/inventory/suppliers': {
      id: '/inventory/suppliers'
      path: '/suppliers'
      fullPath: '/inventory/suppliers'
      preLoaderRoute: typeof InventorySuppliersImport
      parentRoute: typeof InventoryRouteImport
    }
    '/sensory/$token': {
      id: '/sensory/$token'
      path: '/sensory/$token'
      fullPath: '/sensory/$token'
      preLoaderRoute: typeof SensoryTokenImport
      parentRoute: typeof rootRoute
    }
    '/settings/devices': {
      id: '/settings/devices'
      path: '/settings/devices'
      fullPath: '/settings/devices'
      preLoaderRoute: typeof SettingsDevicesImport
      parentRoute: typeof rootRoute
    }
    '/settings/fermentation-parameters': {
      id: '/settings/fermentation-parameters'
      path: '/settings/fermentation-parameters'
      fullPath: '/settings/fermentation-parameters'
      preLoaderRoute: typeof SettingsFermentationParametersImport
      parentRoute: typeof rootRoute
    }
    '/settings/operators': {
      id: '/settings/operators'
      path: '/settings/operators'
      fullPath: '/settings/operators'
      preLoaderRoute: typeof SettingsOperatorsImport
      parentRoute: typeof rootRoute
    }
    '/stage/preview-stage': {
      id: '/stage/preview-stage'
      path: '/stage/preview-stage'
      fullPath: '/stage/preview-stage'
      preLoaderRoute: typeof StagePreviewStageImport
      parentRoute: typeof rootRoute
    }
    '/tests/$': {
      id: '/tests/$'
      path: '/tests/$'
      fullPath: '/tests/$'
      preLoaderRoute: typeof TestsSplatImport
      parentRoute: typeof rootRoute
    }
    '/upload/$token': {
      id: '/upload/$token'
      path: '/upload/$token'
      fullPath: '/upload/$token'
      preLoaderRoute: typeof UploadTokenImport
      parentRoute: typeof rootRoute
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AnalyticsIndexImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/batches/': {
      id: '/batches/'
      path: '/batches'
      fullPath: '/batches'
      preLoaderRoute: typeof BatchesIndexImport
      parentRoute: typeof rootRoute
    }
    '/brewcontrol/': {
      id: '/brewcontrol/'
      path: '/'
      fullPath: '/brewcontrol/'
      preLoaderRoute: typeof BrewcontrolIndexImport
      parentRoute: typeof BrewcontrolRouteImport
    }
    '/devices/': {
      id: '/devices/'
      path: '/'
      fullPath: '/devices/'
      preLoaderRoute: typeof DevicesIndexImport
      parentRoute: typeof DevicesRouteImport
    }
    '/fermentations/': {
      id: '/fermentations/'
      path: '/fermentations'
      fullPath: '/fermentations'
      preLoaderRoute: typeof FermentationsIndexImport
      parentRoute: typeof rootRoute
    }
    '/food-app/': {
      id: '/food-app/'
      path: '/'
      fullPath: '/food-app/'
      preLoaderRoute: typeof FoodAppIndexImport
      parentRoute: typeof FoodAppImport
    }
    '/harvests/': {
      id: '/harvests/'
      path: '/harvests'
      fullPath: '/harvests'
      preLoaderRoute: typeof HarvestsIndexImport
      parentRoute: typeof rootRoute
    }
    '/inventory/': {
      id: '/inventory/'
      path: '/'
      fullPath: '/inventory/'
      preLoaderRoute: typeof InventoryIndexImport
      parentRoute: typeof InventoryRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexImport
      parentRoute: typeof rootRoute
    }
    '/analytics/templates/$template_id': {
      id: '/analytics/templates/$template_id'
      path: '/templates/$template_id'
      fullPath: '/analytics/templates/$template_id'
      preLoaderRoute: typeof AnalyticsTemplatesTemplateidRouteImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/brewcontrol/wirings/$modelId': {
      id: '/brewcontrol/wirings/$modelId'
      path: '/wirings/$modelId'
      fullPath: '/brewcontrol/wirings/$modelId'
      preLoaderRoute: typeof BrewcontrolWiringsModelIdRouteImport
      parentRoute: typeof BrewcontrolRouteImport
    }
    '/fermentations/$group_id/aftercare': {
      id: '/fermentations/$group_id/aftercare'
      path: '/aftercare'
      fullPath: '/fermentations/$group_id/aftercare'
      preLoaderRoute: typeof FermentationsGroupidAftercareRouteImport
      parentRoute: typeof FermentationsGroupidRouteImport
    }
    '/fermentations/$group_id/planning': {
      id: '/fermentations/$group_id/planning'
      path: '/planning'
      fullPath: '/fermentations/$group_id/planning'
      preLoaderRoute: typeof FermentationsGroupidPlanningRouteImport
      parentRoute: typeof FermentationsGroupidRouteImport
    }
    '/fermentations/$group_id/results': {
      id: '/fermentations/$group_id/results'
      path: '/results'
      fullPath: '/fermentations/$group_id/results'
      preLoaderRoute: typeof FermentationsGroupidResultsRouteImport
      parentRoute: typeof FermentationsGroupidRouteImport
    }
    '/fermentations/$group_id/setup': {
      id: '/fermentations/$group_id/setup'
      path: '/setup'
      fullPath: '/fermentations/$group_id/setup'
      preLoaderRoute: typeof FermentationsGroupidSetupRouteImport
      parentRoute: typeof FermentationsGroupidRouteImport
    }
    '/fermentations/procedures/$procedure_id': {
      id: '/fermentations/procedures/$procedure_id'
      path: '/fermentations/procedures/$procedure_id'
      fullPath: '/fermentations/procedures/$procedure_id'
      preLoaderRoute: typeof FermentationsProceduresProcedureidRouteImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/protocols/$protocol_id': {
      id: '/fermentations/protocols/$protocol_id'
      path: '/fermentations/protocols/$protocol_id'
      fullPath: '/fermentations/protocols/$protocol_id'
      preLoaderRoute: typeof FermentationsProtocolsProtocolidRouteImport
      parentRoute: typeof rootRoute
    }
    '/food-app/projects/$project_id': {
      id: '/food-app/projects/$project_id'
      path: '/$project_id'
      fullPath: '/food-app/projects/$project_id'
      preLoaderRoute: typeof FoodAppProjectsProjectidRouteImport
      parentRoute: typeof FoodAppProjectsImport
    }
    '/food-app/sessions/$session_id': {
      id: '/food-app/sessions/$session_id'
      path: '/sessions/$session_id'
      fullPath: '/food-app/sessions/$session_id'
      preLoaderRoute: typeof FoodAppSessionsSessionidRouteImport
      parentRoute: typeof FoodAppImport
    }
    '/harvests/operation-templates/$template_id': {
      id: '/harvests/operation-templates/$template_id'
      path: '/harvests/operation-templates/$template_id'
      fullPath: '/harvests/operation-templates/$template_id'
      preLoaderRoute: typeof HarvestsOperationTemplatesTemplateidRouteImport
      parentRoute: typeof rootRoute
    }
    '/harvests/protocols/$protocol_id': {
      id: '/harvests/protocols/$protocol_id'
      path: '/harvests/protocols/$protocol_id'
      fullPath: '/harvests/protocols/$protocol_id'
      preLoaderRoute: typeof HarvestsProtocolsProtocolidRouteImport
      parentRoute: typeof rootRoute
    }
    '/inventory/equipment/$equipment_id': {
      id: '/inventory/equipment/$equipment_id'
      path: '/equipment/$equipment_id'
      fullPath: '/inventory/equipment/$equipment_id'
      preLoaderRoute: typeof InventoryEquipmentEquipmentidRouteImport
      parentRoute: typeof InventoryRouteImport
    }
    '/settings/cleaning-procedures/$procedure_id': {
      id: '/settings/cleaning-procedures/$procedure_id'
      path: '/settings/cleaning-procedures/$procedure_id'
      fullPath: '/settings/cleaning-procedures/$procedure_id'
      preLoaderRoute: typeof SettingsCleaningProceduresProcedureidRouteImport
      parentRoute: typeof rootRoute
    }
    '/analytics/blueprints/$blueprint_id': {
      id: '/analytics/blueprints/$blueprint_id'
      path: '/blueprints/$blueprint_id'
      fullPath: '/analytics/blueprints/$blueprint_id'
      preLoaderRoute: typeof AnalyticsBlueprintsBlueprintidImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/analytics/classic/$slug': {
      id: '/analytics/classic/$slug'
      path: '/classic/$slug'
      fullPath: '/analytics/classic/$slug'
      preLoaderRoute: typeof AnalyticsClassicSlugImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/analytics/methods/$template_id': {
      id: '/analytics/methods/$template_id'
      path: '/methods/$template_id'
      fullPath: '/analytics/methods/$template_id'
      preLoaderRoute: typeof AnalyticsMethodsTemplateidImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/brewcontrol/$nodeId/calibration': {
      id: '/brewcontrol/$nodeId/calibration'
      path: '/calibration'
      fullPath: '/brewcontrol/$nodeId/calibration'
      preLoaderRoute: typeof BrewcontrolNodeIdCalibrationImport
      parentRoute: typeof BrewcontrolNodeIdRouteImport
    }
    '/brewcontrol/$nodeId/config': {
      id: '/brewcontrol/$nodeId/config'
      path: '/config'
      fullPath: '/brewcontrol/$nodeId/config'
      preLoaderRoute: typeof BrewcontrolNodeIdConfigImport
      parentRoute: typeof BrewcontrolNodeIdRouteImport
    }
    '/brewcontrol/$nodeId/devices': {
      id: '/brewcontrol/$nodeId/devices'
      path: '/devices'
      fullPath: '/brewcontrol/$nodeId/devices'
      preLoaderRoute: typeof BrewcontrolNodeIdDevicesImport
      parentRoute: typeof BrewcontrolNodeIdRouteImport
    }
    '/brewcontrol/$nodeId/logs': {
      id: '/brewcontrol/$nodeId/logs'
      path: '/logs'
      fullPath: '/brewcontrol/$nodeId/logs'
      preLoaderRoute: typeof BrewcontrolNodeIdLogsImport
      parentRoute: typeof BrewcontrolNodeIdRouteImport
    }
    '/devices/rigs/$rigId': {
      id: '/devices/rigs/$rigId'
      path: '/rigs/$rigId'
      fullPath: '/devices/rigs/$rigId'
      preLoaderRoute: typeof DevicesRigsRigIdImport
      parentRoute: typeof DevicesRouteImport
    }
    '/fermentations/$group_id/timeline': {
      id: '/fermentations/$group_id/timeline'
      path: '/timeline'
      fullPath: '/fermentations/$group_id/timeline'
      preLoaderRoute: typeof FermentationsGroupidTimelineImport
      parentRoute: typeof FermentationsGroupidRouteImport
    }
    '/fermentations/dashboards/$dashboardId': {
      id: '/fermentations/dashboards/$dashboardId'
      path: '/fermentations/dashboards/$dashboardId'
      fullPath: '/fermentations/dashboards/$dashboardId'
      preLoaderRoute: typeof FermentationsDashboardsDashboardIdImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/investigations/$investigation_id': {
      id: '/fermentations/investigations/$investigation_id'
      path: '/fermentations/investigations/$investigation_id'
      fullPath: '/fermentations/investigations/$investigation_id'
      preLoaderRoute: typeof FermentationsInvestigationsInvestigationidImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/medium-recipes/$recipe_id': {
      id: '/fermentations/medium-recipes/$recipe_id'
      path: '/fermentations/medium-recipes/$recipe_id'
      fullPath: '/fermentations/medium-recipes/$recipe_id'
      preLoaderRoute: typeof FermentationsMediumRecipesRecipeidImport
      parentRoute: typeof rootRoute
    }
    '/food-app/ingredients/$product_id': {
      id: '/food-app/ingredients/$product_id'
      path: '/$product_id'
      fullPath: '/food-app/ingredients/$product_id'
      preLoaderRoute: typeof FoodAppIngredientsProductidImport
      parentRoute: typeof FoodAppIngredientsImport
    }
    '/food-app/sensory/$brew_sensory_session_id': {
      id: '/food-app/sensory/$brew_sensory_session_id'
      path: '/$brew_sensory_session_id'
      fullPath: '/food-app/sensory/$brew_sensory_session_id'
      preLoaderRoute: typeof FoodAppSensoryBrewsensorysessionidImport
      parentRoute: typeof FoodAppSensoryImport
    }
    '/food-app/sensory/templates': {
      id: '/food-app/sensory/templates'
      path: '/templates'
      fullPath: '/food-app/sensory/templates'
      preLoaderRoute: typeof FoodAppSensoryTemplatesImport
      parentRoute: typeof FoodAppSensoryImport
    }
    '/food-app/tasters/$taster_id': {
      id: '/food-app/tasters/$taster_id'
      path: '/$taster_id'
      fullPath: '/food-app/tasters/$taster_id'
      preLoaderRoute: typeof FoodAppTastersTasteridImport
      parentRoute: typeof FoodAppTastersImport
    }
    '/food-app/tastings/$tasting_id': {
      id: '/food-app/tastings/$tasting_id'
      path: '/$tasting_id'
      fullPath: '/food-app/tastings/$tasting_id'
      preLoaderRoute: typeof FoodAppTastingsTastingidImport
      parentRoute: typeof FoodAppTastingsImport
    }
    '/harvests/$session_id/analysis': {
      id: '/harvests/$session_id/analysis'
      path: '/analysis'
      fullPath: '/harvests/$session_id/analysis'
      preLoaderRoute: typeof HarvestsSessionidAnalysisImport
      parentRoute: typeof HarvestsSessionidRouteImport
    }
    '/harvests/$session_id/batches': {
      id: '/harvests/$session_id/batches'
      path: '/batches'
      fullPath: '/harvests/$session_id/batches'
      preLoaderRoute: typeof HarvestsSessionidBatchesImport
      parentRoute: typeof HarvestsSessionidRouteImport
    }
    '/harvests/$session_id/live': {
      id: '/harvests/$session_id/live'
      path: '/live'
      fullPath: '/harvests/$session_id/live'
      preLoaderRoute: typeof HarvestsSessionidLiveImport
      parentRoute: typeof HarvestsSessionidRouteImport
    }
    '/harvests/$session_id/post-cleaning': {
      id: '/harvests/$session_id/post-cleaning'
      path: '/post-cleaning'
      fullPath: '/harvests/$session_id/post-cleaning'
      preLoaderRoute: typeof HarvestsSessionidPostCleaningImport
      parentRoute: typeof HarvestsSessionidRouteImport
    }
    '/harvests/$session_id/pre-cleaning': {
      id: '/harvests/$session_id/pre-cleaning'
      path: '/pre-cleaning'
      fullPath: '/harvests/$session_id/pre-cleaning'
      preLoaderRoute: typeof HarvestsSessionidPreCleaningImport
      parentRoute: typeof HarvestsSessionidRouteImport
    }
    '/harvests/$session_id/samples': {
      id: '/harvests/$session_id/samples'
      path: '/samples'
      fullPath: '/harvests/$session_id/samples'
      preLoaderRoute: typeof HarvestsSessionidSamplesImport
      parentRoute: typeof HarvestsSessionidRouteImport
    }
    '/harvests/batches/$batch_id': {
      id: '/harvests/batches/$batch_id'
      path: '/harvests/batches/$batch_id'
      fullPath: '/harvests/batches/$batch_id'
      preLoaderRoute: typeof HarvestsBatchesBatchidImport
      parentRoute: typeof rootRoute
    }
    '/inventory/orders/new': {
      id: '/inventory/orders/new'
      path: '/new'
      fullPath: '/inventory/orders/new'
      preLoaderRoute: typeof InventoryOrdersNewImport
      parentRoute: typeof InventoryOrdersImport
    }
    '/inventory/prepare/dilution': {
      id: '/inventory/prepare/dilution'
      path: '/prepare/dilution'
      fullPath: '/inventory/prepare/dilution'
      preLoaderRoute: typeof InventoryPrepareDilutionImport
      parentRoute: typeof InventoryRouteImport
    }
    '/inventory/prepare/recipe': {
      id: '/inventory/prepare/recipe'
      path: '/prepare/recipe'
      fullPath: '/inventory/prepare/recipe'
      preLoaderRoute: typeof InventoryPrepareRecipeImport
      parentRoute: typeof InventoryRouteImport
    }
    '/inventory/purchased/new': {
      id: '/inventory/purchased/new'
      path: '/purchased/new'
      fullPath: '/inventory/purchased/new'
      preLoaderRoute: typeof InventoryPurchasedNewImport
      parentRoute: typeof InventoryRouteImport
    }
    '/inventory/recipes/$recipeId': {
      id: '/inventory/recipes/$recipeId'
      path: '/recipes/$recipeId'
      fullPath: '/inventory/recipes/$recipeId'
      preLoaderRoute: typeof InventoryRecipesRecipeIdImport
      parentRoute: typeof InventoryRouteImport
    }
    '/sensory/join/$join_code': {
      id: '/sensory/join/$join_code'
      path: '/sensory/join/$join_code'
      fullPath: '/sensory/join/$join_code'
      preLoaderRoute: typeof SensoryJoinJoincodeImport
      parentRoute: typeof rootRoute
    }
    '/settings/batch-clearance/$clearance_defintion_id': {
      id: '/settings/batch-clearance/$clearance_defintion_id'
      path: '/settings/batch-clearance/$clearance_defintion_id'
      fullPath: '/settings/batch-clearance/$clearance_defintion_id'
      preLoaderRoute: typeof SettingsBatchClearanceClearancedefintionidImport
      parentRoute: typeof rootRoute
    }
    '/settings/formula-templates/$template_id': {
      id: '/settings/formula-templates/$template_id'
      path: '/settings/formula-templates/$template_id'
      fullPath: '/settings/formula-templates/$template_id'
      preLoaderRoute: typeof SettingsFormulaTemplatesTemplateidImport
      parentRoute: typeof rootRoute
    }
    '/settings/inventory/certificate-types': {
      id: '/settings/inventory/certificate-types'
      path: '/settings/inventory/certificate-types'
      fullPath: '/settings/inventory/certificate-types'
      preLoaderRoute: typeof SettingsInventoryCertificateTypesImport
      parentRoute: typeof rootRoute
    }
    '/settings/inventory/equipment-models': {
      id: '/settings/inventory/equipment-models'
      path: '/settings/inventory/equipment-models'
      fullPath: '/settings/inventory/equipment-models'
      preLoaderRoute: typeof SettingsInventoryEquipmentModelsImport
      parentRoute: typeof rootRoute
    }
    '/settings/inventory/equipment-types': {
      id: '/settings/inventory/equipment-types'
      path: '/settings/inventory/equipment-types'
      fullPath: '/settings/inventory/equipment-types'
      preLoaderRoute: typeof SettingsInventoryEquipmentTypesImport
      parentRoute: typeof rootRoute
    }
    '/settings/inventory/locations': {
      id: '/settings/inventory/locations'
      path: '/settings/inventory/locations'
      fullPath: '/settings/inventory/locations'
      preLoaderRoute: typeof SettingsInventoryLocationsImport
      parentRoute: typeof rootRoute
    }
    '/settings/inventory/manufacturers': {
      id: '/settings/inventory/manufacturers'
      path: '/settings/inventory/manufacturers'
      fullPath: '/settings/inventory/manufacturers'
      preLoaderRoute: typeof SettingsInventoryManufacturersImport
      parentRoute: typeof rootRoute
    }
    '/settings/inventory/resources': {
      id: '/settings/inventory/resources'
      path: '/settings/inventory/resources'
      fullPath: '/settings/inventory/resources'
      preLoaderRoute: typeof SettingsInventoryResourcesImport
      parentRoute: typeof rootRoute
    }
    '/settings/inventory/sterilization': {
      id: '/settings/inventory/sterilization'
      path: '/settings/inventory/sterilization'
      fullPath: '/settings/inventory/sterilization'
      preLoaderRoute: typeof SettingsInventorySterilizationImport
      parentRoute: typeof rootRoute
    }
    '/stage/preview/$tasting_id': {
      id: '/stage/preview/$tasting_id'
      path: '/stage/preview/$tasting_id'
      fullPath: '/stage/preview/$tasting_id'
      preLoaderRoute: typeof StagePreviewTastingidImport
      parentRoute: typeof rootRoute
    }
    '/stage/tasting/$tasting_id': {
      id: '/stage/tasting/$tasting_id'
      path: '/stage/tasting/$tasting_id'
      fullPath: '/stage/tasting/$tasting_id'
      preLoaderRoute: typeof StageTastingTastingidImport
      parentRoute: typeof rootRoute
    }
    '/analytics/blueprints/': {
      id: '/analytics/blueprints/'
      path: '/blueprints'
      fullPath: '/analytics/blueprints'
      preLoaderRoute: typeof AnalyticsBlueprintsIndexImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/analytics/classic/': {
      id: '/analytics/classic/'
      path: '/classic'
      fullPath: '/analytics/classic'
      preLoaderRoute: typeof AnalyticsClassicIndexImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/analytics/external/': {
      id: '/analytics/external/'
      path: '/external'
      fullPath: '/analytics/external'
      preLoaderRoute: typeof AnalyticsExternalIndexImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/analytics/templates/': {
      id: '/analytics/templates/'
      path: '/templates'
      fullPath: '/analytics/templates'
      preLoaderRoute: typeof AnalyticsTemplatesIndexImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/brewcontrol/$nodeId/': {
      id: '/brewcontrol/$nodeId/'
      path: '/'
      fullPath: '/brewcontrol/$nodeId/'
      preLoaderRoute: typeof BrewcontrolNodeIdIndexImport
      parentRoute: typeof BrewcontrolNodeIdRouteImport
    }
    '/brewcontrol/wirings/': {
      id: '/brewcontrol/wirings/'
      path: '/wirings'
      fullPath: '/brewcontrol/wirings'
      preLoaderRoute: typeof BrewcontrolWiringsIndexImport
      parentRoute: typeof BrewcontrolRouteImport
    }
    '/fermentations/$group_id/': {
      id: '/fermentations/$group_id/'
      path: '/'
      fullPath: '/fermentations/$group_id/'
      preLoaderRoute: typeof FermentationsGroupidIndexImport
      parentRoute: typeof FermentationsGroupidRouteImport
    }
    '/fermentations/dashboards/': {
      id: '/fermentations/dashboards/'
      path: '/fermentations/dashboards'
      fullPath: '/fermentations/dashboards'
      preLoaderRoute: typeof FermentationsDashboardsIndexImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/investigations/': {
      id: '/fermentations/investigations/'
      path: '/fermentations/investigations'
      fullPath: '/fermentations/investigations'
      preLoaderRoute: typeof FermentationsInvestigationsIndexImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/medium-recipes/': {
      id: '/fermentations/medium-recipes/'
      path: '/fermentations/medium-recipes'
      fullPath: '/fermentations/medium-recipes'
      preLoaderRoute: typeof FermentationsMediumRecipesIndexImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/procedures/': {
      id: '/fermentations/procedures/'
      path: '/fermentations/procedures'
      fullPath: '/fermentations/procedures'
      preLoaderRoute: typeof FermentationsProceduresIndexImport
      parentRoute: typeof rootRoute
    }
    '/fermentations/protocols/': {
      id: '/fermentations/protocols/'
      path: '/fermentations/protocols'
      fullPath: '/fermentations/protocols'
      preLoaderRoute: typeof FermentationsProtocolsIndexImport
      parentRoute: typeof rootRoute
    }
    '/food-app/ingredients/': {
      id: '/food-app/ingredients/'
      path: '/'
      fullPath: '/food-app/ingredients/'
      preLoaderRoute: typeof FoodAppIngredientsIndexImport
      parentRoute: typeof FoodAppIngredientsImport
    }
    '/food-app/projects/': {
      id: '/food-app/projects/'
      path: '/'
      fullPath: '/food-app/projects/'
      preLoaderRoute: typeof FoodAppProjectsIndexImport
      parentRoute: typeof FoodAppProjectsImport
    }
    '/food-app/sensory/': {
      id: '/food-app/sensory/'
      path: '/'
      fullPath: '/food-app/sensory/'
      preLoaderRoute: typeof FoodAppSensoryIndexImport
      parentRoute: typeof FoodAppSensoryImport
    }
    '/food-app/tasters/': {
      id: '/food-app/tasters/'
      path: '/'
      fullPath: '/food-app/tasters/'
      preLoaderRoute: typeof FoodAppTastersIndexImport
      parentRoute: typeof FoodAppTastersImport
    }
    '/food-app/tastings/': {
      id: '/food-app/tastings/'
      path: '/'
      fullPath: '/food-app/tastings/'
      preLoaderRoute: typeof FoodAppTastingsIndexImport
      parentRoute: typeof FoodAppTastingsImport
    }
    '/harvests/$session_id/': {
      id: '/harvests/$session_id/'
      path: '/'
      fullPath: '/harvests/$session_id/'
      preLoaderRoute: typeof HarvestsSessionidIndexImport
      parentRoute: typeof HarvestsSessionidRouteImport
    }
    '/harvests/batches/': {
      id: '/harvests/batches/'
      path: '/harvests/batches'
      fullPath: '/harvests/batches'
      preLoaderRoute: typeof HarvestsBatchesIndexImport
      parentRoute: typeof rootRoute
    }
    '/harvests/operation-templates/': {
      id: '/harvests/operation-templates/'
      path: '/harvests/operation-templates'
      fullPath: '/harvests/operation-templates'
      preLoaderRoute: typeof HarvestsOperationTemplatesIndexImport
      parentRoute: typeof rootRoute
    }
    '/harvests/protocols/': {
      id: '/harvests/protocols/'
      path: '/harvests/protocols'
      fullPath: '/harvests/protocols'
      preLoaderRoute: typeof HarvestsProtocolsIndexImport
      parentRoute: typeof rootRoute
    }
    '/inventory/equipment/': {
      id: '/inventory/equipment/'
      path: '/equipment'
      fullPath: '/inventory/equipment'
      preLoaderRoute: typeof InventoryEquipmentIndexImport
      parentRoute: typeof InventoryRouteImport
    }
    '/inventory/recipes/': {
      id: '/inventory/recipes/'
      path: '/recipes'
      fullPath: '/inventory/recipes'
      preLoaderRoute: typeof InventoryRecipesIndexImport
      parentRoute: typeof InventoryRouteImport
    }
    '/settings/batch-clearance/': {
      id: '/settings/batch-clearance/'
      path: '/settings/batch-clearance'
      fullPath: '/settings/batch-clearance'
      preLoaderRoute: typeof SettingsBatchClearanceIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/cleaning-procedures/': {
      id: '/settings/cleaning-procedures/'
      path: '/settings/cleaning-procedures'
      fullPath: '/settings/cleaning-procedures'
      preLoaderRoute: typeof SettingsCleaningProceduresIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/documents/': {
      id: '/settings/documents/'
      path: '/settings/documents'
      fullPath: '/settings/documents'
      preLoaderRoute: typeof SettingsDocumentsIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/formula-templates/': {
      id: '/settings/formula-templates/'
      path: '/settings/formula-templates'
      fullPath: '/settings/formula-templates'
      preLoaderRoute: typeof SettingsFormulaTemplatesIndexImport
      parentRoute: typeof rootRoute
    }
    '/analytics/external/imports/$import_id': {
      id: '/analytics/external/imports/$import_id'
      path: '/external/imports/$import_id'
      fullPath: '/analytics/external/imports/$import_id'
      preLoaderRoute: typeof AnalyticsExternalImportsImportidImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/analytics/external/orders/$session_id': {
      id: '/analytics/external/orders/$session_id'
      path: '/external/orders/$session_id'
      fullPath: '/analytics/external/orders/$session_id'
      preLoaderRoute: typeof AnalyticsExternalOrdersSessionidImport
      parentRoute: typeof AnalyticsRouteImport
    }
    '/analytics/templates/$template_id/attributes': {
      id: '/analytics/templates/$template_id/attributes'
      path: '/attributes'
      fullPath: '/analytics/templates/$template_id/attributes'
      preLoaderRoute: typeof AnalyticsTemplatesTemplateidAttributesImport
      parentRoute: typeof AnalyticsTemplatesTemplateidRouteImport
    }
    '/analytics/templates/$template_id/blueprint': {
      id: '/analytics/templates/$template_id/blueprint'
      path: '/blueprint'
      fullPath: '/analytics/templates/$template_id/blueprint'
      preLoaderRoute: typeof AnalyticsTemplatesTemplateidBlueprintImport
      parentRoute: typeof AnalyticsTemplatesTemplateidRouteImport
    }
    '/analytics/templates/$template_id/curves': {
      id: '/analytics/templates/$template_id/curves'
      path: '/curves'
      fullPath: '/analytics/templates/$template_id/curves'
      preLoaderRoute: typeof AnalyticsTemplatesTemplateidCurvesImport
      parentRoute: typeof AnalyticsTemplatesTemplateidRouteImport
    }
    '/brewcontrol/wirings/$modelId/calibration': {
      id: '/brewcontrol/wirings/$modelId/calibration'
      path: '/calibration'
      fullPath: '/brewcontrol/wirings/$modelId/calibration'
      preLoaderRoute: typeof BrewcontrolWiringsModelIdCalibrationImport
      parentRoute: typeof BrewcontrolWiringsModelIdRouteImport
    }
    '/fermentations/$group_id/aftercare/cip': {
      id: '/fermentations/$group_id/aftercare/cip'
      path: '/cip'
      fullPath: '/fermentations/$group_id/aftercare/cip'
      preLoaderRoute: typeof FermentationsGroupidAftercareCipImport
      parentRoute: typeof FermentationsGroupidAftercareRouteImport
    }
    '/fermentations/$group_id/aftercare/weights': {
      id: '/fermentations/$group_id/aftercare/weights'
      path: '/weights'
      fullPath: '/fermentations/$group_id/aftercare/weights'
      preLoaderRoute: typeof FermentationsGroupidAftercareWeightsImport
      parentRoute: typeof FermentationsGroupidAftercareRouteImport
    }
    '/fermentations/$group_id/planning/alerts': {
      id: '/fermentations/$group_id/planning/alerts'
      path: '/alerts'
      fullPath: '/fermentations/$group_id/planning/alerts'
      preLoaderRoute: typeof FermentationsGroupidPlanningAlertsImport
      parentRoute: typeof FermentationsGroupidPlanningRouteImport
    }
    '/fermentations/$group_id/planning/general': {
      id: '/fermentations/$group_id/planning/general'
      path: '/general'
      fullPath: '/fermentations/$group_id/planning/general'
      preLoaderRoute: typeof FermentationsGroupidPlanningGeneralImport
      parentRoute: typeof FermentationsGroupidPlanningRouteImport
    }
    '/fermentations/$group_id/planning/protocol': {
      id: '/fermentations/$group_id/planning/protocol'
      path: '/protocol'
      fullPath: '/fermentations/$group_id/planning/protocol'
      preLoaderRoute: typeof FermentationsGroupidPlanningProtocolImport
      parentRoute: typeof FermentationsGroupidPlanningRouteImport
    }
    '/fermentations/$group_id/results/analysis': {
      id: '/fermentations/$group_id/results/analysis'
      path: '/analysis'
      fullPath: '/fermentations/$group_id/results/analysis'
      preLoaderRoute: typeof FermentationsGroupidResultsAnalysisImport
      parentRoute: typeof FermentationsGroupidResultsRouteImport
    }
    '/fermentations/$group_id/results/charts': {
      id: '/fermentations/$group_id/results/charts'
      path: '/charts'
      fullPath: '/fermentations/$group_id/results/charts'
      preLoaderRoute: typeof FermentationsGroupidResultsChartsImport
      parentRoute: typeof FermentationsGroupidResultsRouteImport
    }
    '/fermentations/$group_id/results/data': {
      id: '/fermentations/$group_id/results/data'
      path: '/data'
      fullPath: '/fermentations/$group_id/results/data'
      preLoaderRoute: typeof FermentationsGroupidResultsDataImport
      parentRoute: typeof FermentationsGroupidResultsRouteImport
    }
    '/fermentations/$group_id/results/kpis': {
      id: '/fermentations/$group_id/results/kpis'
      path: '/kpis'
      fullPath: '/fermentations/$group_id/results/kpis'
      preLoaderRoute: typeof FermentationsGroupidResultsKpisImport
      parentRoute: typeof FermentationsGroupidResultsRouteImport
    }
    '/fermentations/$group_id/results/tests': {
      id: '/fermentations/$group_id/results/tests'
      path: '/tests'
      fullPath: '/fermentations/$group_id/results/tests'
      preLoaderRoute: typeof FermentationsGroupidResultsTestsImport
      parentRoute: typeof FermentationsGroupidResultsRouteImport
    }
    '/fermentations/$group_id/setup/calibration': {
      id: '/fermentations/$group_id/setup/calibration'
      path: '/calibration'
      fullPath: '/fermentations/$group_id/setup/calibration'
      preLoaderRoute: typeof FermentationsGroupidSetupCalibrationImport
      parentRoute: typeof FermentationsGroupidSetupRouteImport
    }
    '/fermentations/$group_id/setup/inoculation': {
      id: '/fermentations/$group_id/setup/inoculation'
      path: '/inoculation'
      fullPath: '/fermentations/$group_id/setup/inoculation'
      preLoaderRoute: typeof FermentationsGroupidSetupInoculationImport
      parentRoute: typeof FermentationsGroupidSetupRouteImport
    }
    '/fermentations/$group_id/setup/pre-cleaning': {
      id: '/fermentations/$group_id/setup/pre-cleaning'
      path: '/pre-cleaning'
      fullPath: '/fermentations/$group_id/setup/pre-cleaning'
      preLoaderRoute: typeof FermentationsGroupidSetupPreCleaningImport
      parentRoute: typeof FermentationsGroupidSetupRouteImport
    }
    '/fermentations/$group_id/setup/preparation': {
      id: '/fermentations/$group_id/setup/preparation'
      path: '/preparation'
      fullPath: '/fermentations/$group_id/setup/preparation'
      preLoaderRoute: typeof FermentationsGroupidSetupPreparationImport
      parentRoute: typeof FermentationsGroupidSetupRouteImport
    }
    '/fermentations/$group_id/setup/seed-flask': {
      id: '/fermentations/$group_id/setup/seed-flask'
      path: '/seed-flask'
      fullPath: '/fermentations/$group_id/setup/seed-flask'
      preLoaderRoute: typeof FermentationsGroupidSetupSeedFlaskImport
      parentRoute: typeof FermentationsGroupidSetupRouteImport
    }
    '/fermentations/procedures/$procedure_id/alerts': {
      id: '/fermentations/procedures/$procedure_id/alerts'
      path: '/alerts'
      fullPath: '/fermentations/procedures/$procedure_id/alerts'
      preLoaderRoute: typeof FermentationsProceduresProcedureidAlertsImport
      parentRoute: typeof FermentationsProceduresProcedureidRouteImport
    }
    '/fermentations/procedures/$procedure_id/dashboard': {
      id: '/fermentations/procedures/$procedure_id/dashboard'
      path: '/dashboard'
      fullPath: '/fermentations/procedures/$procedure_id/dashboard'
      preLoaderRoute: typeof FermentationsProceduresProcedureidDashboardImport
      parentRoute: typeof FermentationsProceduresProcedureidRouteImport
    }
    '/fermentations/procedures/$procedure_id/kpis': {
      id: '/fermentations/procedures/$procedure_id/kpis'
      path: '/kpis'
      fullPath: '/fermentations/procedures/$procedure_id/kpis'
      preLoaderRoute: typeof FermentationsProceduresProcedureidKpisImport
      parentRoute: typeof FermentationsProceduresProcedureidRouteImport
    }
    '/fermentations/procedures/$procedure_id/lines': {
      id: '/fermentations/procedures/$procedure_id/lines'
      path: '/lines'
      fullPath: '/fermentations/procedures/$procedure_id/lines'
      preLoaderRoute: typeof FermentationsProceduresProcedureidLinesImport
      parentRoute: typeof FermentationsProceduresProcedureidRouteImport
    }
    '/fermentations/procedures/$procedure_id/overview': {
      id: '/fermentations/procedures/$procedure_id/overview'
      path: '/overview'
      fullPath: '/fermentations/procedures/$procedure_id/overview'
      preLoaderRoute: typeof FermentationsProceduresProcedureidOverviewImport
      parentRoute: typeof FermentationsProceduresProcedureidRouteImport
    }
    '/fermentations/procedures/$procedure_id/protocols': {
      id: '/fermentations/procedures/$procedure_id/protocols'
      path: '/protocols'
      fullPath: '/fermentations/procedures/$procedure_id/protocols'
      preLoaderRoute: typeof FermentationsProceduresProcedureidProtocolsImport
      parentRoute: typeof FermentationsProceduresProcedureidRouteImport
    }
    '/fermentations/procedures/$procedure_id/tasks': {
      id: '/fermentations/procedures/$procedure_id/tasks'
      path: '/tasks'
      fullPath: '/fermentations/procedures/$procedure_id/tasks'
      preLoaderRoute: typeof FermentationsProceduresProcedureidTasksImport
      parentRoute: typeof FermentationsProceduresProcedureidRouteImport
    }
    '/fermentations/protocols/$protocol_id/overview': {
      id: '/fermentations/protocols/$protocol_id/overview'
      path: '/overview'
      fullPath: '/fermentations/protocols/$protocol_id/overview'
      preLoaderRoute: typeof FermentationsProtocolsProtocolidOverviewImport
      parentRoute: typeof FermentationsProtocolsProtocolidRouteImport
    }
    '/fermentations/protocols/$protocol_id/parameters': {
      id: '/fermentations/protocols/$protocol_id/parameters'
      path: '/parameters'
      fullPath: '/fermentations/protocols/$protocol_id/parameters'
      preLoaderRoute: typeof FermentationsProtocolsProtocolidParametersImport
      parentRoute: typeof FermentationsProtocolsProtocolidRouteImport
    }
    '/food-app/sessions/$session_id/analysis': {
      id: '/food-app/sessions/$session_id/analysis'
      path: '/analysis'
      fullPath: '/food-app/sessions/$session_id/analysis'
      preLoaderRoute: typeof FoodAppSessionsSessionidAnalysisImport
      parentRoute: typeof FoodAppSessionsSessionidRouteImport
    }
    '/food-app/sessions/$session_id/general': {
      id: '/food-app/sessions/$session_id/general'
      path: '/general'
      fullPath: '/food-app/sessions/$session_id/general'
      preLoaderRoute: typeof FoodAppSessionsSessionidGeneralImport
      parentRoute: typeof FoodAppSessionsSessionidRouteImport
    }
    '/food-app/sessions/$session_id/results': {
      id: '/food-app/sessions/$session_id/results'
      path: '/results'
      fullPath: '/food-app/sessions/$session_id/results'
      preLoaderRoute: typeof FoodAppSessionsSessionidResultsImport
      parentRoute: typeof FoodAppSessionsSessionidRouteImport
    }
    '/food-app/sessions/$session_id/running': {
      id: '/food-app/sessions/$session_id/running'
      path: '/running'
      fullPath: '/food-app/sessions/$session_id/running'
      preLoaderRoute: typeof FoodAppSessionsSessionidRunningImport
      parentRoute: typeof FoodAppSessionsSessionidRouteImport
    }
    '/food-app/sessions/$session_id/setup': {
      id: '/food-app/sessions/$session_id/setup'
      path: '/setup'
      fullPath: '/food-app/sessions/$session_id/setup'
      preLoaderRoute: typeof FoodAppSessionsSessionidSetupImport
      parentRoute: typeof FoodAppSessionsSessionidRouteImport
    }
    '/harvests/$session_id/stages/$stage_id': {
      id: '/harvests/$session_id/stages/$stage_id'
      path: '/stages/$stage_id'
      fullPath: '/harvests/$session_id/stages/$stage_id'
      preLoaderRoute: typeof HarvestsSessionidStagesStageidImport
      parentRoute: typeof HarvestsSessionidRouteImport
    }
    '/harvests/operation-templates/$template_id/attributes': {
      id: '/harvests/operation-templates/$template_id/attributes'
      path: '/attributes'
      fullPath: '/harvests/operation-templates/$template_id/attributes'
      preLoaderRoute: typeof HarvestsOperationTemplatesTemplateidAttributesImport
      parentRoute: typeof HarvestsOperationTemplatesTemplateidRouteImport
    }
    '/harvests/operation-templates/$template_id/kpis': {
      id: '/harvests/operation-templates/$template_id/kpis'
      path: '/kpis'
      fullPath: '/harvests/operation-templates/$template_id/kpis'
      preLoaderRoute: typeof HarvestsOperationTemplatesTemplateidKpisImport
      parentRoute: typeof HarvestsOperationTemplatesTemplateidRouteImport
    }
    '/harvests/operation-templates/$template_id/samples': {
      id: '/harvests/operation-templates/$template_id/samples'
      path: '/samples'
      fullPath: '/harvests/operation-templates/$template_id/samples'
      preLoaderRoute: typeof HarvestsOperationTemplatesTemplateidSamplesImport
      parentRoute: typeof HarvestsOperationTemplatesTemplateidRouteImport
    }
    '/harvests/protocols/$protocol_id/cleaning': {
      id: '/harvests/protocols/$protocol_id/cleaning'
      path: '/cleaning'
      fullPath: '/harvests/protocols/$protocol_id/cleaning'
      preLoaderRoute: typeof HarvestsProtocolsProtocolidCleaningImport
      parentRoute: typeof HarvestsProtocolsProtocolidRouteImport
    }
    '/harvests/protocols/$protocol_id/kpis': {
      id: '/harvests/protocols/$protocol_id/kpis'
      path: '/kpis'
      fullPath: '/harvests/protocols/$protocol_id/kpis'
      preLoaderRoute: typeof HarvestsProtocolsProtocolidKpisImport
      parentRoute: typeof HarvestsProtocolsProtocolidRouteImport
    }
    '/inventory/equipment/$equipment_id/maintenance': {
      id: '/inventory/equipment/$equipment_id/maintenance'
      path: '/maintenance'
      fullPath: '/inventory/equipment/$equipment_id/maintenance'
      preLoaderRoute: typeof InventoryEquipmentEquipmentidMaintenanceImport
      parentRoute: typeof InventoryEquipmentEquipmentidRouteImport
    }
    '/sensory/join/brew/$sensory_session_id': {
      id: '/sensory/join/brew/$sensory_session_id'
      path: '/sensory/join/brew/$sensory_session_id'
      fullPath: '/sensory/join/brew/$sensory_session_id'
      preLoaderRoute: typeof SensoryJoinBrewSensorysessionidImport
      parentRoute: typeof rootRoute
    }
    '/settings/cleaning-procedures/$procedure_id/fields': {
      id: '/settings/cleaning-procedures/$procedure_id/fields'
      path: '/fields'
      fullPath: '/settings/cleaning-procedures/$procedure_id/fields'
      preLoaderRoute: typeof SettingsCleaningProceduresProcedureidFieldsImport
      parentRoute: typeof SettingsCleaningProceduresProcedureidRouteImport
    }
    '/settings/inventory/suppliers/$id': {
      id: '/settings/inventory/suppliers/$id'
      path: '/settings/inventory/suppliers/$id'
      fullPath: '/settings/inventory/suppliers/$id'
      preLoaderRoute: typeof SettingsInventorySuppliersIdImport
      parentRoute: typeof rootRoute
    }
    '/analytics/templates/$template_id/': {
      id: '/analytics/templates/$template_id/'
      path: '/'
      fullPath: '/analytics/templates/$template_id/'
      preLoaderRoute: typeof AnalyticsTemplatesTemplateidIndexImport
      parentRoute: typeof AnalyticsTemplatesTemplateidRouteImport
    }
    '/brewcontrol/wirings/$modelId/': {
      id: '/brewcontrol/wirings/$modelId/'
      path: '/'
      fullPath: '/brewcontrol/wirings/$modelId/'
      preLoaderRoute: typeof BrewcontrolWiringsModelIdIndexImport
      parentRoute: typeof BrewcontrolWiringsModelIdRouteImport
    }
    '/fermentations/$group_id/aftercare/': {
      id: '/fermentations/$group_id/aftercare/'
      path: '/'
      fullPath: '/fermentations/$group_id/aftercare/'
      preLoaderRoute: typeof FermentationsGroupidAftercareIndexImport
      parentRoute: typeof FermentationsGroupidAftercareRouteImport
    }
    '/fermentations/$group_id/planning/': {
      id: '/fermentations/$group_id/planning/'
      path: '/'
      fullPath: '/fermentations/$group_id/planning/'
      preLoaderRoute: typeof FermentationsGroupidPlanningIndexImport
      parentRoute: typeof FermentationsGroupidPlanningRouteImport
    }
    '/fermentations/$group_id/results/': {
      id: '/fermentations/$group_id/results/'
      path: '/'
      fullPath: '/fermentations/$group_id/results/'
      preLoaderRoute: typeof FermentationsGroupidResultsIndexImport
      parentRoute: typeof FermentationsGroupidResultsRouteImport
    }
    '/fermentations/$group_id/setup/': {
      id: '/fermentations/$group_id/setup/'
      path: '/'
      fullPath: '/fermentations/$group_id/setup/'
      preLoaderRoute: typeof FermentationsGroupidSetupIndexImport
      parentRoute: typeof FermentationsGroupidSetupRouteImport
    }
    '/fermentations/procedures/$procedure_id/': {
      id: '/fermentations/procedures/$procedure_id/'
      path: '/'
      fullPath: '/fermentations/procedures/$procedure_id/'
      preLoaderRoute: typeof FermentationsProceduresProcedureidIndexImport
      parentRoute: typeof FermentationsProceduresProcedureidRouteImport
    }
    '/fermentations/protocols/$protocol_id/': {
      id: '/fermentations/protocols/$protocol_id/'
      path: '/'
      fullPath: '/fermentations/protocols/$protocol_id/'
      preLoaderRoute: typeof FermentationsProtocolsProtocolidIndexImport
      parentRoute: typeof FermentationsProtocolsProtocolidRouteImport
    }
    '/food-app/projects/$project_id/': {
      id: '/food-app/projects/$project_id/'
      path: '/'
      fullPath: '/food-app/projects/$project_id/'
      preLoaderRoute: typeof FoodAppProjectsProjectidIndexImport
      parentRoute: typeof FoodAppProjectsProjectidRouteImport
    }
    '/food-app/sessions/$session_id/': {
      id: '/food-app/sessions/$session_id/'
      path: '/'
      fullPath: '/food-app/sessions/$session_id/'
      preLoaderRoute: typeof FoodAppSessionsSessionidIndexImport
      parentRoute: typeof FoodAppSessionsSessionidRouteImport
    }
    '/harvests/operation-templates/$template_id/': {
      id: '/harvests/operation-templates/$template_id/'
      path: '/'
      fullPath: '/harvests/operation-templates/$template_id/'
      preLoaderRoute: typeof HarvestsOperationTemplatesTemplateidIndexImport
      parentRoute: typeof HarvestsOperationTemplatesTemplateidRouteImport
    }
    '/harvests/protocols/$protocol_id/': {
      id: '/harvests/protocols/$protocol_id/'
      path: '/'
      fullPath: '/harvests/protocols/$protocol_id/'
      preLoaderRoute: typeof HarvestsProtocolsProtocolidIndexImport
      parentRoute: typeof HarvestsProtocolsProtocolidRouteImport
    }
    '/inventory/equipment/$equipment_id/': {
      id: '/inventory/equipment/$equipment_id/'
      path: '/'
      fullPath: '/inventory/equipment/$equipment_id/'
      preLoaderRoute: typeof InventoryEquipmentEquipmentidIndexImport
      parentRoute: typeof InventoryEquipmentEquipmentidRouteImport
    }
    '/settings/cleaning-procedures/$procedure_id/': {
      id: '/settings/cleaning-procedures/$procedure_id/'
      path: '/'
      fullPath: '/settings/cleaning-procedures/$procedure_id/'
      preLoaderRoute: typeof SettingsCleaningProceduresProcedureidIndexImport
      parentRoute: typeof SettingsCleaningProceduresProcedureidRouteImport
    }
    '/food-app/projects/$project_id/sensory/$sensory_session_id': {
      id: '/food-app/projects/$project_id/sensory/$sensory_session_id'
      path: '/sensory/$sensory_session_id'
      fullPath: '/food-app/projects/$project_id/sensory/$sensory_session_id'
      preLoaderRoute: typeof FoodAppProjectsProjectidSensorySensorysessionidImport
      parentRoute: typeof FoodAppProjectsProjectidRouteImport
    }
    '/inventory/equipment/$equipment_id/cleaning/$record_id': {
      id: '/inventory/equipment/$equipment_id/cleaning/$record_id'
      path: '/cleaning/$record_id'
      fullPath: '/inventory/equipment/$equipment_id/cleaning/$record_id'
      preLoaderRoute: typeof InventoryEquipmentEquipmentidCleaningRecordidImport
      parentRoute: typeof InventoryEquipmentEquipmentidRouteImport
    }
    '/inventory/equipment/$equipment_id/cleaning/new': {
      id: '/inventory/equipment/$equipment_id/cleaning/new'
      path: '/cleaning/new'
      fullPath: '/inventory/equipment/$equipment_id/cleaning/new'
      preLoaderRoute: typeof InventoryEquipmentEquipmentidCleaningNewImport
      parentRoute: typeof InventoryEquipmentEquipmentidRouteImport
    }
    '/settings/cleaning-procedures/$procedure_id/forms/$form_id': {
      id: '/settings/cleaning-procedures/$procedure_id/forms/$form_id'
      path: '/forms/$form_id'
      fullPath: '/settings/cleaning-procedures/$procedure_id/forms/$form_id'
      preLoaderRoute: typeof SettingsCleaningProceduresProcedureidFormsFormidImport
      parentRoute: typeof SettingsCleaningProceduresProcedureidRouteImport
    }
    '/inventory/equipment/$equipment_id/cleaning/': {
      id: '/inventory/equipment/$equipment_id/cleaning/'
      path: '/cleaning'
      fullPath: '/inventory/equipment/$equipment_id/cleaning'
      preLoaderRoute: typeof InventoryEquipmentEquipmentidCleaningIndexImport
      parentRoute: typeof InventoryEquipmentEquipmentidRouteImport
    }
  }
}

// Create and export the route tree

interface AnalyticsTemplatesTemplateidRouteRouteChildren {
  AnalyticsTemplatesTemplateidAttributesRoute: typeof AnalyticsTemplatesTemplateidAttributesRoute
  AnalyticsTemplatesTemplateidBlueprintRoute: typeof AnalyticsTemplatesTemplateidBlueprintRoute
  AnalyticsTemplatesTemplateidCurvesRoute: typeof AnalyticsTemplatesTemplateidCurvesRoute
  AnalyticsTemplatesTemplateidIndexRoute: typeof AnalyticsTemplatesTemplateidIndexRoute
}

const AnalyticsTemplatesTemplateidRouteRouteChildren: AnalyticsTemplatesTemplateidRouteRouteChildren =
  {
    AnalyticsTemplatesTemplateidAttributesRoute:
      AnalyticsTemplatesTemplateidAttributesRoute,
    AnalyticsTemplatesTemplateidBlueprintRoute:
      AnalyticsTemplatesTemplateidBlueprintRoute,
    AnalyticsTemplatesTemplateidCurvesRoute:
      AnalyticsTemplatesTemplateidCurvesRoute,
    AnalyticsTemplatesTemplateidIndexRoute:
      AnalyticsTemplatesTemplateidIndexRoute,
  }

const AnalyticsTemplatesTemplateidRouteRouteWithChildren =
  AnalyticsTemplatesTemplateidRouteRoute._addFileChildren(
    AnalyticsTemplatesTemplateidRouteRouteChildren,
  )

interface AnalyticsRouteRouteChildren {
  AnalyticsSlugRoute: typeof AnalyticsSlugRoute
  AnalyticsCatalogueRoute: typeof AnalyticsCatalogueRoute
  AnalyticsLabsRoute: typeof AnalyticsLabsRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  AnalyticsTemplatesTemplateidRouteRoute: typeof AnalyticsTemplatesTemplateidRouteRouteWithChildren
  AnalyticsBlueprintsBlueprintidRoute: typeof AnalyticsBlueprintsBlueprintidRoute
  AnalyticsClassicSlugRoute: typeof AnalyticsClassicSlugRoute
  AnalyticsMethodsTemplateidRoute: typeof AnalyticsMethodsTemplateidRoute
  AnalyticsBlueprintsIndexRoute: typeof AnalyticsBlueprintsIndexRoute
  AnalyticsClassicIndexRoute: typeof AnalyticsClassicIndexRoute
  AnalyticsExternalIndexRoute: typeof AnalyticsExternalIndexRoute
  AnalyticsTemplatesIndexRoute: typeof AnalyticsTemplatesIndexRoute
  AnalyticsExternalImportsImportidRoute: typeof AnalyticsExternalImportsImportidRoute
  AnalyticsExternalOrdersSessionidRoute: typeof AnalyticsExternalOrdersSessionidRoute
}

const AnalyticsRouteRouteChildren: AnalyticsRouteRouteChildren = {
  AnalyticsSlugRoute: AnalyticsSlugRoute,
  AnalyticsCatalogueRoute: AnalyticsCatalogueRoute,
  AnalyticsLabsRoute: AnalyticsLabsRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  AnalyticsTemplatesTemplateidRouteRoute:
    AnalyticsTemplatesTemplateidRouteRouteWithChildren,
  AnalyticsBlueprintsBlueprintidRoute: AnalyticsBlueprintsBlueprintidRoute,
  AnalyticsClassicSlugRoute: AnalyticsClassicSlugRoute,
  AnalyticsMethodsTemplateidRoute: AnalyticsMethodsTemplateidRoute,
  AnalyticsBlueprintsIndexRoute: AnalyticsBlueprintsIndexRoute,
  AnalyticsClassicIndexRoute: AnalyticsClassicIndexRoute,
  AnalyticsExternalIndexRoute: AnalyticsExternalIndexRoute,
  AnalyticsTemplatesIndexRoute: AnalyticsTemplatesIndexRoute,
  AnalyticsExternalImportsImportidRoute: AnalyticsExternalImportsImportidRoute,
  AnalyticsExternalOrdersSessionidRoute: AnalyticsExternalOrdersSessionidRoute,
}

const AnalyticsRouteRouteWithChildren = AnalyticsRouteRoute._addFileChildren(
  AnalyticsRouteRouteChildren,
)

interface BrewcontrolNodeIdRouteRouteChildren {
  BrewcontrolNodeIdCalibrationRoute: typeof BrewcontrolNodeIdCalibrationRoute
  BrewcontrolNodeIdConfigRoute: typeof BrewcontrolNodeIdConfigRoute
  BrewcontrolNodeIdDevicesRoute: typeof BrewcontrolNodeIdDevicesRoute
  BrewcontrolNodeIdLogsRoute: typeof BrewcontrolNodeIdLogsRoute
  BrewcontrolNodeIdIndexRoute: typeof BrewcontrolNodeIdIndexRoute
}

const BrewcontrolNodeIdRouteRouteChildren: BrewcontrolNodeIdRouteRouteChildren =
  {
    BrewcontrolNodeIdCalibrationRoute: BrewcontrolNodeIdCalibrationRoute,
    BrewcontrolNodeIdConfigRoute: BrewcontrolNodeIdConfigRoute,
    BrewcontrolNodeIdDevicesRoute: BrewcontrolNodeIdDevicesRoute,
    BrewcontrolNodeIdLogsRoute: BrewcontrolNodeIdLogsRoute,
    BrewcontrolNodeIdIndexRoute: BrewcontrolNodeIdIndexRoute,
  }

const BrewcontrolNodeIdRouteRouteWithChildren =
  BrewcontrolNodeIdRouteRoute._addFileChildren(
    BrewcontrolNodeIdRouteRouteChildren,
  )

interface BrewcontrolWiringsModelIdRouteRouteChildren {
  BrewcontrolWiringsModelIdCalibrationRoute: typeof BrewcontrolWiringsModelIdCalibrationRoute
  BrewcontrolWiringsModelIdIndexRoute: typeof BrewcontrolWiringsModelIdIndexRoute
}

const BrewcontrolWiringsModelIdRouteRouteChildren: BrewcontrolWiringsModelIdRouteRouteChildren =
  {
    BrewcontrolWiringsModelIdCalibrationRoute:
      BrewcontrolWiringsModelIdCalibrationRoute,
    BrewcontrolWiringsModelIdIndexRoute: BrewcontrolWiringsModelIdIndexRoute,
  }

const BrewcontrolWiringsModelIdRouteRouteWithChildren =
  BrewcontrolWiringsModelIdRouteRoute._addFileChildren(
    BrewcontrolWiringsModelIdRouteRouteChildren,
  )

interface BrewcontrolRouteRouteChildren {
  BrewcontrolNodeIdRouteRoute: typeof BrewcontrolNodeIdRouteRouteWithChildren
  BrewcontrolEnrolRoute: typeof BrewcontrolEnrolRoute
  BrewcontrolIndexRoute: typeof BrewcontrolIndexRoute
  BrewcontrolWiringsModelIdRouteRoute: typeof BrewcontrolWiringsModelIdRouteRouteWithChildren
  BrewcontrolWiringsIndexRoute: typeof BrewcontrolWiringsIndexRoute
}

const BrewcontrolRouteRouteChildren: BrewcontrolRouteRouteChildren = {
  BrewcontrolNodeIdRouteRoute: BrewcontrolNodeIdRouteRouteWithChildren,
  BrewcontrolEnrolRoute: BrewcontrolEnrolRoute,
  BrewcontrolIndexRoute: BrewcontrolIndexRoute,
  BrewcontrolWiringsModelIdRouteRoute:
    BrewcontrolWiringsModelIdRouteRouteWithChildren,
  BrewcontrolWiringsIndexRoute: BrewcontrolWiringsIndexRoute,
}

const BrewcontrolRouteRouteWithChildren =
  BrewcontrolRouteRoute._addFileChildren(BrewcontrolRouteRouteChildren)

interface DevicesRouteRouteChildren {
  DevicesDeviceIdRoute: typeof DevicesDeviceIdRoute
  DevicesIndexRoute: typeof DevicesIndexRoute
  DevicesRigsRigIdRoute: typeof DevicesRigsRigIdRoute
}

const DevicesRouteRouteChildren: DevicesRouteRouteChildren = {
  DevicesDeviceIdRoute: DevicesDeviceIdRoute,
  DevicesIndexRoute: DevicesIndexRoute,
  DevicesRigsRigIdRoute: DevicesRigsRigIdRoute,
}

const DevicesRouteRouteWithChildren = DevicesRouteRoute._addFileChildren(
  DevicesRouteRouteChildren,
)

interface InventoryOrdersRouteChildren {
  InventoryOrdersNewRoute: typeof InventoryOrdersNewRoute
}

const InventoryOrdersRouteChildren: InventoryOrdersRouteChildren = {
  InventoryOrdersNewRoute: InventoryOrdersNewRoute,
}

const InventoryOrdersRouteWithChildren = InventoryOrdersRoute._addFileChildren(
  InventoryOrdersRouteChildren,
)

interface InventoryEquipmentEquipmentidRouteRouteChildren {
  InventoryEquipmentEquipmentidMaintenanceRoute: typeof InventoryEquipmentEquipmentidMaintenanceRoute
  InventoryEquipmentEquipmentidIndexRoute: typeof InventoryEquipmentEquipmentidIndexRoute
  InventoryEquipmentEquipmentidCleaningRecordidRoute: typeof InventoryEquipmentEquipmentidCleaningRecordidRoute
  InventoryEquipmentEquipmentidCleaningNewRoute: typeof InventoryEquipmentEquipmentidCleaningNewRoute
  InventoryEquipmentEquipmentidCleaningIndexRoute: typeof InventoryEquipmentEquipmentidCleaningIndexRoute
}

const InventoryEquipmentEquipmentidRouteRouteChildren: InventoryEquipmentEquipmentidRouteRouteChildren =
  {
    InventoryEquipmentEquipmentidMaintenanceRoute:
      InventoryEquipmentEquipmentidMaintenanceRoute,
    InventoryEquipmentEquipmentidIndexRoute:
      InventoryEquipmentEquipmentidIndexRoute,
    InventoryEquipmentEquipmentidCleaningRecordidRoute:
      InventoryEquipmentEquipmentidCleaningRecordidRoute,
    InventoryEquipmentEquipmentidCleaningNewRoute:
      InventoryEquipmentEquipmentidCleaningNewRoute,
    InventoryEquipmentEquipmentidCleaningIndexRoute:
      InventoryEquipmentEquipmentidCleaningIndexRoute,
  }

const InventoryEquipmentEquipmentidRouteRouteWithChildren =
  InventoryEquipmentEquipmentidRouteRoute._addFileChildren(
    InventoryEquipmentEquipmentidRouteRouteChildren,
  )

interface InventoryRouteRouteChildren {
  InventoryAnalyticsRoute: typeof InventoryAnalyticsRoute
  InventoryOrdersRoute: typeof InventoryOrdersRouteWithChildren
  InventoryOrganismsRoute: typeof InventoryOrganismsRoute
  InventoryProductsRoute: typeof InventoryProductsRoute
  InventoryReceivingRoute: typeof InventoryReceivingRoute
  InventorySuppliersRoute: typeof InventorySuppliersRoute
  InventoryIndexRoute: typeof InventoryIndexRoute
  InventoryEquipmentEquipmentidRouteRoute: typeof InventoryEquipmentEquipmentidRouteRouteWithChildren
  InventoryPrepareDilutionRoute: typeof InventoryPrepareDilutionRoute
  InventoryPrepareRecipeRoute: typeof InventoryPrepareRecipeRoute
  InventoryPurchasedNewRoute: typeof InventoryPurchasedNewRoute
  InventoryRecipesRecipeIdRoute: typeof InventoryRecipesRecipeIdRoute
  InventoryEquipmentIndexRoute: typeof InventoryEquipmentIndexRoute
  InventoryRecipesIndexRoute: typeof InventoryRecipesIndexRoute
}

const InventoryRouteRouteChildren: InventoryRouteRouteChildren = {
  InventoryAnalyticsRoute: InventoryAnalyticsRoute,
  InventoryOrdersRoute: InventoryOrdersRouteWithChildren,
  InventoryOrganismsRoute: InventoryOrganismsRoute,
  InventoryProductsRoute: InventoryProductsRoute,
  InventoryReceivingRoute: InventoryReceivingRoute,
  InventorySuppliersRoute: InventorySuppliersRoute,
  InventoryIndexRoute: InventoryIndexRoute,
  InventoryEquipmentEquipmentidRouteRoute:
    InventoryEquipmentEquipmentidRouteRouteWithChildren,
  InventoryPrepareDilutionRoute: InventoryPrepareDilutionRoute,
  InventoryPrepareRecipeRoute: InventoryPrepareRecipeRoute,
  InventoryPurchasedNewRoute: InventoryPurchasedNewRoute,
  InventoryRecipesRecipeIdRoute: InventoryRecipesRecipeIdRoute,
  InventoryEquipmentIndexRoute: InventoryEquipmentIndexRoute,
  InventoryRecipesIndexRoute: InventoryRecipesIndexRoute,
}

const InventoryRouteRouteWithChildren = InventoryRouteRoute._addFileChildren(
  InventoryRouteRouteChildren,
)

interface FoodAppIngredientsRouteChildren {
  FoodAppIngredientsProductidRoute: typeof FoodAppIngredientsProductidRoute
  FoodAppIngredientsIndexRoute: typeof FoodAppIngredientsIndexRoute
}

const FoodAppIngredientsRouteChildren: FoodAppIngredientsRouteChildren = {
  FoodAppIngredientsProductidRoute: FoodAppIngredientsProductidRoute,
  FoodAppIngredientsIndexRoute: FoodAppIngredientsIndexRoute,
}

const FoodAppIngredientsRouteWithChildren =
  FoodAppIngredientsRoute._addFileChildren(FoodAppIngredientsRouteChildren)

interface FoodAppProjectsProjectidRouteRouteChildren {
  FoodAppProjectsProjectidIndexRoute: typeof FoodAppProjectsProjectidIndexRoute
  FoodAppProjectsProjectidSensorySensorysessionidRoute: typeof FoodAppProjectsProjectidSensorySensorysessionidRoute
}

const FoodAppProjectsProjectidRouteRouteChildren: FoodAppProjectsProjectidRouteRouteChildren =
  {
    FoodAppProjectsProjectidIndexRoute: FoodAppProjectsProjectidIndexRoute,
    FoodAppProjectsProjectidSensorySensorysessionidRoute:
      FoodAppProjectsProjectidSensorySensorysessionidRoute,
  }

const FoodAppProjectsProjectidRouteRouteWithChildren =
  FoodAppProjectsProjectidRouteRoute._addFileChildren(
    FoodAppProjectsProjectidRouteRouteChildren,
  )

interface FoodAppProjectsRouteChildren {
  FoodAppProjectsProjectidRouteRoute: typeof FoodAppProjectsProjectidRouteRouteWithChildren
  FoodAppProjectsIndexRoute: typeof FoodAppProjectsIndexRoute
}

const FoodAppProjectsRouteChildren: FoodAppProjectsRouteChildren = {
  FoodAppProjectsProjectidRouteRoute:
    FoodAppProjectsProjectidRouteRouteWithChildren,
  FoodAppProjectsIndexRoute: FoodAppProjectsIndexRoute,
}

const FoodAppProjectsRouteWithChildren = FoodAppProjectsRoute._addFileChildren(
  FoodAppProjectsRouteChildren,
)

interface FoodAppSensoryRouteChildren {
  FoodAppSensoryBrewsensorysessionidRoute: typeof FoodAppSensoryBrewsensorysessionidRoute
  FoodAppSensoryTemplatesRoute: typeof FoodAppSensoryTemplatesRoute
  FoodAppSensoryIndexRoute: typeof FoodAppSensoryIndexRoute
}

const FoodAppSensoryRouteChildren: FoodAppSensoryRouteChildren = {
  FoodAppSensoryBrewsensorysessionidRoute:
    FoodAppSensoryBrewsensorysessionidRoute,
  FoodAppSensoryTemplatesRoute: FoodAppSensoryTemplatesRoute,
  FoodAppSensoryIndexRoute: FoodAppSensoryIndexRoute,
}

const FoodAppSensoryRouteWithChildren = FoodAppSensoryRoute._addFileChildren(
  FoodAppSensoryRouteChildren,
)

interface FoodAppTastersRouteChildren {
  FoodAppTastersTasteridRoute: typeof FoodAppTastersTasteridRoute
  FoodAppTastersIndexRoute: typeof FoodAppTastersIndexRoute
}

const FoodAppTastersRouteChildren: FoodAppTastersRouteChildren = {
  FoodAppTastersTasteridRoute: FoodAppTastersTasteridRoute,
  FoodAppTastersIndexRoute: FoodAppTastersIndexRoute,
}

const FoodAppTastersRouteWithChildren = FoodAppTastersRoute._addFileChildren(
  FoodAppTastersRouteChildren,
)

interface FoodAppTastingsRouteChildren {
  FoodAppTastingsTastingidRoute: typeof FoodAppTastingsTastingidRoute
  FoodAppTastingsIndexRoute: typeof FoodAppTastingsIndexRoute
}

const FoodAppTastingsRouteChildren: FoodAppTastingsRouteChildren = {
  FoodAppTastingsTastingidRoute: FoodAppTastingsTastingidRoute,
  FoodAppTastingsIndexRoute: FoodAppTastingsIndexRoute,
}

const FoodAppTastingsRouteWithChildren = FoodAppTastingsRoute._addFileChildren(
  FoodAppTastingsRouteChildren,
)

interface FoodAppSessionsSessionidRouteRouteChildren {
  FoodAppSessionsSessionidAnalysisRoute: typeof FoodAppSessionsSessionidAnalysisRoute
  FoodAppSessionsSessionidGeneralRoute: typeof FoodAppSessionsSessionidGeneralRoute
  FoodAppSessionsSessionidResultsRoute: typeof FoodAppSessionsSessionidResultsRoute
  FoodAppSessionsSessionidRunningRoute: typeof FoodAppSessionsSessionidRunningRoute
  FoodAppSessionsSessionidSetupRoute: typeof FoodAppSessionsSessionidSetupRoute
  FoodAppSessionsSessionidIndexRoute: typeof FoodAppSessionsSessionidIndexRoute
}

const FoodAppSessionsSessionidRouteRouteChildren: FoodAppSessionsSessionidRouteRouteChildren =
  {
    FoodAppSessionsSessionidAnalysisRoute:
      FoodAppSessionsSessionidAnalysisRoute,
    FoodAppSessionsSessionidGeneralRoute: FoodAppSessionsSessionidGeneralRoute,
    FoodAppSessionsSessionidResultsRoute: FoodAppSessionsSessionidResultsRoute,
    FoodAppSessionsSessionidRunningRoute: FoodAppSessionsSessionidRunningRoute,
    FoodAppSessionsSessionidSetupRoute: FoodAppSessionsSessionidSetupRoute,
    FoodAppSessionsSessionidIndexRoute: FoodAppSessionsSessionidIndexRoute,
  }

const FoodAppSessionsSessionidRouteRouteWithChildren =
  FoodAppSessionsSessionidRouteRoute._addFileChildren(
    FoodAppSessionsSessionidRouteRouteChildren,
  )

interface FoodAppRouteChildren {
  FoodAppConfigurationRoute: typeof FoodAppConfigurationRoute
  FoodAppIngredientsRoute: typeof FoodAppIngredientsRouteWithChildren
  FoodAppProjectsRoute: typeof FoodAppProjectsRouteWithChildren
  FoodAppSensoryRoute: typeof FoodAppSensoryRouteWithChildren
  FoodAppTastersRoute: typeof FoodAppTastersRouteWithChildren
  FoodAppTastingsRoute: typeof FoodAppTastingsRouteWithChildren
  FoodAppIndexRoute: typeof FoodAppIndexRoute
  FoodAppSessionsSessionidRouteRoute: typeof FoodAppSessionsSessionidRouteRouteWithChildren
}

const FoodAppRouteChildren: FoodAppRouteChildren = {
  FoodAppConfigurationRoute: FoodAppConfigurationRoute,
  FoodAppIngredientsRoute: FoodAppIngredientsRouteWithChildren,
  FoodAppProjectsRoute: FoodAppProjectsRouteWithChildren,
  FoodAppSensoryRoute: FoodAppSensoryRouteWithChildren,
  FoodAppTastersRoute: FoodAppTastersRouteWithChildren,
  FoodAppTastingsRoute: FoodAppTastingsRouteWithChildren,
  FoodAppIndexRoute: FoodAppIndexRoute,
  FoodAppSessionsSessionidRouteRoute:
    FoodAppSessionsSessionidRouteRouteWithChildren,
}

const FoodAppRouteWithChildren =
  FoodAppRoute._addFileChildren(FoodAppRouteChildren)

interface FermentationsGroupidAftercareRouteRouteChildren {
  FermentationsGroupidAftercareCipRoute: typeof FermentationsGroupidAftercareCipRoute
  FermentationsGroupidAftercareWeightsRoute: typeof FermentationsGroupidAftercareWeightsRoute
  FermentationsGroupidAftercareIndexRoute: typeof FermentationsGroupidAftercareIndexRoute
}

const FermentationsGroupidAftercareRouteRouteChildren: FermentationsGroupidAftercareRouteRouteChildren =
  {
    FermentationsGroupidAftercareCipRoute:
      FermentationsGroupidAftercareCipRoute,
    FermentationsGroupidAftercareWeightsRoute:
      FermentationsGroupidAftercareWeightsRoute,
    FermentationsGroupidAftercareIndexRoute:
      FermentationsGroupidAftercareIndexRoute,
  }

const FermentationsGroupidAftercareRouteRouteWithChildren =
  FermentationsGroupidAftercareRouteRoute._addFileChildren(
    FermentationsGroupidAftercareRouteRouteChildren,
  )

interface FermentationsGroupidPlanningRouteRouteChildren {
  FermentationsGroupidPlanningAlertsRoute: typeof FermentationsGroupidPlanningAlertsRoute
  FermentationsGroupidPlanningGeneralRoute: typeof FermentationsGroupidPlanningGeneralRoute
  FermentationsGroupidPlanningProtocolRoute: typeof FermentationsGroupidPlanningProtocolRoute
  FermentationsGroupidPlanningIndexRoute: typeof FermentationsGroupidPlanningIndexRoute
}

const FermentationsGroupidPlanningRouteRouteChildren: FermentationsGroupidPlanningRouteRouteChildren =
  {
    FermentationsGroupidPlanningAlertsRoute:
      FermentationsGroupidPlanningAlertsRoute,
    FermentationsGroupidPlanningGeneralRoute:
      FermentationsGroupidPlanningGeneralRoute,
    FermentationsGroupidPlanningProtocolRoute:
      FermentationsGroupidPlanningProtocolRoute,
    FermentationsGroupidPlanningIndexRoute:
      FermentationsGroupidPlanningIndexRoute,
  }

const FermentationsGroupidPlanningRouteRouteWithChildren =
  FermentationsGroupidPlanningRouteRoute._addFileChildren(
    FermentationsGroupidPlanningRouteRouteChildren,
  )

interface FermentationsGroupidResultsRouteRouteChildren {
  FermentationsGroupidResultsAnalysisRoute: typeof FermentationsGroupidResultsAnalysisRoute
  FermentationsGroupidResultsChartsRoute: typeof FermentationsGroupidResultsChartsRoute
  FermentationsGroupidResultsDataRoute: typeof FermentationsGroupidResultsDataRoute
  FermentationsGroupidResultsKpisRoute: typeof FermentationsGroupidResultsKpisRoute
  FermentationsGroupidResultsTestsRoute: typeof FermentationsGroupidResultsTestsRoute
  FermentationsGroupidResultsIndexRoute: typeof FermentationsGroupidResultsIndexRoute
}

const FermentationsGroupidResultsRouteRouteChildren: FermentationsGroupidResultsRouteRouteChildren =
  {
    FermentationsGroupidResultsAnalysisRoute:
      FermentationsGroupidResultsAnalysisRoute,
    FermentationsGroupidResultsChartsRoute:
      FermentationsGroupidResultsChartsRoute,
    FermentationsGroupidResultsDataRoute: FermentationsGroupidResultsDataRoute,
    FermentationsGroupidResultsKpisRoute: FermentationsGroupidResultsKpisRoute,
    FermentationsGroupidResultsTestsRoute:
      FermentationsGroupidResultsTestsRoute,
    FermentationsGroupidResultsIndexRoute:
      FermentationsGroupidResultsIndexRoute,
  }

const FermentationsGroupidResultsRouteRouteWithChildren =
  FermentationsGroupidResultsRouteRoute._addFileChildren(
    FermentationsGroupidResultsRouteRouteChildren,
  )

interface FermentationsGroupidSetupRouteRouteChildren {
  FermentationsGroupidSetupCalibrationRoute: typeof FermentationsGroupidSetupCalibrationRoute
  FermentationsGroupidSetupInoculationRoute: typeof FermentationsGroupidSetupInoculationRoute
  FermentationsGroupidSetupPreCleaningRoute: typeof FermentationsGroupidSetupPreCleaningRoute
  FermentationsGroupidSetupPreparationRoute: typeof FermentationsGroupidSetupPreparationRoute
  FermentationsGroupidSetupSeedFlaskRoute: typeof FermentationsGroupidSetupSeedFlaskRoute
  FermentationsGroupidSetupIndexRoute: typeof FermentationsGroupidSetupIndexRoute
}

const FermentationsGroupidSetupRouteRouteChildren: FermentationsGroupidSetupRouteRouteChildren =
  {
    FermentationsGroupidSetupCalibrationRoute:
      FermentationsGroupidSetupCalibrationRoute,
    FermentationsGroupidSetupInoculationRoute:
      FermentationsGroupidSetupInoculationRoute,
    FermentationsGroupidSetupPreCleaningRoute:
      FermentationsGroupidSetupPreCleaningRoute,
    FermentationsGroupidSetupPreparationRoute:
      FermentationsGroupidSetupPreparationRoute,
    FermentationsGroupidSetupSeedFlaskRoute:
      FermentationsGroupidSetupSeedFlaskRoute,
    FermentationsGroupidSetupIndexRoute: FermentationsGroupidSetupIndexRoute,
  }

const FermentationsGroupidSetupRouteRouteWithChildren =
  FermentationsGroupidSetupRouteRoute._addFileChildren(
    FermentationsGroupidSetupRouteRouteChildren,
  )

interface FermentationsGroupidRouteRouteChildren {
  FermentationsGroupidAftercareRouteRoute: typeof FermentationsGroupidAftercareRouteRouteWithChildren
  FermentationsGroupidPlanningRouteRoute: typeof FermentationsGroupidPlanningRouteRouteWithChildren
  FermentationsGroupidResultsRouteRoute: typeof FermentationsGroupidResultsRouteRouteWithChildren
  FermentationsGroupidSetupRouteRoute: typeof FermentationsGroupidSetupRouteRouteWithChildren
  FermentationsGroupidTimelineRoute: typeof FermentationsGroupidTimelineRoute
  FermentationsGroupidIndexRoute: typeof FermentationsGroupidIndexRoute
}

const FermentationsGroupidRouteRouteChildren: FermentationsGroupidRouteRouteChildren =
  {
    FermentationsGroupidAftercareRouteRoute:
      FermentationsGroupidAftercareRouteRouteWithChildren,
    FermentationsGroupidPlanningRouteRoute:
      FermentationsGroupidPlanningRouteRouteWithChildren,
    FermentationsGroupidResultsRouteRoute:
      FermentationsGroupidResultsRouteRouteWithChildren,
    FermentationsGroupidSetupRouteRoute:
      FermentationsGroupidSetupRouteRouteWithChildren,
    FermentationsGroupidTimelineRoute: FermentationsGroupidTimelineRoute,
    FermentationsGroupidIndexRoute: FermentationsGroupidIndexRoute,
  }

const FermentationsGroupidRouteRouteWithChildren =
  FermentationsGroupidRouteRoute._addFileChildren(
    FermentationsGroupidRouteRouteChildren,
  )

interface HarvestsSessionidRouteRouteChildren {
  HarvestsSessionidAnalysisRoute: typeof HarvestsSessionidAnalysisRoute
  HarvestsSessionidBatchesRoute: typeof HarvestsSessionidBatchesRoute
  HarvestsSessionidLiveRoute: typeof HarvestsSessionidLiveRoute
  HarvestsSessionidPostCleaningRoute: typeof HarvestsSessionidPostCleaningRoute
  HarvestsSessionidPreCleaningRoute: typeof HarvestsSessionidPreCleaningRoute
  HarvestsSessionidSamplesRoute: typeof HarvestsSessionidSamplesRoute
  HarvestsSessionidIndexRoute: typeof HarvestsSessionidIndexRoute
  HarvestsSessionidStagesStageidRoute: typeof HarvestsSessionidStagesStageidRoute
}

const HarvestsSessionidRouteRouteChildren: HarvestsSessionidRouteRouteChildren =
  {
    HarvestsSessionidAnalysisRoute: HarvestsSessionidAnalysisRoute,
    HarvestsSessionidBatchesRoute: HarvestsSessionidBatchesRoute,
    HarvestsSessionidLiveRoute: HarvestsSessionidLiveRoute,
    HarvestsSessionidPostCleaningRoute: HarvestsSessionidPostCleaningRoute,
    HarvestsSessionidPreCleaningRoute: HarvestsSessionidPreCleaningRoute,
    HarvestsSessionidSamplesRoute: HarvestsSessionidSamplesRoute,
    HarvestsSessionidIndexRoute: HarvestsSessionidIndexRoute,
    HarvestsSessionidStagesStageidRoute: HarvestsSessionidStagesStageidRoute,
  }

const HarvestsSessionidRouteRouteWithChildren =
  HarvestsSessionidRouteRoute._addFileChildren(
    HarvestsSessionidRouteRouteChildren,
  )

interface FermentationsProceduresProcedureidRouteRouteChildren {
  FermentationsProceduresProcedureidAlertsRoute: typeof FermentationsProceduresProcedureidAlertsRoute
  FermentationsProceduresProcedureidDashboardRoute: typeof FermentationsProceduresProcedureidDashboardRoute
  FermentationsProceduresProcedureidKpisRoute: typeof FermentationsProceduresProcedureidKpisRoute
  FermentationsProceduresProcedureidLinesRoute: typeof FermentationsProceduresProcedureidLinesRoute
  FermentationsProceduresProcedureidOverviewRoute: typeof FermentationsProceduresProcedureidOverviewRoute
  FermentationsProceduresProcedureidProtocolsRoute: typeof FermentationsProceduresProcedureidProtocolsRoute
  FermentationsProceduresProcedureidTasksRoute: typeof FermentationsProceduresProcedureidTasksRoute
  FermentationsProceduresProcedureidIndexRoute: typeof FermentationsProceduresProcedureidIndexRoute
}

const FermentationsProceduresProcedureidRouteRouteChildren: FermentationsProceduresProcedureidRouteRouteChildren =
  {
    FermentationsProceduresProcedureidAlertsRoute:
      FermentationsProceduresProcedureidAlertsRoute,
    FermentationsProceduresProcedureidDashboardRoute:
      FermentationsProceduresProcedureidDashboardRoute,
    FermentationsProceduresProcedureidKpisRoute:
      FermentationsProceduresProcedureidKpisRoute,
    FermentationsProceduresProcedureidLinesRoute:
      FermentationsProceduresProcedureidLinesRoute,
    FermentationsProceduresProcedureidOverviewRoute:
      FermentationsProceduresProcedureidOverviewRoute,
    FermentationsProceduresProcedureidProtocolsRoute:
      FermentationsProceduresProcedureidProtocolsRoute,
    FermentationsProceduresProcedureidTasksRoute:
      FermentationsProceduresProcedureidTasksRoute,
    FermentationsProceduresProcedureidIndexRoute:
      FermentationsProceduresProcedureidIndexRoute,
  }

const FermentationsProceduresProcedureidRouteRouteWithChildren =
  FermentationsProceduresProcedureidRouteRoute._addFileChildren(
    FermentationsProceduresProcedureidRouteRouteChildren,
  )

interface FermentationsProtocolsProtocolidRouteRouteChildren {
  FermentationsProtocolsProtocolidOverviewRoute: typeof FermentationsProtocolsProtocolidOverviewRoute
  FermentationsProtocolsProtocolidParametersRoute: typeof FermentationsProtocolsProtocolidParametersRoute
  FermentationsProtocolsProtocolidIndexRoute: typeof FermentationsProtocolsProtocolidIndexRoute
}

const FermentationsProtocolsProtocolidRouteRouteChildren: FermentationsProtocolsProtocolidRouteRouteChildren =
  {
    FermentationsProtocolsProtocolidOverviewRoute:
      FermentationsProtocolsProtocolidOverviewRoute,
    FermentationsProtocolsProtocolidParametersRoute:
      FermentationsProtocolsProtocolidParametersRoute,
    FermentationsProtocolsProtocolidIndexRoute:
      FermentationsProtocolsProtocolidIndexRoute,
  }

const FermentationsProtocolsProtocolidRouteRouteWithChildren =
  FermentationsProtocolsProtocolidRouteRoute._addFileChildren(
    FermentationsProtocolsProtocolidRouteRouteChildren,
  )

interface HarvestsOperationTemplatesTemplateidRouteRouteChildren {
  HarvestsOperationTemplatesTemplateidAttributesRoute: typeof HarvestsOperationTemplatesTemplateidAttributesRoute
  HarvestsOperationTemplatesTemplateidKpisRoute: typeof HarvestsOperationTemplatesTemplateidKpisRoute
  HarvestsOperationTemplatesTemplateidSamplesRoute: typeof HarvestsOperationTemplatesTemplateidSamplesRoute
  HarvestsOperationTemplatesTemplateidIndexRoute: typeof HarvestsOperationTemplatesTemplateidIndexRoute
}

const HarvestsOperationTemplatesTemplateidRouteRouteChildren: HarvestsOperationTemplatesTemplateidRouteRouteChildren =
  {
    HarvestsOperationTemplatesTemplateidAttributesRoute:
      HarvestsOperationTemplatesTemplateidAttributesRoute,
    HarvestsOperationTemplatesTemplateidKpisRoute:
      HarvestsOperationTemplatesTemplateidKpisRoute,
    HarvestsOperationTemplatesTemplateidSamplesRoute:
      HarvestsOperationTemplatesTemplateidSamplesRoute,
    HarvestsOperationTemplatesTemplateidIndexRoute:
      HarvestsOperationTemplatesTemplateidIndexRoute,
  }

const HarvestsOperationTemplatesTemplateidRouteRouteWithChildren =
  HarvestsOperationTemplatesTemplateidRouteRoute._addFileChildren(
    HarvestsOperationTemplatesTemplateidRouteRouteChildren,
  )

interface HarvestsProtocolsProtocolidRouteRouteChildren {
  HarvestsProtocolsProtocolidCleaningRoute: typeof HarvestsProtocolsProtocolidCleaningRoute
  HarvestsProtocolsProtocolidKpisRoute: typeof HarvestsProtocolsProtocolidKpisRoute
  HarvestsProtocolsProtocolidIndexRoute: typeof HarvestsProtocolsProtocolidIndexRoute
}

const HarvestsProtocolsProtocolidRouteRouteChildren: HarvestsProtocolsProtocolidRouteRouteChildren =
  {
    HarvestsProtocolsProtocolidCleaningRoute:
      HarvestsProtocolsProtocolidCleaningRoute,
    HarvestsProtocolsProtocolidKpisRoute: HarvestsProtocolsProtocolidKpisRoute,
    HarvestsProtocolsProtocolidIndexRoute:
      HarvestsProtocolsProtocolidIndexRoute,
  }

const HarvestsProtocolsProtocolidRouteRouteWithChildren =
  HarvestsProtocolsProtocolidRouteRoute._addFileChildren(
    HarvestsProtocolsProtocolidRouteRouteChildren,
  )

interface SettingsCleaningProceduresProcedureidRouteRouteChildren {
  SettingsCleaningProceduresProcedureidFieldsRoute: typeof SettingsCleaningProceduresProcedureidFieldsRoute
  SettingsCleaningProceduresProcedureidIndexRoute: typeof SettingsCleaningProceduresProcedureidIndexRoute
  SettingsCleaningProceduresProcedureidFormsFormidRoute: typeof SettingsCleaningProceduresProcedureidFormsFormidRoute
}

const SettingsCleaningProceduresProcedureidRouteRouteChildren: SettingsCleaningProceduresProcedureidRouteRouteChildren =
  {
    SettingsCleaningProceduresProcedureidFieldsRoute:
      SettingsCleaningProceduresProcedureidFieldsRoute,
    SettingsCleaningProceduresProcedureidIndexRoute:
      SettingsCleaningProceduresProcedureidIndexRoute,
    SettingsCleaningProceduresProcedureidFormsFormidRoute:
      SettingsCleaningProceduresProcedureidFormsFormidRoute,
  }

const SettingsCleaningProceduresProcedureidRouteRouteWithChildren =
  SettingsCleaningProceduresProcedureidRouteRoute._addFileChildren(
    SettingsCleaningProceduresProcedureidRouteRouteChildren,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRouteRouteWithChildren
  '/brewcontrol': typeof BrewcontrolRouteRouteWithChildren
  '/devices': typeof DevicesRouteRouteWithChildren
  '/inventory': typeof InventoryRouteRouteWithChildren
  '/food-app': typeof FoodAppRouteWithChildren
  '/login': typeof LoginRoute
  '/brewcontrol/$nodeId': typeof BrewcontrolNodeIdRouteRouteWithChildren
  '/fermentations/$group_id': typeof FermentationsGroupidRouteRouteWithChildren
  '/harvests/$session_id': typeof HarvestsSessionidRouteRouteWithChildren
  '/alert/$token': typeof AlertTokenRoute
  '/analytics/$slug': typeof AnalyticsSlugRoute
  '/analytics/catalogue': typeof AnalyticsCatalogueRoute
  '/analytics/labs': typeof AnalyticsLabsRoute
  '/batches/$batch_id': typeof BatchesBatchidRoute
  '/brewcontrol/enrol': typeof BrewcontrolEnrolRoute
  '/consent/$share_code': typeof ConsentSharecodeRoute
  '/devices/$deviceId': typeof DevicesDeviceIdRoute
  '/fermentations/board': typeof FermentationsBoardRoute
  '/fermentations/bottles': typeof FermentationsBottlesRoute
  '/fermentations/canvas': typeof FermentationsCanvasRoute
  '/fermentations/methanol-suggestions': typeof FermentationsMethanolSuggestionsRoute
  '/food-app/configuration': typeof FoodAppConfigurationRoute
  '/food-app/ingredients': typeof FoodAppIngredientsRouteWithChildren
  '/food-app/projects': typeof FoodAppProjectsRouteWithChildren
  '/food-app/sensory': typeof FoodAppSensoryRouteWithChildren
  '/food-app/tasters': typeof FoodAppTastersRouteWithChildren
  '/food-app/tastings': typeof FoodAppTastingsRouteWithChildren
  '/harvests/broth': typeof HarvestsBrothRoute
  '/inventory/analytics': typeof InventoryAnalyticsRoute
  '/inventory/orders': typeof InventoryOrdersRouteWithChildren
  '/inventory/organisms': typeof InventoryOrganismsRoute
  '/inventory/products': typeof InventoryProductsRoute
  '/inventory/receiving': typeof InventoryReceivingRoute
  '/inventory/suppliers': typeof InventorySuppliersRoute
  '/sensory/$token': typeof SensoryTokenRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/fermentation-parameters': typeof SettingsFermentationParametersRoute
  '/settings/operators': typeof SettingsOperatorsRoute
  '/stage/preview-stage': typeof StagePreviewStageRoute
  '/tests/$': typeof TestsSplatRoute
  '/upload/$token': typeof UploadTokenRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/batches': typeof BatchesIndexRoute
  '/brewcontrol/': typeof BrewcontrolIndexRoute
  '/devices/': typeof DevicesIndexRoute
  '/fermentations': typeof FermentationsIndexRoute
  '/food-app/': typeof FoodAppIndexRoute
  '/harvests': typeof HarvestsIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/analytics/templates/$template_id': typeof AnalyticsTemplatesTemplateidRouteRouteWithChildren
  '/brewcontrol/wirings/$modelId': typeof BrewcontrolWiringsModelIdRouteRouteWithChildren
  '/fermentations/$group_id/aftercare': typeof FermentationsGroupidAftercareRouteRouteWithChildren
  '/fermentations/$group_id/planning': typeof FermentationsGroupidPlanningRouteRouteWithChildren
  '/fermentations/$group_id/results': typeof FermentationsGroupidResultsRouteRouteWithChildren
  '/fermentations/$group_id/setup': typeof FermentationsGroupidSetupRouteRouteWithChildren
  '/fermentations/procedures/$procedure_id': typeof FermentationsProceduresProcedureidRouteRouteWithChildren
  '/fermentations/protocols/$protocol_id': typeof FermentationsProtocolsProtocolidRouteRouteWithChildren
  '/food-app/projects/$project_id': typeof FoodAppProjectsProjectidRouteRouteWithChildren
  '/food-app/sessions/$session_id': typeof FoodAppSessionsSessionidRouteRouteWithChildren
  '/harvests/operation-templates/$template_id': typeof HarvestsOperationTemplatesTemplateidRouteRouteWithChildren
  '/harvests/protocols/$protocol_id': typeof HarvestsProtocolsProtocolidRouteRouteWithChildren
  '/inventory/equipment/$equipment_id': typeof InventoryEquipmentEquipmentidRouteRouteWithChildren
  '/settings/cleaning-procedures/$procedure_id': typeof SettingsCleaningProceduresProcedureidRouteRouteWithChildren
  '/analytics/blueprints/$blueprint_id': typeof AnalyticsBlueprintsBlueprintidRoute
  '/analytics/classic/$slug': typeof AnalyticsClassicSlugRoute
  '/analytics/methods/$template_id': typeof AnalyticsMethodsTemplateidRoute
  '/brewcontrol/$nodeId/calibration': typeof BrewcontrolNodeIdCalibrationRoute
  '/brewcontrol/$nodeId/config': typeof BrewcontrolNodeIdConfigRoute
  '/brewcontrol/$nodeId/devices': typeof BrewcontrolNodeIdDevicesRoute
  '/brewcontrol/$nodeId/logs': typeof BrewcontrolNodeIdLogsRoute
  '/devices/rigs/$rigId': typeof DevicesRigsRigIdRoute
  '/fermentations/$group_id/timeline': typeof FermentationsGroupidTimelineRoute
  '/fermentations/dashboards/$dashboardId': typeof FermentationsDashboardsDashboardIdRoute
  '/fermentations/investigations/$investigation_id': typeof FermentationsInvestigationsInvestigationidRoute
  '/fermentations/medium-recipes/$recipe_id': typeof FermentationsMediumRecipesRecipeidRoute
  '/food-app/ingredients/$product_id': typeof FoodAppIngredientsProductidRoute
  '/food-app/sensory/$brew_sensory_session_id': typeof FoodAppSensoryBrewsensorysessionidRoute
  '/food-app/sensory/templates': typeof FoodAppSensoryTemplatesRoute
  '/food-app/tasters/$taster_id': typeof FoodAppTastersTasteridRoute
  '/food-app/tastings/$tasting_id': typeof FoodAppTastingsTastingidRoute
  '/harvests/$session_id/analysis': typeof HarvestsSessionidAnalysisRoute
  '/harvests/$session_id/batches': typeof HarvestsSessionidBatchesRoute
  '/harvests/$session_id/live': typeof HarvestsSessionidLiveRoute
  '/harvests/$session_id/post-cleaning': typeof HarvestsSessionidPostCleaningRoute
  '/harvests/$session_id/pre-cleaning': typeof HarvestsSessionidPreCleaningRoute
  '/harvests/$session_id/samples': typeof HarvestsSessionidSamplesRoute
  '/harvests/batches/$batch_id': typeof HarvestsBatchesBatchidRoute
  '/inventory/orders/new': typeof InventoryOrdersNewRoute
  '/inventory/prepare/dilution': typeof InventoryPrepareDilutionRoute
  '/inventory/prepare/recipe': typeof InventoryPrepareRecipeRoute
  '/inventory/purchased/new': typeof InventoryPurchasedNewRoute
  '/inventory/recipes/$recipeId': typeof InventoryRecipesRecipeIdRoute
  '/sensory/join/$join_code': typeof SensoryJoinJoincodeRoute
  '/settings/batch-clearance/$clearance_defintion_id': typeof SettingsBatchClearanceClearancedefintionidRoute
  '/settings/formula-templates/$template_id': typeof SettingsFormulaTemplatesTemplateidRoute
  '/settings/inventory/certificate-types': typeof SettingsInventoryCertificateTypesRoute
  '/settings/inventory/equipment-models': typeof SettingsInventoryEquipmentModelsRoute
  '/settings/inventory/equipment-types': typeof SettingsInventoryEquipmentTypesRoute
  '/settings/inventory/locations': typeof SettingsInventoryLocationsRoute
  '/settings/inventory/manufacturers': typeof SettingsInventoryManufacturersRoute
  '/settings/inventory/resources': typeof SettingsInventoryResourcesRoute
  '/settings/inventory/sterilization': typeof SettingsInventorySterilizationRoute
  '/stage/preview/$tasting_id': typeof StagePreviewTastingidRoute
  '/stage/tasting/$tasting_id': typeof StageTastingTastingidRoute
  '/analytics/blueprints': typeof AnalyticsBlueprintsIndexRoute
  '/analytics/classic': typeof AnalyticsClassicIndexRoute
  '/analytics/external': typeof AnalyticsExternalIndexRoute
  '/analytics/templates': typeof AnalyticsTemplatesIndexRoute
  '/brewcontrol/$nodeId/': typeof BrewcontrolNodeIdIndexRoute
  '/brewcontrol/wirings': typeof BrewcontrolWiringsIndexRoute
  '/fermentations/$group_id/': typeof FermentationsGroupidIndexRoute
  '/fermentations/dashboards': typeof FermentationsDashboardsIndexRoute
  '/fermentations/investigations': typeof FermentationsInvestigationsIndexRoute
  '/fermentations/medium-recipes': typeof FermentationsMediumRecipesIndexRoute
  '/fermentations/procedures': typeof FermentationsProceduresIndexRoute
  '/fermentations/protocols': typeof FermentationsProtocolsIndexRoute
  '/food-app/ingredients/': typeof FoodAppIngredientsIndexRoute
  '/food-app/projects/': typeof FoodAppProjectsIndexRoute
  '/food-app/sensory/': typeof FoodAppSensoryIndexRoute
  '/food-app/tasters/': typeof FoodAppTastersIndexRoute
  '/food-app/tastings/': typeof FoodAppTastingsIndexRoute
  '/harvests/$session_id/': typeof HarvestsSessionidIndexRoute
  '/harvests/batches': typeof HarvestsBatchesIndexRoute
  '/harvests/operation-templates': typeof HarvestsOperationTemplatesIndexRoute
  '/harvests/protocols': typeof HarvestsProtocolsIndexRoute
  '/inventory/equipment': typeof InventoryEquipmentIndexRoute
  '/inventory/recipes': typeof InventoryRecipesIndexRoute
  '/settings/batch-clearance': typeof SettingsBatchClearanceIndexRoute
  '/settings/cleaning-procedures': typeof SettingsCleaningProceduresIndexRoute
  '/settings/documents': typeof SettingsDocumentsIndexRoute
  '/settings/formula-templates': typeof SettingsFormulaTemplatesIndexRoute
  '/analytics/external/imports/$import_id': typeof AnalyticsExternalImportsImportidRoute
  '/analytics/external/orders/$session_id': typeof AnalyticsExternalOrdersSessionidRoute
  '/analytics/templates/$template_id/attributes': typeof AnalyticsTemplatesTemplateidAttributesRoute
  '/analytics/templates/$template_id/blueprint': typeof AnalyticsTemplatesTemplateidBlueprintRoute
  '/analytics/templates/$template_id/curves': typeof AnalyticsTemplatesTemplateidCurvesRoute
  '/brewcontrol/wirings/$modelId/calibration': typeof BrewcontrolWiringsModelIdCalibrationRoute
  '/fermentations/$group_id/aftercare/cip': typeof FermentationsGroupidAftercareCipRoute
  '/fermentations/$group_id/aftercare/weights': typeof FermentationsGroupidAftercareWeightsRoute
  '/fermentations/$group_id/planning/alerts': typeof FermentationsGroupidPlanningAlertsRoute
  '/fermentations/$group_id/planning/general': typeof FermentationsGroupidPlanningGeneralRoute
  '/fermentations/$group_id/planning/protocol': typeof FermentationsGroupidPlanningProtocolRoute
  '/fermentations/$group_id/results/analysis': typeof FermentationsGroupidResultsAnalysisRoute
  '/fermentations/$group_id/results/charts': typeof FermentationsGroupidResultsChartsRoute
  '/fermentations/$group_id/results/data': typeof FermentationsGroupidResultsDataRoute
  '/fermentations/$group_id/results/kpis': typeof FermentationsGroupidResultsKpisRoute
  '/fermentations/$group_id/results/tests': typeof FermentationsGroupidResultsTestsRoute
  '/fermentations/$group_id/setup/calibration': typeof FermentationsGroupidSetupCalibrationRoute
  '/fermentations/$group_id/setup/inoculation': typeof FermentationsGroupidSetupInoculationRoute
  '/fermentations/$group_id/setup/pre-cleaning': typeof FermentationsGroupidSetupPreCleaningRoute
  '/fermentations/$group_id/setup/preparation': typeof FermentationsGroupidSetupPreparationRoute
  '/fermentations/$group_id/setup/seed-flask': typeof FermentationsGroupidSetupSeedFlaskRoute
  '/fermentations/procedures/$procedure_id/alerts': typeof FermentationsProceduresProcedureidAlertsRoute
  '/fermentations/procedures/$procedure_id/dashboard': typeof FermentationsProceduresProcedureidDashboardRoute
  '/fermentations/procedures/$procedure_id/kpis': typeof FermentationsProceduresProcedureidKpisRoute
  '/fermentations/procedures/$procedure_id/lines': typeof FermentationsProceduresProcedureidLinesRoute
  '/fermentations/procedures/$procedure_id/overview': typeof FermentationsProceduresProcedureidOverviewRoute
  '/fermentations/procedures/$procedure_id/protocols': typeof FermentationsProceduresProcedureidProtocolsRoute
  '/fermentations/procedures/$procedure_id/tasks': typeof FermentationsProceduresProcedureidTasksRoute
  '/fermentations/protocols/$protocol_id/overview': typeof FermentationsProtocolsProtocolidOverviewRoute
  '/fermentations/protocols/$protocol_id/parameters': typeof FermentationsProtocolsProtocolidParametersRoute
  '/food-app/sessions/$session_id/analysis': typeof FoodAppSessionsSessionidAnalysisRoute
  '/food-app/sessions/$session_id/general': typeof FoodAppSessionsSessionidGeneralRoute
  '/food-app/sessions/$session_id/results': typeof FoodAppSessionsSessionidResultsRoute
  '/food-app/sessions/$session_id/running': typeof FoodAppSessionsSessionidRunningRoute
  '/food-app/sessions/$session_id/setup': typeof FoodAppSessionsSessionidSetupRoute
  '/harvests/$session_id/stages/$stage_id': typeof HarvestsSessionidStagesStageidRoute
  '/harvests/operation-templates/$template_id/attributes': typeof HarvestsOperationTemplatesTemplateidAttributesRoute
  '/harvests/operation-templates/$template_id/kpis': typeof HarvestsOperationTemplatesTemplateidKpisRoute
  '/harvests/operation-templates/$template_id/samples': typeof HarvestsOperationTemplatesTemplateidSamplesRoute
  '/harvests/protocols/$protocol_id/cleaning': typeof HarvestsProtocolsProtocolidCleaningRoute
  '/harvests/protocols/$protocol_id/kpis': typeof HarvestsProtocolsProtocolidKpisRoute
  '/inventory/equipment/$equipment_id/maintenance': typeof InventoryEquipmentEquipmentidMaintenanceRoute
  '/sensory/join/brew/$sensory_session_id': typeof SensoryJoinBrewSensorysessionidRoute
  '/settings/cleaning-procedures/$procedure_id/fields': typeof SettingsCleaningProceduresProcedureidFieldsRoute
  '/settings/inventory/suppliers/$id': typeof SettingsInventorySuppliersIdRoute
  '/analytics/templates/$template_id/': typeof AnalyticsTemplatesTemplateidIndexRoute
  '/brewcontrol/wirings/$modelId/': typeof BrewcontrolWiringsModelIdIndexRoute
  '/fermentations/$group_id/aftercare/': typeof FermentationsGroupidAftercareIndexRoute
  '/fermentations/$group_id/planning/': typeof FermentationsGroupidPlanningIndexRoute
  '/fermentations/$group_id/results/': typeof FermentationsGroupidResultsIndexRoute
  '/fermentations/$group_id/setup/': typeof FermentationsGroupidSetupIndexRoute
  '/fermentations/procedures/$procedure_id/': typeof FermentationsProceduresProcedureidIndexRoute
  '/fermentations/protocols/$protocol_id/': typeof FermentationsProtocolsProtocolidIndexRoute
  '/food-app/projects/$project_id/': typeof FoodAppProjectsProjectidIndexRoute
  '/food-app/sessions/$session_id/': typeof FoodAppSessionsSessionidIndexRoute
  '/harvests/operation-templates/$template_id/': typeof HarvestsOperationTemplatesTemplateidIndexRoute
  '/harvests/protocols/$protocol_id/': typeof HarvestsProtocolsProtocolidIndexRoute
  '/inventory/equipment/$equipment_id/': typeof InventoryEquipmentEquipmentidIndexRoute
  '/settings/cleaning-procedures/$procedure_id/': typeof SettingsCleaningProceduresProcedureidIndexRoute
  '/food-app/projects/$project_id/sensory/$sensory_session_id': typeof FoodAppProjectsProjectidSensorySensorysessionidRoute
  '/inventory/equipment/$equipment_id/cleaning/$record_id': typeof InventoryEquipmentEquipmentidCleaningRecordidRoute
  '/inventory/equipment/$equipment_id/cleaning/new': typeof InventoryEquipmentEquipmentidCleaningNewRoute
  '/settings/cleaning-procedures/$procedure_id/forms/$form_id': typeof SettingsCleaningProceduresProcedureidFormsFormidRoute
  '/inventory/equipment/$equipment_id/cleaning': typeof InventoryEquipmentEquipmentidCleaningIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/alert/$token': typeof AlertTokenRoute
  '/analytics/$slug': typeof AnalyticsSlugRoute
  '/analytics/catalogue': typeof AnalyticsCatalogueRoute
  '/analytics/labs': typeof AnalyticsLabsRoute
  '/batches/$batch_id': typeof BatchesBatchidRoute
  '/brewcontrol/enrol': typeof BrewcontrolEnrolRoute
  '/consent/$share_code': typeof ConsentSharecodeRoute
  '/devices/$deviceId': typeof DevicesDeviceIdRoute
  '/fermentations/board': typeof FermentationsBoardRoute
  '/fermentations/bottles': typeof FermentationsBottlesRoute
  '/fermentations/canvas': typeof FermentationsCanvasRoute
  '/fermentations/methanol-suggestions': typeof FermentationsMethanolSuggestionsRoute
  '/food-app/configuration': typeof FoodAppConfigurationRoute
  '/harvests/broth': typeof HarvestsBrothRoute
  '/inventory/analytics': typeof InventoryAnalyticsRoute
  '/inventory/orders': typeof InventoryOrdersRouteWithChildren
  '/inventory/organisms': typeof InventoryOrganismsRoute
  '/inventory/products': typeof InventoryProductsRoute
  '/inventory/receiving': typeof InventoryReceivingRoute
  '/inventory/suppliers': typeof InventorySuppliersRoute
  '/sensory/$token': typeof SensoryTokenRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/fermentation-parameters': typeof SettingsFermentationParametersRoute
  '/settings/operators': typeof SettingsOperatorsRoute
  '/stage/preview-stage': typeof StagePreviewStageRoute
  '/tests/$': typeof TestsSplatRoute
  '/upload/$token': typeof UploadTokenRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/batches': typeof BatchesIndexRoute
  '/brewcontrol': typeof BrewcontrolIndexRoute
  '/devices': typeof DevicesIndexRoute
  '/fermentations': typeof FermentationsIndexRoute
  '/food-app': typeof FoodAppIndexRoute
  '/harvests': typeof HarvestsIndexRoute
  '/inventory': typeof InventoryIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/analytics/blueprints/$blueprint_id': typeof AnalyticsBlueprintsBlueprintidRoute
  '/analytics/classic/$slug': typeof AnalyticsClassicSlugRoute
  '/analytics/methods/$template_id': typeof AnalyticsMethodsTemplateidRoute
  '/brewcontrol/$nodeId/calibration': typeof BrewcontrolNodeIdCalibrationRoute
  '/brewcontrol/$nodeId/config': typeof BrewcontrolNodeIdConfigRoute
  '/brewcontrol/$nodeId/devices': typeof BrewcontrolNodeIdDevicesRoute
  '/brewcontrol/$nodeId/logs': typeof BrewcontrolNodeIdLogsRoute
  '/devices/rigs/$rigId': typeof DevicesRigsRigIdRoute
  '/fermentations/$group_id/timeline': typeof FermentationsGroupidTimelineRoute
  '/fermentations/dashboards/$dashboardId': typeof FermentationsDashboardsDashboardIdRoute
  '/fermentations/investigations/$investigation_id': typeof FermentationsInvestigationsInvestigationidRoute
  '/fermentations/medium-recipes/$recipe_id': typeof FermentationsMediumRecipesRecipeidRoute
  '/food-app/ingredients/$product_id': typeof FoodAppIngredientsProductidRoute
  '/food-app/sensory/$brew_sensory_session_id': typeof FoodAppSensoryBrewsensorysessionidRoute
  '/food-app/sensory/templates': typeof FoodAppSensoryTemplatesRoute
  '/food-app/tasters/$taster_id': typeof FoodAppTastersTasteridRoute
  '/food-app/tastings/$tasting_id': typeof FoodAppTastingsTastingidRoute
  '/harvests/$session_id/analysis': typeof HarvestsSessionidAnalysisRoute
  '/harvests/$session_id/batches': typeof HarvestsSessionidBatchesRoute
  '/harvests/$session_id/live': typeof HarvestsSessionidLiveRoute
  '/harvests/$session_id/post-cleaning': typeof HarvestsSessionidPostCleaningRoute
  '/harvests/$session_id/pre-cleaning': typeof HarvestsSessionidPreCleaningRoute
  '/harvests/$session_id/samples': typeof HarvestsSessionidSamplesRoute
  '/harvests/batches/$batch_id': typeof HarvestsBatchesBatchidRoute
  '/inventory/orders/new': typeof InventoryOrdersNewRoute
  '/inventory/prepare/dilution': typeof InventoryPrepareDilutionRoute
  '/inventory/prepare/recipe': typeof InventoryPrepareRecipeRoute
  '/inventory/purchased/new': typeof InventoryPurchasedNewRoute
  '/inventory/recipes/$recipeId': typeof InventoryRecipesRecipeIdRoute
  '/sensory/join/$join_code': typeof SensoryJoinJoincodeRoute
  '/settings/batch-clearance/$clearance_defintion_id': typeof SettingsBatchClearanceClearancedefintionidRoute
  '/settings/formula-templates/$template_id': typeof SettingsFormulaTemplatesTemplateidRoute
  '/settings/inventory/certificate-types': typeof SettingsInventoryCertificateTypesRoute
  '/settings/inventory/equipment-models': typeof SettingsInventoryEquipmentModelsRoute
  '/settings/inventory/equipment-types': typeof SettingsInventoryEquipmentTypesRoute
  '/settings/inventory/locations': typeof SettingsInventoryLocationsRoute
  '/settings/inventory/manufacturers': typeof SettingsInventoryManufacturersRoute
  '/settings/inventory/resources': typeof SettingsInventoryResourcesRoute
  '/settings/inventory/sterilization': typeof SettingsInventorySterilizationRoute
  '/stage/preview/$tasting_id': typeof StagePreviewTastingidRoute
  '/stage/tasting/$tasting_id': typeof StageTastingTastingidRoute
  '/analytics/blueprints': typeof AnalyticsBlueprintsIndexRoute
  '/analytics/classic': typeof AnalyticsClassicIndexRoute
  '/analytics/external': typeof AnalyticsExternalIndexRoute
  '/analytics/templates': typeof AnalyticsTemplatesIndexRoute
  '/brewcontrol/$nodeId': typeof BrewcontrolNodeIdIndexRoute
  '/brewcontrol/wirings': typeof BrewcontrolWiringsIndexRoute
  '/fermentations/$group_id': typeof FermentationsGroupidIndexRoute
  '/fermentations/dashboards': typeof FermentationsDashboardsIndexRoute
  '/fermentations/investigations': typeof FermentationsInvestigationsIndexRoute
  '/fermentations/medium-recipes': typeof FermentationsMediumRecipesIndexRoute
  '/fermentations/procedures': typeof FermentationsProceduresIndexRoute
  '/fermentations/protocols': typeof FermentationsProtocolsIndexRoute
  '/food-app/ingredients': typeof FoodAppIngredientsIndexRoute
  '/food-app/projects': typeof FoodAppProjectsIndexRoute
  '/food-app/sensory': typeof FoodAppSensoryIndexRoute
  '/food-app/tasters': typeof FoodAppTastersIndexRoute
  '/food-app/tastings': typeof FoodAppTastingsIndexRoute
  '/harvests/$session_id': typeof HarvestsSessionidIndexRoute
  '/harvests/batches': typeof HarvestsBatchesIndexRoute
  '/harvests/operation-templates': typeof HarvestsOperationTemplatesIndexRoute
  '/harvests/protocols': typeof HarvestsProtocolsIndexRoute
  '/inventory/equipment': typeof InventoryEquipmentIndexRoute
  '/inventory/recipes': typeof InventoryRecipesIndexRoute
  '/settings/batch-clearance': typeof SettingsBatchClearanceIndexRoute
  '/settings/cleaning-procedures': typeof SettingsCleaningProceduresIndexRoute
  '/settings/documents': typeof SettingsDocumentsIndexRoute
  '/settings/formula-templates': typeof SettingsFormulaTemplatesIndexRoute
  '/analytics/external/imports/$import_id': typeof AnalyticsExternalImportsImportidRoute
  '/analytics/external/orders/$session_id': typeof AnalyticsExternalOrdersSessionidRoute
  '/analytics/templates/$template_id/attributes': typeof AnalyticsTemplatesTemplateidAttributesRoute
  '/analytics/templates/$template_id/blueprint': typeof AnalyticsTemplatesTemplateidBlueprintRoute
  '/analytics/templates/$template_id/curves': typeof AnalyticsTemplatesTemplateidCurvesRoute
  '/brewcontrol/wirings/$modelId/calibration': typeof BrewcontrolWiringsModelIdCalibrationRoute
  '/fermentations/$group_id/aftercare/cip': typeof FermentationsGroupidAftercareCipRoute
  '/fermentations/$group_id/aftercare/weights': typeof FermentationsGroupidAftercareWeightsRoute
  '/fermentations/$group_id/planning/alerts': typeof FermentationsGroupidPlanningAlertsRoute
  '/fermentations/$group_id/planning/general': typeof FermentationsGroupidPlanningGeneralRoute
  '/fermentations/$group_id/planning/protocol': typeof FermentationsGroupidPlanningProtocolRoute
  '/fermentations/$group_id/results/analysis': typeof FermentationsGroupidResultsAnalysisRoute
  '/fermentations/$group_id/results/charts': typeof FermentationsGroupidResultsChartsRoute
  '/fermentations/$group_id/results/data': typeof FermentationsGroupidResultsDataRoute
  '/fermentations/$group_id/results/kpis': typeof FermentationsGroupidResultsKpisRoute
  '/fermentations/$group_id/results/tests': typeof FermentationsGroupidResultsTestsRoute
  '/fermentations/$group_id/setup/calibration': typeof FermentationsGroupidSetupCalibrationRoute
  '/fermentations/$group_id/setup/inoculation': typeof FermentationsGroupidSetupInoculationRoute
  '/fermentations/$group_id/setup/pre-cleaning': typeof FermentationsGroupidSetupPreCleaningRoute
  '/fermentations/$group_id/setup/preparation': typeof FermentationsGroupidSetupPreparationRoute
  '/fermentations/$group_id/setup/seed-flask': typeof FermentationsGroupidSetupSeedFlaskRoute
  '/fermentations/procedures/$procedure_id/alerts': typeof FermentationsProceduresProcedureidAlertsRoute
  '/fermentations/procedures/$procedure_id/dashboard': typeof FermentationsProceduresProcedureidDashboardRoute
  '/fermentations/procedures/$procedure_id/kpis': typeof FermentationsProceduresProcedureidKpisRoute
  '/fermentations/procedures/$procedure_id/lines': typeof FermentationsProceduresProcedureidLinesRoute
  '/fermentations/procedures/$procedure_id/overview': typeof FermentationsProceduresProcedureidOverviewRoute
  '/fermentations/procedures/$procedure_id/protocols': typeof FermentationsProceduresProcedureidProtocolsRoute
  '/fermentations/procedures/$procedure_id/tasks': typeof FermentationsProceduresProcedureidTasksRoute
  '/fermentations/protocols/$protocol_id/overview': typeof FermentationsProtocolsProtocolidOverviewRoute
  '/fermentations/protocols/$protocol_id/parameters': typeof FermentationsProtocolsProtocolidParametersRoute
  '/food-app/sessions/$session_id/analysis': typeof FoodAppSessionsSessionidAnalysisRoute
  '/food-app/sessions/$session_id/general': typeof FoodAppSessionsSessionidGeneralRoute
  '/food-app/sessions/$session_id/results': typeof FoodAppSessionsSessionidResultsRoute
  '/food-app/sessions/$session_id/running': typeof FoodAppSessionsSessionidRunningRoute
  '/food-app/sessions/$session_id/setup': typeof FoodAppSessionsSessionidSetupRoute
  '/harvests/$session_id/stages/$stage_id': typeof HarvestsSessionidStagesStageidRoute
  '/harvests/operation-templates/$template_id/attributes': typeof HarvestsOperationTemplatesTemplateidAttributesRoute
  '/harvests/operation-templates/$template_id/kpis': typeof HarvestsOperationTemplatesTemplateidKpisRoute
  '/harvests/operation-templates/$template_id/samples': typeof HarvestsOperationTemplatesTemplateidSamplesRoute
  '/harvests/protocols/$protocol_id/cleaning': typeof HarvestsProtocolsProtocolidCleaningRoute
  '/harvests/protocols/$protocol_id/kpis': typeof HarvestsProtocolsProtocolidKpisRoute
  '/inventory/equipment/$equipment_id/maintenance': typeof InventoryEquipmentEquipmentidMaintenanceRoute
  '/sensory/join/brew/$sensory_session_id': typeof SensoryJoinBrewSensorysessionidRoute
  '/settings/cleaning-procedures/$procedure_id/fields': typeof SettingsCleaningProceduresProcedureidFieldsRoute
  '/settings/inventory/suppliers/$id': typeof SettingsInventorySuppliersIdRoute
  '/analytics/templates/$template_id': typeof AnalyticsTemplatesTemplateidIndexRoute
  '/brewcontrol/wirings/$modelId': typeof BrewcontrolWiringsModelIdIndexRoute
  '/fermentations/$group_id/aftercare': typeof FermentationsGroupidAftercareIndexRoute
  '/fermentations/$group_id/planning': typeof FermentationsGroupidPlanningIndexRoute
  '/fermentations/$group_id/results': typeof FermentationsGroupidResultsIndexRoute
  '/fermentations/$group_id/setup': typeof FermentationsGroupidSetupIndexRoute
  '/fermentations/procedures/$procedure_id': typeof FermentationsProceduresProcedureidIndexRoute
  '/fermentations/protocols/$protocol_id': typeof FermentationsProtocolsProtocolidIndexRoute
  '/food-app/projects/$project_id': typeof FoodAppProjectsProjectidIndexRoute
  '/food-app/sessions/$session_id': typeof FoodAppSessionsSessionidIndexRoute
  '/harvests/operation-templates/$template_id': typeof HarvestsOperationTemplatesTemplateidIndexRoute
  '/harvests/protocols/$protocol_id': typeof HarvestsProtocolsProtocolidIndexRoute
  '/inventory/equipment/$equipment_id': typeof InventoryEquipmentEquipmentidIndexRoute
  '/settings/cleaning-procedures/$procedure_id': typeof SettingsCleaningProceduresProcedureidIndexRoute
  '/food-app/projects/$project_id/sensory/$sensory_session_id': typeof FoodAppProjectsProjectidSensorySensorysessionidRoute
  '/inventory/equipment/$equipment_id/cleaning/$record_id': typeof InventoryEquipmentEquipmentidCleaningRecordidRoute
  '/inventory/equipment/$equipment_id/cleaning/new': typeof InventoryEquipmentEquipmentidCleaningNewRoute
  '/settings/cleaning-procedures/$procedure_id/forms/$form_id': typeof SettingsCleaningProceduresProcedureidFormsFormidRoute
  '/inventory/equipment/$equipment_id/cleaning': typeof InventoryEquipmentEquipmentidCleaningIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRouteRouteWithChildren
  '/brewcontrol': typeof BrewcontrolRouteRouteWithChildren
  '/devices': typeof DevicesRouteRouteWithChildren
  '/inventory': typeof InventoryRouteRouteWithChildren
  '/food-app': typeof FoodAppRouteWithChildren
  '/login': typeof LoginRoute
  '/brewcontrol/$nodeId': typeof BrewcontrolNodeIdRouteRouteWithChildren
  '/fermentations/$group_id': typeof FermentationsGroupidRouteRouteWithChildren
  '/harvests/$session_id': typeof HarvestsSessionidRouteRouteWithChildren
  '/alert/$token': typeof AlertTokenRoute
  '/analytics/$slug': typeof AnalyticsSlugRoute
  '/analytics/catalogue': typeof AnalyticsCatalogueRoute
  '/analytics/labs': typeof AnalyticsLabsRoute
  '/batches/$batch_id': typeof BatchesBatchidRoute
  '/brewcontrol/enrol': typeof BrewcontrolEnrolRoute
  '/consent/$share_code': typeof ConsentSharecodeRoute
  '/devices/$deviceId': typeof DevicesDeviceIdRoute
  '/fermentations/board': typeof FermentationsBoardRoute
  '/fermentations/bottles': typeof FermentationsBottlesRoute
  '/fermentations/canvas': typeof FermentationsCanvasRoute
  '/fermentations/methanol-suggestions': typeof FermentationsMethanolSuggestionsRoute
  '/food-app/configuration': typeof FoodAppConfigurationRoute
  '/food-app/ingredients': typeof FoodAppIngredientsRouteWithChildren
  '/food-app/projects': typeof FoodAppProjectsRouteWithChildren
  '/food-app/sensory': typeof FoodAppSensoryRouteWithChildren
  '/food-app/tasters': typeof FoodAppTastersRouteWithChildren
  '/food-app/tastings': typeof FoodAppTastingsRouteWithChildren
  '/harvests/broth': typeof HarvestsBrothRoute
  '/inventory/analytics': typeof InventoryAnalyticsRoute
  '/inventory/orders': typeof InventoryOrdersRouteWithChildren
  '/inventory/organisms': typeof InventoryOrganismsRoute
  '/inventory/products': typeof InventoryProductsRoute
  '/inventory/receiving': typeof InventoryReceivingRoute
  '/inventory/suppliers': typeof InventorySuppliersRoute
  '/sensory/$token': typeof SensoryTokenRoute
  '/settings/devices': typeof SettingsDevicesRoute
  '/settings/fermentation-parameters': typeof SettingsFermentationParametersRoute
  '/settings/operators': typeof SettingsOperatorsRoute
  '/stage/preview-stage': typeof StagePreviewStageRoute
  '/tests/$': typeof TestsSplatRoute
  '/upload/$token': typeof UploadTokenRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/batches/': typeof BatchesIndexRoute
  '/brewcontrol/': typeof BrewcontrolIndexRoute
  '/devices/': typeof DevicesIndexRoute
  '/fermentations/': typeof FermentationsIndexRoute
  '/food-app/': typeof FoodAppIndexRoute
  '/harvests/': typeof HarvestsIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/analytics/templates/$template_id': typeof AnalyticsTemplatesTemplateidRouteRouteWithChildren
  '/brewcontrol/wirings/$modelId': typeof BrewcontrolWiringsModelIdRouteRouteWithChildren
  '/fermentations/$group_id/aftercare': typeof FermentationsGroupidAftercareRouteRouteWithChildren
  '/fermentations/$group_id/planning': typeof FermentationsGroupidPlanningRouteRouteWithChildren
  '/fermentations/$group_id/results': typeof FermentationsGroupidResultsRouteRouteWithChildren
  '/fermentations/$group_id/setup': typeof FermentationsGroupidSetupRouteRouteWithChildren
  '/fermentations/procedures/$procedure_id': typeof FermentationsProceduresProcedureidRouteRouteWithChildren
  '/fermentations/protocols/$protocol_id': typeof FermentationsProtocolsProtocolidRouteRouteWithChildren
  '/food-app/projects/$project_id': typeof FoodAppProjectsProjectidRouteRouteWithChildren
  '/food-app/sessions/$session_id': typeof FoodAppSessionsSessionidRouteRouteWithChildren
  '/harvests/operation-templates/$template_id': typeof HarvestsOperationTemplatesTemplateidRouteRouteWithChildren
  '/harvests/protocols/$protocol_id': typeof HarvestsProtocolsProtocolidRouteRouteWithChildren
  '/inventory/equipment/$equipment_id': typeof InventoryEquipmentEquipmentidRouteRouteWithChildren
  '/settings/cleaning-procedures/$procedure_id': typeof SettingsCleaningProceduresProcedureidRouteRouteWithChildren
  '/analytics/blueprints/$blueprint_id': typeof AnalyticsBlueprintsBlueprintidRoute
  '/analytics/classic/$slug': typeof AnalyticsClassicSlugRoute
  '/analytics/methods/$template_id': typeof AnalyticsMethodsTemplateidRoute
  '/brewcontrol/$nodeId/calibration': typeof BrewcontrolNodeIdCalibrationRoute
  '/brewcontrol/$nodeId/config': typeof BrewcontrolNodeIdConfigRoute
  '/brewcontrol/$nodeId/devices': typeof BrewcontrolNodeIdDevicesRoute
  '/brewcontrol/$nodeId/logs': typeof BrewcontrolNodeIdLogsRoute
  '/devices/rigs/$rigId': typeof DevicesRigsRigIdRoute
  '/fermentations/$group_id/timeline': typeof FermentationsGroupidTimelineRoute
  '/fermentations/dashboards/$dashboardId': typeof FermentationsDashboardsDashboardIdRoute
  '/fermentations/investigations/$investigation_id': typeof FermentationsInvestigationsInvestigationidRoute
  '/fermentations/medium-recipes/$recipe_id': typeof FermentationsMediumRecipesRecipeidRoute
  '/food-app/ingredients/$product_id': typeof FoodAppIngredientsProductidRoute
  '/food-app/sensory/$brew_sensory_session_id': typeof FoodAppSensoryBrewsensorysessionidRoute
  '/food-app/sensory/templates': typeof FoodAppSensoryTemplatesRoute
  '/food-app/tasters/$taster_id': typeof FoodAppTastersTasteridRoute
  '/food-app/tastings/$tasting_id': typeof FoodAppTastingsTastingidRoute
  '/harvests/$session_id/analysis': typeof HarvestsSessionidAnalysisRoute
  '/harvests/$session_id/batches': typeof HarvestsSessionidBatchesRoute
  '/harvests/$session_id/live': typeof HarvestsSessionidLiveRoute
  '/harvests/$session_id/post-cleaning': typeof HarvestsSessionidPostCleaningRoute
  '/harvests/$session_id/pre-cleaning': typeof HarvestsSessionidPreCleaningRoute
  '/harvests/$session_id/samples': typeof HarvestsSessionidSamplesRoute
  '/harvests/batches/$batch_id': typeof HarvestsBatchesBatchidRoute
  '/inventory/orders/new': typeof InventoryOrdersNewRoute
  '/inventory/prepare/dilution': typeof InventoryPrepareDilutionRoute
  '/inventory/prepare/recipe': typeof InventoryPrepareRecipeRoute
  '/inventory/purchased/new': typeof InventoryPurchasedNewRoute
  '/inventory/recipes/$recipeId': typeof InventoryRecipesRecipeIdRoute
  '/sensory/join/$join_code': typeof SensoryJoinJoincodeRoute
  '/settings/batch-clearance/$clearance_defintion_id': typeof SettingsBatchClearanceClearancedefintionidRoute
  '/settings/formula-templates/$template_id': typeof SettingsFormulaTemplatesTemplateidRoute
  '/settings/inventory/certificate-types': typeof SettingsInventoryCertificateTypesRoute
  '/settings/inventory/equipment-models': typeof SettingsInventoryEquipmentModelsRoute
  '/settings/inventory/equipment-types': typeof SettingsInventoryEquipmentTypesRoute
  '/settings/inventory/locations': typeof SettingsInventoryLocationsRoute
  '/settings/inventory/manufacturers': typeof SettingsInventoryManufacturersRoute
  '/settings/inventory/resources': typeof SettingsInventoryResourcesRoute
  '/settings/inventory/sterilization': typeof SettingsInventorySterilizationRoute
  '/stage/preview/$tasting_id': typeof StagePreviewTastingidRoute
  '/stage/tasting/$tasting_id': typeof StageTastingTastingidRoute
  '/analytics/blueprints/': typeof AnalyticsBlueprintsIndexRoute
  '/analytics/classic/': typeof AnalyticsClassicIndexRoute
  '/analytics/external/': typeof AnalyticsExternalIndexRoute
  '/analytics/templates/': typeof AnalyticsTemplatesIndexRoute
  '/brewcontrol/$nodeId/': typeof BrewcontrolNodeIdIndexRoute
  '/brewcontrol/wirings/': typeof BrewcontrolWiringsIndexRoute
  '/fermentations/$group_id/': typeof FermentationsGroupidIndexRoute
  '/fermentations/dashboards/': typeof FermentationsDashboardsIndexRoute
  '/fermentations/investigations/': typeof FermentationsInvestigationsIndexRoute
  '/fermentations/medium-recipes/': typeof FermentationsMediumRecipesIndexRoute
  '/fermentations/procedures/': typeof FermentationsProceduresIndexRoute
  '/fermentations/protocols/': typeof FermentationsProtocolsIndexRoute
  '/food-app/ingredients/': typeof FoodAppIngredientsIndexRoute
  '/food-app/projects/': typeof FoodAppProjectsIndexRoute
  '/food-app/sensory/': typeof FoodAppSensoryIndexRoute
  '/food-app/tasters/': typeof FoodAppTastersIndexRoute
  '/food-app/tastings/': typeof FoodAppTastingsIndexRoute
  '/harvests/$session_id/': typeof HarvestsSessionidIndexRoute
  '/harvests/batches/': typeof HarvestsBatchesIndexRoute
  '/harvests/operation-templates/': typeof HarvestsOperationTemplatesIndexRoute
  '/harvests/protocols/': typeof HarvestsProtocolsIndexRoute
  '/inventory/equipment/': typeof InventoryEquipmentIndexRoute
  '/inventory/recipes/': typeof InventoryRecipesIndexRoute
  '/settings/batch-clearance/': typeof SettingsBatchClearanceIndexRoute
  '/settings/cleaning-procedures/': typeof SettingsCleaningProceduresIndexRoute
  '/settings/documents/': typeof SettingsDocumentsIndexRoute
  '/settings/formula-templates/': typeof SettingsFormulaTemplatesIndexRoute
  '/analytics/external/imports/$import_id': typeof AnalyticsExternalImportsImportidRoute
  '/analytics/external/orders/$session_id': typeof AnalyticsExternalOrdersSessionidRoute
  '/analytics/templates/$template_id/attributes': typeof AnalyticsTemplatesTemplateidAttributesRoute
  '/analytics/templates/$template_id/blueprint': typeof AnalyticsTemplatesTemplateidBlueprintRoute
  '/analytics/templates/$template_id/curves': typeof AnalyticsTemplatesTemplateidCurvesRoute
  '/brewcontrol/wirings/$modelId/calibration': typeof BrewcontrolWiringsModelIdCalibrationRoute
  '/fermentations/$group_id/aftercare/cip': typeof FermentationsGroupidAftercareCipRoute
  '/fermentations/$group_id/aftercare/weights': typeof FermentationsGroupidAftercareWeightsRoute
  '/fermentations/$group_id/planning/alerts': typeof FermentationsGroupidPlanningAlertsRoute
  '/fermentations/$group_id/planning/general': typeof FermentationsGroupidPlanningGeneralRoute
  '/fermentations/$group_id/planning/protocol': typeof FermentationsGroupidPlanningProtocolRoute
  '/fermentations/$group_id/results/analysis': typeof FermentationsGroupidResultsAnalysisRoute
  '/fermentations/$group_id/results/charts': typeof FermentationsGroupidResultsChartsRoute
  '/fermentations/$group_id/results/data': typeof FermentationsGroupidResultsDataRoute
  '/fermentations/$group_id/results/kpis': typeof FermentationsGroupidResultsKpisRoute
  '/fermentations/$group_id/results/tests': typeof FermentationsGroupidResultsTestsRoute
  '/fermentations/$group_id/setup/calibration': typeof FermentationsGroupidSetupCalibrationRoute
  '/fermentations/$group_id/setup/inoculation': typeof FermentationsGroupidSetupInoculationRoute
  '/fermentations/$group_id/setup/pre-cleaning': typeof FermentationsGroupidSetupPreCleaningRoute
  '/fermentations/$group_id/setup/preparation': typeof FermentationsGroupidSetupPreparationRoute
  '/fermentations/$group_id/setup/seed-flask': typeof FermentationsGroupidSetupSeedFlaskRoute
  '/fermentations/procedures/$procedure_id/alerts': typeof FermentationsProceduresProcedureidAlertsRoute
  '/fermentations/procedures/$procedure_id/dashboard': typeof FermentationsProceduresProcedureidDashboardRoute
  '/fermentations/procedures/$procedure_id/kpis': typeof FermentationsProceduresProcedureidKpisRoute
  '/fermentations/procedures/$procedure_id/lines': typeof FermentationsProceduresProcedureidLinesRoute
  '/fermentations/procedures/$procedure_id/overview': typeof FermentationsProceduresProcedureidOverviewRoute
  '/fermentations/procedures/$procedure_id/protocols': typeof FermentationsProceduresProcedureidProtocolsRoute
  '/fermentations/procedures/$procedure_id/tasks': typeof FermentationsProceduresProcedureidTasksRoute
  '/fermentations/protocols/$protocol_id/overview': typeof FermentationsProtocolsProtocolidOverviewRoute
  '/fermentations/protocols/$protocol_id/parameters': typeof FermentationsProtocolsProtocolidParametersRoute
  '/food-app/sessions/$session_id/analysis': typeof FoodAppSessionsSessionidAnalysisRoute
  '/food-app/sessions/$session_id/general': typeof FoodAppSessionsSessionidGeneralRoute
  '/food-app/sessions/$session_id/results': typeof FoodAppSessionsSessionidResultsRoute
  '/food-app/sessions/$session_id/running': typeof FoodAppSessionsSessionidRunningRoute
  '/food-app/sessions/$session_id/setup': typeof FoodAppSessionsSessionidSetupRoute
  '/harvests/$session_id/stages/$stage_id': typeof HarvestsSessionidStagesStageidRoute
  '/harvests/operation-templates/$template_id/attributes': typeof HarvestsOperationTemplatesTemplateidAttributesRoute
  '/harvests/operation-templates/$template_id/kpis': typeof HarvestsOperationTemplatesTemplateidKpisRoute
  '/harvests/operation-templates/$template_id/samples': typeof HarvestsOperationTemplatesTemplateidSamplesRoute
  '/harvests/protocols/$protocol_id/cleaning': typeof HarvestsProtocolsProtocolidCleaningRoute
  '/harvests/protocols/$protocol_id/kpis': typeof HarvestsProtocolsProtocolidKpisRoute
  '/inventory/equipment/$equipment_id/maintenance': typeof InventoryEquipmentEquipmentidMaintenanceRoute
  '/sensory/join/brew/$sensory_session_id': typeof SensoryJoinBrewSensorysessionidRoute
  '/settings/cleaning-procedures/$procedure_id/fields': typeof SettingsCleaningProceduresProcedureidFieldsRoute
  '/settings/inventory/suppliers/$id': typeof SettingsInventorySuppliersIdRoute
  '/analytics/templates/$template_id/': typeof AnalyticsTemplatesTemplateidIndexRoute
  '/brewcontrol/wirings/$modelId/': typeof BrewcontrolWiringsModelIdIndexRoute
  '/fermentations/$group_id/aftercare/': typeof FermentationsGroupidAftercareIndexRoute
  '/fermentations/$group_id/planning/': typeof FermentationsGroupidPlanningIndexRoute
  '/fermentations/$group_id/results/': typeof FermentationsGroupidResultsIndexRoute
  '/fermentations/$group_id/setup/': typeof FermentationsGroupidSetupIndexRoute
  '/fermentations/procedures/$procedure_id/': typeof FermentationsProceduresProcedureidIndexRoute
  '/fermentations/protocols/$protocol_id/': typeof FermentationsProtocolsProtocolidIndexRoute
  '/food-app/projects/$project_id/': typeof FoodAppProjectsProjectidIndexRoute
  '/food-app/sessions/$session_id/': typeof FoodAppSessionsSessionidIndexRoute
  '/harvests/operation-templates/$template_id/': typeof HarvestsOperationTemplatesTemplateidIndexRoute
  '/harvests/protocols/$protocol_id/': typeof HarvestsProtocolsProtocolidIndexRoute
  '/inventory/equipment/$equipment_id/': typeof InventoryEquipmentEquipmentidIndexRoute
  '/settings/cleaning-procedures/$procedure_id/': typeof SettingsCleaningProceduresProcedureidIndexRoute
  '/food-app/projects/$project_id/sensory/$sensory_session_id': typeof FoodAppProjectsProjectidSensorySensorysessionidRoute
  '/inventory/equipment/$equipment_id/cleaning/$record_id': typeof InventoryEquipmentEquipmentidCleaningRecordidRoute
  '/inventory/equipment/$equipment_id/cleaning/new': typeof InventoryEquipmentEquipmentidCleaningNewRoute
  '/settings/cleaning-procedures/$procedure_id/forms/$form_id': typeof SettingsCleaningProceduresProcedureidFormsFormidRoute
  '/inventory/equipment/$equipment_id/cleaning/': typeof InventoryEquipmentEquipmentidCleaningIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/brewcontrol'
    | '/devices'
    | '/inventory'
    | '/food-app'
    | '/login'
    | '/brewcontrol/$nodeId'
    | '/fermentations/$group_id'
    | '/harvests/$session_id'
    | '/alert/$token'
    | '/analytics/$slug'
    | '/analytics/catalogue'
    | '/analytics/labs'
    | '/batches/$batch_id'
    | '/brewcontrol/enrol'
    | '/consent/$share_code'
    | '/devices/$deviceId'
    | '/fermentations/board'
    | '/fermentations/bottles'
    | '/fermentations/canvas'
    | '/fermentations/methanol-suggestions'
    | '/food-app/configuration'
    | '/food-app/ingredients'
    | '/food-app/projects'
    | '/food-app/sensory'
    | '/food-app/tasters'
    | '/food-app/tastings'
    | '/harvests/broth'
    | '/inventory/analytics'
    | '/inventory/orders'
    | '/inventory/organisms'
    | '/inventory/products'
    | '/inventory/receiving'
    | '/inventory/suppliers'
    | '/sensory/$token'
    | '/settings/devices'
    | '/settings/fermentation-parameters'
    | '/settings/operators'
    | '/stage/preview-stage'
    | '/tests/$'
    | '/upload/$token'
    | '/analytics/'
    | '/batches'
    | '/brewcontrol/'
    | '/devices/'
    | '/fermentations'
    | '/food-app/'
    | '/harvests'
    | '/inventory/'
    | '/settings'
    | '/analytics/templates/$template_id'
    | '/brewcontrol/wirings/$modelId'
    | '/fermentations/$group_id/aftercare'
    | '/fermentations/$group_id/planning'
    | '/fermentations/$group_id/results'
    | '/fermentations/$group_id/setup'
    | '/fermentations/procedures/$procedure_id'
    | '/fermentations/protocols/$protocol_id'
    | '/food-app/projects/$project_id'
    | '/food-app/sessions/$session_id'
    | '/harvests/operation-templates/$template_id'
    | '/harvests/protocols/$protocol_id'
    | '/inventory/equipment/$equipment_id'
    | '/settings/cleaning-procedures/$procedure_id'
    | '/analytics/blueprints/$blueprint_id'
    | '/analytics/classic/$slug'
    | '/analytics/methods/$template_id'
    | '/brewcontrol/$nodeId/calibration'
    | '/brewcontrol/$nodeId/config'
    | '/brewcontrol/$nodeId/devices'
    | '/brewcontrol/$nodeId/logs'
    | '/devices/rigs/$rigId'
    | '/fermentations/$group_id/timeline'
    | '/fermentations/dashboards/$dashboardId'
    | '/fermentations/investigations/$investigation_id'
    | '/fermentations/medium-recipes/$recipe_id'
    | '/food-app/ingredients/$product_id'
    | '/food-app/sensory/$brew_sensory_session_id'
    | '/food-app/sensory/templates'
    | '/food-app/tasters/$taster_id'
    | '/food-app/tastings/$tasting_id'
    | '/harvests/$session_id/analysis'
    | '/harvests/$session_id/batches'
    | '/harvests/$session_id/live'
    | '/harvests/$session_id/post-cleaning'
    | '/harvests/$session_id/pre-cleaning'
    | '/harvests/$session_id/samples'
    | '/harvests/batches/$batch_id'
    | '/inventory/orders/new'
    | '/inventory/prepare/dilution'
    | '/inventory/prepare/recipe'
    | '/inventory/purchased/new'
    | '/inventory/recipes/$recipeId'
    | '/sensory/join/$join_code'
    | '/settings/batch-clearance/$clearance_defintion_id'
    | '/settings/formula-templates/$template_id'
    | '/settings/inventory/certificate-types'
    | '/settings/inventory/equipment-models'
    | '/settings/inventory/equipment-types'
    | '/settings/inventory/locations'
    | '/settings/inventory/manufacturers'
    | '/settings/inventory/resources'
    | '/settings/inventory/sterilization'
    | '/stage/preview/$tasting_id'
    | '/stage/tasting/$tasting_id'
    | '/analytics/blueprints'
    | '/analytics/classic'
    | '/analytics/external'
    | '/analytics/templates'
    | '/brewcontrol/$nodeId/'
    | '/brewcontrol/wirings'
    | '/fermentations/$group_id/'
    | '/fermentations/dashboards'
    | '/fermentations/investigations'
    | '/fermentations/medium-recipes'
    | '/fermentations/procedures'
    | '/fermentations/protocols'
    | '/food-app/ingredients/'
    | '/food-app/projects/'
    | '/food-app/sensory/'
    | '/food-app/tasters/'
    | '/food-app/tastings/'
    | '/harvests/$session_id/'
    | '/harvests/batches'
    | '/harvests/operation-templates'
    | '/harvests/protocols'
    | '/inventory/equipment'
    | '/inventory/recipes'
    | '/settings/batch-clearance'
    | '/settings/cleaning-procedures'
    | '/settings/documents'
    | '/settings/formula-templates'
    | '/analytics/external/imports/$import_id'
    | '/analytics/external/orders/$session_id'
    | '/analytics/templates/$template_id/attributes'
    | '/analytics/templates/$template_id/blueprint'
    | '/analytics/templates/$template_id/curves'
    | '/brewcontrol/wirings/$modelId/calibration'
    | '/fermentations/$group_id/aftercare/cip'
    | '/fermentations/$group_id/aftercare/weights'
    | '/fermentations/$group_id/planning/alerts'
    | '/fermentations/$group_id/planning/general'
    | '/fermentations/$group_id/planning/protocol'
    | '/fermentations/$group_id/results/analysis'
    | '/fermentations/$group_id/results/charts'
    | '/fermentations/$group_id/results/data'
    | '/fermentations/$group_id/results/kpis'
    | '/fermentations/$group_id/results/tests'
    | '/fermentations/$group_id/setup/calibration'
    | '/fermentations/$group_id/setup/inoculation'
    | '/fermentations/$group_id/setup/pre-cleaning'
    | '/fermentations/$group_id/setup/preparation'
    | '/fermentations/$group_id/setup/seed-flask'
    | '/fermentations/procedures/$procedure_id/alerts'
    | '/fermentations/procedures/$procedure_id/dashboard'
    | '/fermentations/procedures/$procedure_id/kpis'
    | '/fermentations/procedures/$procedure_id/lines'
    | '/fermentations/procedures/$procedure_id/overview'
    | '/fermentations/procedures/$procedure_id/protocols'
    | '/fermentations/procedures/$procedure_id/tasks'
    | '/fermentations/protocols/$protocol_id/overview'
    | '/fermentations/protocols/$protocol_id/parameters'
    | '/food-app/sessions/$session_id/analysis'
    | '/food-app/sessions/$session_id/general'
    | '/food-app/sessions/$session_id/results'
    | '/food-app/sessions/$session_id/running'
    | '/food-app/sessions/$session_id/setup'
    | '/harvests/$session_id/stages/$stage_id'
    | '/harvests/operation-templates/$template_id/attributes'
    | '/harvests/operation-templates/$template_id/kpis'
    | '/harvests/operation-templates/$template_id/samples'
    | '/harvests/protocols/$protocol_id/cleaning'
    | '/harvests/protocols/$protocol_id/kpis'
    | '/inventory/equipment/$equipment_id/maintenance'
    | '/sensory/join/brew/$sensory_session_id'
    | '/settings/cleaning-procedures/$procedure_id/fields'
    | '/settings/inventory/suppliers/$id'
    | '/analytics/templates/$template_id/'
    | '/brewcontrol/wirings/$modelId/'
    | '/fermentations/$group_id/aftercare/'
    | '/fermentations/$group_id/planning/'
    | '/fermentations/$group_id/results/'
    | '/fermentations/$group_id/setup/'
    | '/fermentations/procedures/$procedure_id/'
    | '/fermentations/protocols/$protocol_id/'
    | '/food-app/projects/$project_id/'
    | '/food-app/sessions/$session_id/'
    | '/harvests/operation-templates/$template_id/'
    | '/harvests/protocols/$protocol_id/'
    | '/inventory/equipment/$equipment_id/'
    | '/settings/cleaning-procedures/$procedure_id/'
    | '/food-app/projects/$project_id/sensory/$sensory_session_id'
    | '/inventory/equipment/$equipment_id/cleaning/$record_id'
    | '/inventory/equipment/$equipment_id/cleaning/new'
    | '/settings/cleaning-procedures/$procedure_id/forms/$form_id'
    | '/inventory/equipment/$equipment_id/cleaning'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/alert/$token'
    | '/analytics/$slug'
    | '/analytics/catalogue'
    | '/analytics/labs'
    | '/batches/$batch_id'
    | '/brewcontrol/enrol'
    | '/consent/$share_code'
    | '/devices/$deviceId'
    | '/fermentations/board'
    | '/fermentations/bottles'
    | '/fermentations/canvas'
    | '/fermentations/methanol-suggestions'
    | '/food-app/configuration'
    | '/harvests/broth'
    | '/inventory/analytics'
    | '/inventory/orders'
    | '/inventory/organisms'
    | '/inventory/products'
    | '/inventory/receiving'
    | '/inventory/suppliers'
    | '/sensory/$token'
    | '/settings/devices'
    | '/settings/fermentation-parameters'
    | '/settings/operators'
    | '/stage/preview-stage'
    | '/tests/$'
    | '/upload/$token'
    | '/analytics'
    | '/batches'
    | '/brewcontrol'
    | '/devices'
    | '/fermentations'
    | '/food-app'
    | '/harvests'
    | '/inventory'
    | '/settings'
    | '/analytics/blueprints/$blueprint_id'
    | '/analytics/classic/$slug'
    | '/analytics/methods/$template_id'
    | '/brewcontrol/$nodeId/calibration'
    | '/brewcontrol/$nodeId/config'
    | '/brewcontrol/$nodeId/devices'
    | '/brewcontrol/$nodeId/logs'
    | '/devices/rigs/$rigId'
    | '/fermentations/$group_id/timeline'
    | '/fermentations/dashboards/$dashboardId'
    | '/fermentations/investigations/$investigation_id'
    | '/fermentations/medium-recipes/$recipe_id'
    | '/food-app/ingredients/$product_id'
    | '/food-app/sensory/$brew_sensory_session_id'
    | '/food-app/sensory/templates'
    | '/food-app/tasters/$taster_id'
    | '/food-app/tastings/$tasting_id'
    | '/harvests/$session_id/analysis'
    | '/harvests/$session_id/batches'
    | '/harvests/$session_id/live'
    | '/harvests/$session_id/post-cleaning'
    | '/harvests/$session_id/pre-cleaning'
    | '/harvests/$session_id/samples'
    | '/harvests/batches/$batch_id'
    | '/inventory/orders/new'
    | '/inventory/prepare/dilution'
    | '/inventory/prepare/recipe'
    | '/inventory/purchased/new'
    | '/inventory/recipes/$recipeId'
    | '/sensory/join/$join_code'
    | '/settings/batch-clearance/$clearance_defintion_id'
    | '/settings/formula-templates/$template_id'
    | '/settings/inventory/certificate-types'
    | '/settings/inventory/equipment-models'
    | '/settings/inventory/equipment-types'
    | '/settings/inventory/locations'
    | '/settings/inventory/manufacturers'
    | '/settings/inventory/resources'
    | '/settings/inventory/sterilization'
    | '/stage/preview/$tasting_id'
    | '/stage/tasting/$tasting_id'
    | '/analytics/blueprints'
    | '/analytics/classic'
    | '/analytics/external'
    | '/analytics/templates'
    | '/brewcontrol/$nodeId'
    | '/brewcontrol/wirings'
    | '/fermentations/$group_id'
    | '/fermentations/dashboards'
    | '/fermentations/investigations'
    | '/fermentations/medium-recipes'
    | '/fermentations/procedures'
    | '/fermentations/protocols'
    | '/food-app/ingredients'
    | '/food-app/projects'
    | '/food-app/sensory'
    | '/food-app/tasters'
    | '/food-app/tastings'
    | '/harvests/$session_id'
    | '/harvests/batches'
    | '/harvests/operation-templates'
    | '/harvests/protocols'
    | '/inventory/equipment'
    | '/inventory/recipes'
    | '/settings/batch-clearance'
    | '/settings/cleaning-procedures'
    | '/settings/documents'
    | '/settings/formula-templates'
    | '/analytics/external/imports/$import_id'
    | '/analytics/external/orders/$session_id'
    | '/analytics/templates/$template_id/attributes'
    | '/analytics/templates/$template_id/blueprint'
    | '/analytics/templates/$template_id/curves'
    | '/brewcontrol/wirings/$modelId/calibration'
    | '/fermentations/$group_id/aftercare/cip'
    | '/fermentations/$group_id/aftercare/weights'
    | '/fermentations/$group_id/planning/alerts'
    | '/fermentations/$group_id/planning/general'
    | '/fermentations/$group_id/planning/protocol'
    | '/fermentations/$group_id/results/analysis'
    | '/fermentations/$group_id/results/charts'
    | '/fermentations/$group_id/results/data'
    | '/fermentations/$group_id/results/kpis'
    | '/fermentations/$group_id/results/tests'
    | '/fermentations/$group_id/setup/calibration'
    | '/fermentations/$group_id/setup/inoculation'
    | '/fermentations/$group_id/setup/pre-cleaning'
    | '/fermentations/$group_id/setup/preparation'
    | '/fermentations/$group_id/setup/seed-flask'
    | '/fermentations/procedures/$procedure_id/alerts'
    | '/fermentations/procedures/$procedure_id/dashboard'
    | '/fermentations/procedures/$procedure_id/kpis'
    | '/fermentations/procedures/$procedure_id/lines'
    | '/fermentations/procedures/$procedure_id/overview'
    | '/fermentations/procedures/$procedure_id/protocols'
    | '/fermentations/procedures/$procedure_id/tasks'
    | '/fermentations/protocols/$protocol_id/overview'
    | '/fermentations/protocols/$protocol_id/parameters'
    | '/food-app/sessions/$session_id/analysis'
    | '/food-app/sessions/$session_id/general'
    | '/food-app/sessions/$session_id/results'
    | '/food-app/sessions/$session_id/running'
    | '/food-app/sessions/$session_id/setup'
    | '/harvests/$session_id/stages/$stage_id'
    | '/harvests/operation-templates/$template_id/attributes'
    | '/harvests/operation-templates/$template_id/kpis'
    | '/harvests/operation-templates/$template_id/samples'
    | '/harvests/protocols/$protocol_id/cleaning'
    | '/harvests/protocols/$protocol_id/kpis'
    | '/inventory/equipment/$equipment_id/maintenance'
    | '/sensory/join/brew/$sensory_session_id'
    | '/settings/cleaning-procedures/$procedure_id/fields'
    | '/settings/inventory/suppliers/$id'
    | '/analytics/templates/$template_id'
    | '/brewcontrol/wirings/$modelId'
    | '/fermentations/$group_id/aftercare'
    | '/fermentations/$group_id/planning'
    | '/fermentations/$group_id/results'
    | '/fermentations/$group_id/setup'
    | '/fermentations/procedures/$procedure_id'
    | '/fermentations/protocols/$protocol_id'
    | '/food-app/projects/$project_id'
    | '/food-app/sessions/$session_id'
    | '/harvests/operation-templates/$template_id'
    | '/harvests/protocols/$protocol_id'
    | '/inventory/equipment/$equipment_id'
    | '/settings/cleaning-procedures/$procedure_id'
    | '/food-app/projects/$project_id/sensory/$sensory_session_id'
    | '/inventory/equipment/$equipment_id/cleaning/$record_id'
    | '/inventory/equipment/$equipment_id/cleaning/new'
    | '/settings/cleaning-procedures/$procedure_id/forms/$form_id'
    | '/inventory/equipment/$equipment_id/cleaning'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/brewcontrol'
    | '/devices'
    | '/inventory'
    | '/food-app'
    | '/login'
    | '/brewcontrol/$nodeId'
    | '/fermentations/$group_id'
    | '/harvests/$session_id'
    | '/alert/$token'
    | '/analytics/$slug'
    | '/analytics/catalogue'
    | '/analytics/labs'
    | '/batches/$batch_id'
    | '/brewcontrol/enrol'
    | '/consent/$share_code'
    | '/devices/$deviceId'
    | '/fermentations/board'
    | '/fermentations/bottles'
    | '/fermentations/canvas'
    | '/fermentations/methanol-suggestions'
    | '/food-app/configuration'
    | '/food-app/ingredients'
    | '/food-app/projects'
    | '/food-app/sensory'
    | '/food-app/tasters'
    | '/food-app/tastings'
    | '/harvests/broth'
    | '/inventory/analytics'
    | '/inventory/orders'
    | '/inventory/organisms'
    | '/inventory/products'
    | '/inventory/receiving'
    | '/inventory/suppliers'
    | '/sensory/$token'
    | '/settings/devices'
    | '/settings/fermentation-parameters'
    | '/settings/operators'
    | '/stage/preview-stage'
    | '/tests/$'
    | '/upload/$token'
    | '/analytics/'
    | '/batches/'
    | '/brewcontrol/'
    | '/devices/'
    | '/fermentations/'
    | '/food-app/'
    | '/harvests/'
    | '/inventory/'
    | '/settings/'
    | '/analytics/templates/$template_id'
    | '/brewcontrol/wirings/$modelId'
    | '/fermentations/$group_id/aftercare'
    | '/fermentations/$group_id/planning'
    | '/fermentations/$group_id/results'
    | '/fermentations/$group_id/setup'
    | '/fermentations/procedures/$procedure_id'
    | '/fermentations/protocols/$protocol_id'
    | '/food-app/projects/$project_id'
    | '/food-app/sessions/$session_id'
    | '/harvests/operation-templates/$template_id'
    | '/harvests/protocols/$protocol_id'
    | '/inventory/equipment/$equipment_id'
    | '/settings/cleaning-procedures/$procedure_id'
    | '/analytics/blueprints/$blueprint_id'
    | '/analytics/classic/$slug'
    | '/analytics/methods/$template_id'
    | '/brewcontrol/$nodeId/calibration'
    | '/brewcontrol/$nodeId/config'
    | '/brewcontrol/$nodeId/devices'
    | '/brewcontrol/$nodeId/logs'
    | '/devices/rigs/$rigId'
    | '/fermentations/$group_id/timeline'
    | '/fermentations/dashboards/$dashboardId'
    | '/fermentations/investigations/$investigation_id'
    | '/fermentations/medium-recipes/$recipe_id'
    | '/food-app/ingredients/$product_id'
    | '/food-app/sensory/$brew_sensory_session_id'
    | '/food-app/sensory/templates'
    | '/food-app/tasters/$taster_id'
    | '/food-app/tastings/$tasting_id'
    | '/harvests/$session_id/analysis'
    | '/harvests/$session_id/batches'
    | '/harvests/$session_id/live'
    | '/harvests/$session_id/post-cleaning'
    | '/harvests/$session_id/pre-cleaning'
    | '/harvests/$session_id/samples'
    | '/harvests/batches/$batch_id'
    | '/inventory/orders/new'
    | '/inventory/prepare/dilution'
    | '/inventory/prepare/recipe'
    | '/inventory/purchased/new'
    | '/inventory/recipes/$recipeId'
    | '/sensory/join/$join_code'
    | '/settings/batch-clearance/$clearance_defintion_id'
    | '/settings/formula-templates/$template_id'
    | '/settings/inventory/certificate-types'
    | '/settings/inventory/equipment-models'
    | '/settings/inventory/equipment-types'
    | '/settings/inventory/locations'
    | '/settings/inventory/manufacturers'
    | '/settings/inventory/resources'
    | '/settings/inventory/sterilization'
    | '/stage/preview/$tasting_id'
    | '/stage/tasting/$tasting_id'
    | '/analytics/blueprints/'
    | '/analytics/classic/'
    | '/analytics/external/'
    | '/analytics/templates/'
    | '/brewcontrol/$nodeId/'
    | '/brewcontrol/wirings/'
    | '/fermentations/$group_id/'
    | '/fermentations/dashboards/'
    | '/fermentations/investigations/'
    | '/fermentations/medium-recipes/'
    | '/fermentations/procedures/'
    | '/fermentations/protocols/'
    | '/food-app/ingredients/'
    | '/food-app/projects/'
    | '/food-app/sensory/'
    | '/food-app/tasters/'
    | '/food-app/tastings/'
    | '/harvests/$session_id/'
    | '/harvests/batches/'
    | '/harvests/operation-templates/'
    | '/harvests/protocols/'
    | '/inventory/equipment/'
    | '/inventory/recipes/'
    | '/settings/batch-clearance/'
    | '/settings/cleaning-procedures/'
    | '/settings/documents/'
    | '/settings/formula-templates/'
    | '/analytics/external/imports/$import_id'
    | '/analytics/external/orders/$session_id'
    | '/analytics/templates/$template_id/attributes'
    | '/analytics/templates/$template_id/blueprint'
    | '/analytics/templates/$template_id/curves'
    | '/brewcontrol/wirings/$modelId/calibration'
    | '/fermentations/$group_id/aftercare/cip'
    | '/fermentations/$group_id/aftercare/weights'
    | '/fermentations/$group_id/planning/alerts'
    | '/fermentations/$group_id/planning/general'
    | '/fermentations/$group_id/planning/protocol'
    | '/fermentations/$group_id/results/analysis'
    | '/fermentations/$group_id/results/charts'
    | '/fermentations/$group_id/results/data'
    | '/fermentations/$group_id/results/kpis'
    | '/fermentations/$group_id/results/tests'
    | '/fermentations/$group_id/setup/calibration'
    | '/fermentations/$group_id/setup/inoculation'
    | '/fermentations/$group_id/setup/pre-cleaning'
    | '/fermentations/$group_id/setup/preparation'
    | '/fermentations/$group_id/setup/seed-flask'
    | '/fermentations/procedures/$procedure_id/alerts'
    | '/fermentations/procedures/$procedure_id/dashboard'
    | '/fermentations/procedures/$procedure_id/kpis'
    | '/fermentations/procedures/$procedure_id/lines'
    | '/fermentations/procedures/$procedure_id/overview'
    | '/fermentations/procedures/$procedure_id/protocols'
    | '/fermentations/procedures/$procedure_id/tasks'
    | '/fermentations/protocols/$protocol_id/overview'
    | '/fermentations/protocols/$protocol_id/parameters'
    | '/food-app/sessions/$session_id/analysis'
    | '/food-app/sessions/$session_id/general'
    | '/food-app/sessions/$session_id/results'
    | '/food-app/sessions/$session_id/running'
    | '/food-app/sessions/$session_id/setup'
    | '/harvests/$session_id/stages/$stage_id'
    | '/harvests/operation-templates/$template_id/attributes'
    | '/harvests/operation-templates/$template_id/kpis'
    | '/harvests/operation-templates/$template_id/samples'
    | '/harvests/protocols/$protocol_id/cleaning'
    | '/harvests/protocols/$protocol_id/kpis'
    | '/inventory/equipment/$equipment_id/maintenance'
    | '/sensory/join/brew/$sensory_session_id'
    | '/settings/cleaning-procedures/$procedure_id/fields'
    | '/settings/inventory/suppliers/$id'
    | '/analytics/templates/$template_id/'
    | '/brewcontrol/wirings/$modelId/'
    | '/fermentations/$group_id/aftercare/'
    | '/fermentations/$group_id/planning/'
    | '/fermentations/$group_id/results/'
    | '/fermentations/$group_id/setup/'
    | '/fermentations/procedures/$procedure_id/'
    | '/fermentations/protocols/$protocol_id/'
    | '/food-app/projects/$project_id/'
    | '/food-app/sessions/$session_id/'
    | '/harvests/operation-templates/$template_id/'
    | '/harvests/protocols/$protocol_id/'
    | '/inventory/equipment/$equipment_id/'
    | '/settings/cleaning-procedures/$procedure_id/'
    | '/food-app/projects/$project_id/sensory/$sensory_session_id'
    | '/inventory/equipment/$equipment_id/cleaning/$record_id'
    | '/inventory/equipment/$equipment_id/cleaning/new'
    | '/settings/cleaning-procedures/$procedure_id/forms/$form_id'
    | '/inventory/equipment/$equipment_id/cleaning/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRouteRoute: typeof AnalyticsRouteRouteWithChildren
  BrewcontrolRouteRoute: typeof BrewcontrolRouteRouteWithChildren
  DevicesRouteRoute: typeof DevicesRouteRouteWithChildren
  InventoryRouteRoute: typeof InventoryRouteRouteWithChildren
  FoodAppRoute: typeof FoodAppRouteWithChildren
  LoginRoute: typeof LoginRoute
  FermentationsGroupidRouteRoute: typeof FermentationsGroupidRouteRouteWithChildren
  HarvestsSessionidRouteRoute: typeof HarvestsSessionidRouteRouteWithChildren
  AlertTokenRoute: typeof AlertTokenRoute
  BatchesBatchidRoute: typeof BatchesBatchidRoute
  ConsentSharecodeRoute: typeof ConsentSharecodeRoute
  FermentationsBoardRoute: typeof FermentationsBoardRoute
  FermentationsBottlesRoute: typeof FermentationsBottlesRoute
  FermentationsCanvasRoute: typeof FermentationsCanvasRoute
  FermentationsMethanolSuggestionsRoute: typeof FermentationsMethanolSuggestionsRoute
  HarvestsBrothRoute: typeof HarvestsBrothRoute
  SensoryTokenRoute: typeof SensoryTokenRoute
  SettingsDevicesRoute: typeof SettingsDevicesRoute
  SettingsFermentationParametersRoute: typeof SettingsFermentationParametersRoute
  SettingsOperatorsRoute: typeof SettingsOperatorsRoute
  StagePreviewStageRoute: typeof StagePreviewStageRoute
  TestsSplatRoute: typeof TestsSplatRoute
  UploadTokenRoute: typeof UploadTokenRoute
  BatchesIndexRoute: typeof BatchesIndexRoute
  FermentationsIndexRoute: typeof FermentationsIndexRoute
  HarvestsIndexRoute: typeof HarvestsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  FermentationsProceduresProcedureidRouteRoute: typeof FermentationsProceduresProcedureidRouteRouteWithChildren
  FermentationsProtocolsProtocolidRouteRoute: typeof FermentationsProtocolsProtocolidRouteRouteWithChildren
  HarvestsOperationTemplatesTemplateidRouteRoute: typeof HarvestsOperationTemplatesTemplateidRouteRouteWithChildren
  HarvestsProtocolsProtocolidRouteRoute: typeof HarvestsProtocolsProtocolidRouteRouteWithChildren
  SettingsCleaningProceduresProcedureidRouteRoute: typeof SettingsCleaningProceduresProcedureidRouteRouteWithChildren
  FermentationsDashboardsDashboardIdRoute: typeof FermentationsDashboardsDashboardIdRoute
  FermentationsInvestigationsInvestigationidRoute: typeof FermentationsInvestigationsInvestigationidRoute
  FermentationsMediumRecipesRecipeidRoute: typeof FermentationsMediumRecipesRecipeidRoute
  HarvestsBatchesBatchidRoute: typeof HarvestsBatchesBatchidRoute
  SensoryJoinJoincodeRoute: typeof SensoryJoinJoincodeRoute
  SettingsBatchClearanceClearancedefintionidRoute: typeof SettingsBatchClearanceClearancedefintionidRoute
  SettingsFormulaTemplatesTemplateidRoute: typeof SettingsFormulaTemplatesTemplateidRoute
  SettingsInventoryCertificateTypesRoute: typeof SettingsInventoryCertificateTypesRoute
  SettingsInventoryEquipmentModelsRoute: typeof SettingsInventoryEquipmentModelsRoute
  SettingsInventoryEquipmentTypesRoute: typeof SettingsInventoryEquipmentTypesRoute
  SettingsInventoryLocationsRoute: typeof SettingsInventoryLocationsRoute
  SettingsInventoryManufacturersRoute: typeof SettingsInventoryManufacturersRoute
  SettingsInventoryResourcesRoute: typeof SettingsInventoryResourcesRoute
  SettingsInventorySterilizationRoute: typeof SettingsInventorySterilizationRoute
  StagePreviewTastingidRoute: typeof StagePreviewTastingidRoute
  StageTastingTastingidRoute: typeof StageTastingTastingidRoute
  FermentationsDashboardsIndexRoute: typeof FermentationsDashboardsIndexRoute
  FermentationsInvestigationsIndexRoute: typeof FermentationsInvestigationsIndexRoute
  FermentationsMediumRecipesIndexRoute: typeof FermentationsMediumRecipesIndexRoute
  FermentationsProceduresIndexRoute: typeof FermentationsProceduresIndexRoute
  FermentationsProtocolsIndexRoute: typeof FermentationsProtocolsIndexRoute
  HarvestsBatchesIndexRoute: typeof HarvestsBatchesIndexRoute
  HarvestsOperationTemplatesIndexRoute: typeof HarvestsOperationTemplatesIndexRoute
  HarvestsProtocolsIndexRoute: typeof HarvestsProtocolsIndexRoute
  SettingsBatchClearanceIndexRoute: typeof SettingsBatchClearanceIndexRoute
  SettingsCleaningProceduresIndexRoute: typeof SettingsCleaningProceduresIndexRoute
  SettingsDocumentsIndexRoute: typeof SettingsDocumentsIndexRoute
  SettingsFormulaTemplatesIndexRoute: typeof SettingsFormulaTemplatesIndexRoute
  SensoryJoinBrewSensorysessionidRoute: typeof SensoryJoinBrewSensorysessionidRoute
  SettingsInventorySuppliersIdRoute: typeof SettingsInventorySuppliersIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRouteRoute: AnalyticsRouteRouteWithChildren,
  BrewcontrolRouteRoute: BrewcontrolRouteRouteWithChildren,
  DevicesRouteRoute: DevicesRouteRouteWithChildren,
  InventoryRouteRoute: InventoryRouteRouteWithChildren,
  FoodAppRoute: FoodAppRouteWithChildren,
  LoginRoute: LoginRoute,
  FermentationsGroupidRouteRoute: FermentationsGroupidRouteRouteWithChildren,
  HarvestsSessionidRouteRoute: HarvestsSessionidRouteRouteWithChildren,
  AlertTokenRoute: AlertTokenRoute,
  BatchesBatchidRoute: BatchesBatchidRoute,
  ConsentSharecodeRoute: ConsentSharecodeRoute,
  FermentationsBoardRoute: FermentationsBoardRoute,
  FermentationsBottlesRoute: FermentationsBottlesRoute,
  FermentationsCanvasRoute: FermentationsCanvasRoute,
  FermentationsMethanolSuggestionsRoute: FermentationsMethanolSuggestionsRoute,
  HarvestsBrothRoute: HarvestsBrothRoute,
  SensoryTokenRoute: SensoryTokenRoute,
  SettingsDevicesRoute: SettingsDevicesRoute,
  SettingsFermentationParametersRoute: SettingsFermentationParametersRoute,
  SettingsOperatorsRoute: SettingsOperatorsRoute,
  StagePreviewStageRoute: StagePreviewStageRoute,
  TestsSplatRoute: TestsSplatRoute,
  UploadTokenRoute: UploadTokenRoute,
  BatchesIndexRoute: BatchesIndexRoute,
  FermentationsIndexRoute: FermentationsIndexRoute,
  HarvestsIndexRoute: HarvestsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  FermentationsProceduresProcedureidRouteRoute:
    FermentationsProceduresProcedureidRouteRouteWithChildren,
  FermentationsProtocolsProtocolidRouteRoute:
    FermentationsProtocolsProtocolidRouteRouteWithChildren,
  HarvestsOperationTemplatesTemplateidRouteRoute:
    HarvestsOperationTemplatesTemplateidRouteRouteWithChildren,
  HarvestsProtocolsProtocolidRouteRoute:
    HarvestsProtocolsProtocolidRouteRouteWithChildren,
  SettingsCleaningProceduresProcedureidRouteRoute:
    SettingsCleaningProceduresProcedureidRouteRouteWithChildren,
  FermentationsDashboardsDashboardIdRoute:
    FermentationsDashboardsDashboardIdRoute,
  FermentationsInvestigationsInvestigationidRoute:
    FermentationsInvestigationsInvestigationidRoute,
  FermentationsMediumRecipesRecipeidRoute:
    FermentationsMediumRecipesRecipeidRoute,
  HarvestsBatchesBatchidRoute: HarvestsBatchesBatchidRoute,
  SensoryJoinJoincodeRoute: SensoryJoinJoincodeRoute,
  SettingsBatchClearanceClearancedefintionidRoute:
    SettingsBatchClearanceClearancedefintionidRoute,
  SettingsFormulaTemplatesTemplateidRoute:
    SettingsFormulaTemplatesTemplateidRoute,
  SettingsInventoryCertificateTypesRoute:
    SettingsInventoryCertificateTypesRoute,
  SettingsInventoryEquipmentModelsRoute: SettingsInventoryEquipmentModelsRoute,
  SettingsInventoryEquipmentTypesRoute: SettingsInventoryEquipmentTypesRoute,
  SettingsInventoryLocationsRoute: SettingsInventoryLocationsRoute,
  SettingsInventoryManufacturersRoute: SettingsInventoryManufacturersRoute,
  SettingsInventoryResourcesRoute: SettingsInventoryResourcesRoute,
  SettingsInventorySterilizationRoute: SettingsInventorySterilizationRoute,
  StagePreviewTastingidRoute: StagePreviewTastingidRoute,
  StageTastingTastingidRoute: StageTastingTastingidRoute,
  FermentationsDashboardsIndexRoute: FermentationsDashboardsIndexRoute,
  FermentationsInvestigationsIndexRoute: FermentationsInvestigationsIndexRoute,
  FermentationsMediumRecipesIndexRoute: FermentationsMediumRecipesIndexRoute,
  FermentationsProceduresIndexRoute: FermentationsProceduresIndexRoute,
  FermentationsProtocolsIndexRoute: FermentationsProtocolsIndexRoute,
  HarvestsBatchesIndexRoute: HarvestsBatchesIndexRoute,
  HarvestsOperationTemplatesIndexRoute: HarvestsOperationTemplatesIndexRoute,
  HarvestsProtocolsIndexRoute: HarvestsProtocolsIndexRoute,
  SettingsBatchClearanceIndexRoute: SettingsBatchClearanceIndexRoute,
  SettingsCleaningProceduresIndexRoute: SettingsCleaningProceduresIndexRoute,
  SettingsDocumentsIndexRoute: SettingsDocumentsIndexRoute,
  SettingsFormulaTemplatesIndexRoute: SettingsFormulaTemplatesIndexRoute,
  SensoryJoinBrewSensorysessionidRoute: SensoryJoinBrewSensorysessionidRoute,
  SettingsInventorySuppliersIdRoute: SettingsInventorySuppliersIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/analytics",
        "/brewcontrol",
        "/devices",
        "/inventory",
        "/food-app",
        "/login",
        "/fermentations/$group_id",
        "/harvests/$session_id",
        "/alert/$token",
        "/batches/$batch_id",
        "/consent/$share_code",
        "/fermentations/board",
        "/fermentations/bottles",
        "/fermentations/canvas",
        "/fermentations/methanol-suggestions",
        "/harvests/broth",
        "/sensory/$token",
        "/settings/devices",
        "/settings/fermentation-parameters",
        "/settings/operators",
        "/stage/preview-stage",
        "/tests/$",
        "/upload/$token",
        "/batches/",
        "/fermentations/",
        "/harvests/",
        "/settings/",
        "/fermentations/procedures/$procedure_id",
        "/fermentations/protocols/$protocol_id",
        "/harvests/operation-templates/$template_id",
        "/harvests/protocols/$protocol_id",
        "/settings/cleaning-procedures/$procedure_id",
        "/fermentations/dashboards/$dashboardId",
        "/fermentations/investigations/$investigation_id",
        "/fermentations/medium-recipes/$recipe_id",
        "/harvests/batches/$batch_id",
        "/sensory/join/$join_code",
        "/settings/batch-clearance/$clearance_defintion_id",
        "/settings/formula-templates/$template_id",
        "/settings/inventory/certificate-types",
        "/settings/inventory/equipment-models",
        "/settings/inventory/equipment-types",
        "/settings/inventory/locations",
        "/settings/inventory/manufacturers",
        "/settings/inventory/resources",
        "/settings/inventory/sterilization",
        "/stage/preview/$tasting_id",
        "/stage/tasting/$tasting_id",
        "/fermentations/dashboards/",
        "/fermentations/investigations/",
        "/fermentations/medium-recipes/",
        "/fermentations/procedures/",
        "/fermentations/protocols/",
        "/harvests/batches/",
        "/harvests/operation-templates/",
        "/harvests/protocols/",
        "/settings/batch-clearance/",
        "/settings/cleaning-procedures/",
        "/settings/documents/",
        "/settings/formula-templates/",
        "/sensory/join/brew/$sensory_session_id",
        "/settings/inventory/suppliers/$id"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/analytics": {
      "filePath": "analytics/route.tsx",
      "children": [
        "/analytics/$slug",
        "/analytics/catalogue",
        "/analytics/labs",
        "/analytics/",
        "/analytics/templates/$template_id",
        "/analytics/blueprints/$blueprint_id",
        "/analytics/classic/$slug",
        "/analytics/methods/$template_id",
        "/analytics/blueprints/",
        "/analytics/classic/",
        "/analytics/external/",
        "/analytics/templates/",
        "/analytics/external/imports/$import_id",
        "/analytics/external/orders/$session_id"
      ]
    },
    "/brewcontrol": {
      "filePath": "brewcontrol/route.tsx",
      "children": [
        "/brewcontrol/$nodeId",
        "/brewcontrol/enrol",
        "/brewcontrol/",
        "/brewcontrol/wirings/$modelId",
        "/brewcontrol/wirings/"
      ]
    },
    "/devices": {
      "filePath": "devices/route.tsx",
      "children": [
        "/devices/$deviceId",
        "/devices/",
        "/devices/rigs/$rigId"
      ]
    },
    "/inventory": {
      "filePath": "inventory/route.tsx",
      "children": [
        "/inventory/analytics",
        "/inventory/orders",
        "/inventory/organisms",
        "/inventory/products",
        "/inventory/receiving",
        "/inventory/suppliers",
        "/inventory/",
        "/inventory/equipment/$equipment_id",
        "/inventory/prepare/dilution",
        "/inventory/prepare/recipe",
        "/inventory/purchased/new",
        "/inventory/recipes/$recipeId",
        "/inventory/equipment/",
        "/inventory/recipes/"
      ]
    },
    "/food-app": {
      "filePath": "food-app.tsx",
      "children": [
        "/food-app/configuration",
        "/food-app/ingredients",
        "/food-app/projects",
        "/food-app/sensory",
        "/food-app/tasters",
        "/food-app/tastings",
        "/food-app/",
        "/food-app/sessions/$session_id"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/brewcontrol/$nodeId": {
      "filePath": "brewcontrol/$nodeId/route.tsx",
      "parent": "/brewcontrol",
      "children": [
        "/brewcontrol/$nodeId/calibration",
        "/brewcontrol/$nodeId/config",
        "/brewcontrol/$nodeId/devices",
        "/brewcontrol/$nodeId/logs",
        "/brewcontrol/$nodeId/"
      ]
    },
    "/fermentations/$group_id": {
      "filePath": "fermentations/$group_id/route.tsx",
      "children": [
        "/fermentations/$group_id/aftercare",
        "/fermentations/$group_id/planning",
        "/fermentations/$group_id/results",
        "/fermentations/$group_id/setup",
        "/fermentations/$group_id/timeline",
        "/fermentations/$group_id/"
      ]
    },
    "/harvests/$session_id": {
      "filePath": "harvests/$session_id/route.tsx",
      "children": [
        "/harvests/$session_id/analysis",
        "/harvests/$session_id/batches",
        "/harvests/$session_id/live",
        "/harvests/$session_id/post-cleaning",
        "/harvests/$session_id/pre-cleaning",
        "/harvests/$session_id/samples",
        "/harvests/$session_id/",
        "/harvests/$session_id/stages/$stage_id"
      ]
    },
    "/alert/$token": {
      "filePath": "alert/$token.tsx"
    },
    "/analytics/$slug": {
      "filePath": "analytics/$slug.tsx",
      "parent": "/analytics"
    },
    "/analytics/catalogue": {
      "filePath": "analytics/catalogue.tsx",
      "parent": "/analytics"
    },
    "/analytics/labs": {
      "filePath": "analytics/labs.tsx",
      "parent": "/analytics"
    },
    "/batches/$batch_id": {
      "filePath": "batches/$batch_id.tsx"
    },
    "/brewcontrol/enrol": {
      "filePath": "brewcontrol/enrol.tsx",
      "parent": "/brewcontrol"
    },
    "/consent/$share_code": {
      "filePath": "consent/$share_code.tsx"
    },
    "/devices/$deviceId": {
      "filePath": "devices/$deviceId.tsx",
      "parent": "/devices"
    },
    "/fermentations/board": {
      "filePath": "fermentations/board.tsx"
    },
    "/fermentations/bottles": {
      "filePath": "fermentations/bottles.tsx"
    },
    "/fermentations/canvas": {
      "filePath": "fermentations/canvas.tsx"
    },
    "/fermentations/methanol-suggestions": {
      "filePath": "fermentations/methanol-suggestions.tsx"
    },
    "/food-app/configuration": {
      "filePath": "food-app/configuration.tsx",
      "parent": "/food-app"
    },
    "/food-app/ingredients": {
      "filePath": "food-app/ingredients.tsx",
      "parent": "/food-app",
      "children": [
        "/food-app/ingredients/$product_id",
        "/food-app/ingredients/"
      ]
    },
    "/food-app/projects": {
      "filePath": "food-app/projects.tsx",
      "parent": "/food-app",
      "children": [
        "/food-app/projects/$project_id",
        "/food-app/projects/"
      ]
    },
    "/food-app/sensory": {
      "filePath": "food-app/sensory.tsx",
      "parent": "/food-app",
      "children": [
        "/food-app/sensory/$brew_sensory_session_id",
        "/food-app/sensory/templates",
        "/food-app/sensory/"
      ]
    },
    "/food-app/tasters": {
      "filePath": "food-app/tasters.tsx",
      "parent": "/food-app",
      "children": [
        "/food-app/tasters/$taster_id",
        "/food-app/tasters/"
      ]
    },
    "/food-app/tastings": {
      "filePath": "food-app/tastings.tsx",
      "parent": "/food-app",
      "children": [
        "/food-app/tastings/$tasting_id",
        "/food-app/tastings/"
      ]
    },
    "/harvests/broth": {
      "filePath": "harvests/broth.tsx"
    },
    "/inventory/analytics": {
      "filePath": "inventory/analytics.tsx",
      "parent": "/inventory"
    },
    "/inventory/orders": {
      "filePath": "inventory/orders.tsx",
      "parent": "/inventory",
      "children": [
        "/inventory/orders/new"
      ]
    },
    "/inventory/organisms": {
      "filePath": "inventory/organisms.tsx",
      "parent": "/inventory"
    },
    "/inventory/products": {
      "filePath": "inventory/products.tsx",
      "parent": "/inventory"
    },
    "/inventory/receiving": {
      "filePath": "inventory/receiving.tsx",
      "parent": "/inventory"
    },
    "/inventory/suppliers": {
      "filePath": "inventory/suppliers.tsx",
      "parent": "/inventory"
    },
    "/sensory/$token": {
      "filePath": "sensory/$token.tsx"
    },
    "/settings/devices": {
      "filePath": "settings/devices.tsx"
    },
    "/settings/fermentation-parameters": {
      "filePath": "settings/fermentation-parameters.tsx"
    },
    "/settings/operators": {
      "filePath": "settings/operators.tsx"
    },
    "/stage/preview-stage": {
      "filePath": "stage/preview-stage.tsx"
    },
    "/tests/$": {
      "filePath": "tests/$.tsx"
    },
    "/upload/$token": {
      "filePath": "upload/$token.tsx"
    },
    "/analytics/": {
      "filePath": "analytics/index.tsx",
      "parent": "/analytics"
    },
    "/batches/": {
      "filePath": "batches/index.tsx"
    },
    "/brewcontrol/": {
      "filePath": "brewcontrol/index.tsx",
      "parent": "/brewcontrol"
    },
    "/devices/": {
      "filePath": "devices/index.tsx",
      "parent": "/devices"
    },
    "/fermentations/": {
      "filePath": "fermentations/index.tsx"
    },
    "/food-app/": {
      "filePath": "food-app/index.tsx",
      "parent": "/food-app"
    },
    "/harvests/": {
      "filePath": "harvests/index.tsx"
    },
    "/inventory/": {
      "filePath": "inventory/index.tsx",
      "parent": "/inventory"
    },
    "/settings/": {
      "filePath": "settings/index.tsx"
    },
    "/analytics/templates/$template_id": {
      "filePath": "analytics/templates/$template_id/route.tsx",
      "parent": "/analytics",
      "children": [
        "/analytics/templates/$template_id/attributes",
        "/analytics/templates/$template_id/blueprint",
        "/analytics/templates/$template_id/curves",
        "/analytics/templates/$template_id/"
      ]
    },
    "/brewcontrol/wirings/$modelId": {
      "filePath": "brewcontrol/wirings/$modelId/route.tsx",
      "parent": "/brewcontrol",
      "children": [
        "/brewcontrol/wirings/$modelId/calibration",
        "/brewcontrol/wirings/$modelId/"
      ]
    },
    "/fermentations/$group_id/aftercare": {
      "filePath": "fermentations/$group_id/aftercare/route.tsx",
      "parent": "/fermentations/$group_id",
      "children": [
        "/fermentations/$group_id/aftercare/cip",
        "/fermentations/$group_id/aftercare/weights",
        "/fermentations/$group_id/aftercare/"
      ]
    },
    "/fermentations/$group_id/planning": {
      "filePath": "fermentations/$group_id/planning/route.tsx",
      "parent": "/fermentations/$group_id",
      "children": [
        "/fermentations/$group_id/planning/alerts",
        "/fermentations/$group_id/planning/general",
        "/fermentations/$group_id/planning/protocol",
        "/fermentations/$group_id/planning/"
      ]
    },
    "/fermentations/$group_id/results": {
      "filePath": "fermentations/$group_id/results/route.tsx",
      "parent": "/fermentations/$group_id",
      "children": [
        "/fermentations/$group_id/results/analysis",
        "/fermentations/$group_id/results/charts",
        "/fermentations/$group_id/results/data",
        "/fermentations/$group_id/results/kpis",
        "/fermentations/$group_id/results/tests",
        "/fermentations/$group_id/results/"
      ]
    },
    "/fermentations/$group_id/setup": {
      "filePath": "fermentations/$group_id/setup/route.tsx",
      "parent": "/fermentations/$group_id",
      "children": [
        "/fermentations/$group_id/setup/calibration",
        "/fermentations/$group_id/setup/inoculation",
        "/fermentations/$group_id/setup/pre-cleaning",
        "/fermentations/$group_id/setup/preparation",
        "/fermentations/$group_id/setup/seed-flask",
        "/fermentations/$group_id/setup/"
      ]
    },
    "/fermentations/procedures/$procedure_id": {
      "filePath": "fermentations/procedures/$procedure_id/route.tsx",
      "children": [
        "/fermentations/procedures/$procedure_id/alerts",
        "/fermentations/procedures/$procedure_id/dashboard",
        "/fermentations/procedures/$procedure_id/kpis",
        "/fermentations/procedures/$procedure_id/lines",
        "/fermentations/procedures/$procedure_id/overview",
        "/fermentations/procedures/$procedure_id/protocols",
        "/fermentations/procedures/$procedure_id/tasks",
        "/fermentations/procedures/$procedure_id/"
      ]
    },
    "/fermentations/protocols/$protocol_id": {
      "filePath": "fermentations/protocols/$protocol_id/route.tsx",
      "children": [
        "/fermentations/protocols/$protocol_id/overview",
        "/fermentations/protocols/$protocol_id/parameters",
        "/fermentations/protocols/$protocol_id/"
      ]
    },
    "/food-app/projects/$project_id": {
      "filePath": "food-app/projects/$project_id/route.tsx",
      "parent": "/food-app/projects",
      "children": [
        "/food-app/projects/$project_id/",
        "/food-app/projects/$project_id/sensory/$sensory_session_id"
      ]
    },
    "/food-app/sessions/$session_id": {
      "filePath": "food-app/sessions/$session_id/route.tsx",
      "parent": "/food-app",
      "children": [
        "/food-app/sessions/$session_id/analysis",
        "/food-app/sessions/$session_id/general",
        "/food-app/sessions/$session_id/results",
        "/food-app/sessions/$session_id/running",
        "/food-app/sessions/$session_id/setup",
        "/food-app/sessions/$session_id/"
      ]
    },
    "/harvests/operation-templates/$template_id": {
      "filePath": "harvests/operation-templates/$template_id/route.tsx",
      "children": [
        "/harvests/operation-templates/$template_id/attributes",
        "/harvests/operation-templates/$template_id/kpis",
        "/harvests/operation-templates/$template_id/samples",
        "/harvests/operation-templates/$template_id/"
      ]
    },
    "/harvests/protocols/$protocol_id": {
      "filePath": "harvests/protocols/$protocol_id/route.tsx",
      "children": [
        "/harvests/protocols/$protocol_id/cleaning",
        "/harvests/protocols/$protocol_id/kpis",
        "/harvests/protocols/$protocol_id/"
      ]
    },
    "/inventory/equipment/$equipment_id": {
      "filePath": "inventory/equipment/$equipment_id/route.tsx",
      "parent": "/inventory",
      "children": [
        "/inventory/equipment/$equipment_id/maintenance",
        "/inventory/equipment/$equipment_id/",
        "/inventory/equipment/$equipment_id/cleaning/$record_id",
        "/inventory/equipment/$equipment_id/cleaning/new",
        "/inventory/equipment/$equipment_id/cleaning/"
      ]
    },
    "/settings/cleaning-procedures/$procedure_id": {
      "filePath": "settings/cleaning-procedures/$procedure_id/route.tsx",
      "children": [
        "/settings/cleaning-procedures/$procedure_id/fields",
        "/settings/cleaning-procedures/$procedure_id/",
        "/settings/cleaning-procedures/$procedure_id/forms/$form_id"
      ]
    },
    "/analytics/blueprints/$blueprint_id": {
      "filePath": "analytics/blueprints.$blueprint_id.tsx",
      "parent": "/analytics"
    },
    "/analytics/classic/$slug": {
      "filePath": "analytics/classic/$slug.tsx",
      "parent": "/analytics"
    },
    "/analytics/methods/$template_id": {
      "filePath": "analytics/methods.$template_id.tsx",
      "parent": "/analytics"
    },
    "/brewcontrol/$nodeId/calibration": {
      "filePath": "brewcontrol/$nodeId/calibration.tsx",
      "parent": "/brewcontrol/$nodeId"
    },
    "/brewcontrol/$nodeId/config": {
      "filePath": "brewcontrol/$nodeId/config.tsx",
      "parent": "/brewcontrol/$nodeId"
    },
    "/brewcontrol/$nodeId/devices": {
      "filePath": "brewcontrol/$nodeId/devices.tsx",
      "parent": "/brewcontrol/$nodeId"
    },
    "/brewcontrol/$nodeId/logs": {
      "filePath": "brewcontrol/$nodeId/logs.tsx",
      "parent": "/brewcontrol/$nodeId"
    },
    "/devices/rigs/$rigId": {
      "filePath": "devices/rigs/$rigId.tsx",
      "parent": "/devices"
    },
    "/fermentations/$group_id/timeline": {
      "filePath": "fermentations/$group_id/timeline.tsx",
      "parent": "/fermentations/$group_id"
    },
    "/fermentations/dashboards/$dashboardId": {
      "filePath": "fermentations/dashboards/$dashboardId.tsx"
    },
    "/fermentations/investigations/$investigation_id": {
      "filePath": "fermentations/investigations/$investigation_id.tsx"
    },
    "/fermentations/medium-recipes/$recipe_id": {
      "filePath": "fermentations/medium-recipes/$recipe_id.tsx"
    },
    "/food-app/ingredients/$product_id": {
      "filePath": "food-app/ingredients/$product_id.tsx",
      "parent": "/food-app/ingredients"
    },
    "/food-app/sensory/$brew_sensory_session_id": {
      "filePath": "food-app/sensory/$brew_sensory_session_id.tsx",
      "parent": "/food-app/sensory"
    },
    "/food-app/sensory/templates": {
      "filePath": "food-app/sensory/templates.tsx",
      "parent": "/food-app/sensory"
    },
    "/food-app/tasters/$taster_id": {
      "filePath": "food-app/tasters/$taster_id.tsx",
      "parent": "/food-app/tasters"
    },
    "/food-app/tastings/$tasting_id": {
      "filePath": "food-app/tastings/$tasting_id.tsx",
      "parent": "/food-app/tastings"
    },
    "/harvests/$session_id/analysis": {
      "filePath": "harvests/$session_id/analysis.tsx",
      "parent": "/harvests/$session_id"
    },
    "/harvests/$session_id/batches": {
      "filePath": "harvests/$session_id/batches.tsx",
      "parent": "/harvests/$session_id"
    },
    "/harvests/$session_id/live": {
      "filePath": "harvests/$session_id/live.tsx",
      "parent": "/harvests/$session_id"
    },
    "/harvests/$session_id/post-cleaning": {
      "filePath": "harvests/$session_id/post-cleaning.tsx",
      "parent": "/harvests/$session_id"
    },
    "/harvests/$session_id/pre-cleaning": {
      "filePath": "harvests/$session_id/pre-cleaning.tsx",
      "parent": "/harvests/$session_id"
    },
    "/harvests/$session_id/samples": {
      "filePath": "harvests/$session_id/samples.tsx",
      "parent": "/harvests/$session_id"
    },
    "/harvests/batches/$batch_id": {
      "filePath": "harvests/batches/$batch_id.tsx"
    },
    "/inventory/orders/new": {
      "filePath": "inventory/orders.new.tsx",
      "parent": "/inventory/orders"
    },
    "/inventory/prepare/dilution": {
      "filePath": "inventory/prepare.dilution.tsx",
      "parent": "/inventory"
    },
    "/inventory/prepare/recipe": {
      "filePath": "inventory/prepare.recipe.tsx",
      "parent": "/inventory"
    },
    "/inventory/purchased/new": {
      "filePath": "inventory/purchased.new.tsx",
      "parent": "/inventory"
    },
    "/inventory/recipes/$recipeId": {
      "filePath": "inventory/recipes/$recipeId.tsx",
      "parent": "/inventory"
    },
    "/sensory/join/$join_code": {
      "filePath": "sensory/join/$join_code.tsx"
    },
    "/settings/batch-clearance/$clearance_defintion_id": {
      "filePath": "settings/batch-clearance/$clearance_defintion_id.tsx"
    },
    "/settings/formula-templates/$template_id": {
      "filePath": "settings/formula-templates/$template_id.tsx"
    },
    "/settings/inventory/certificate-types": {
      "filePath": "settings/inventory/certificate-types.tsx"
    },
    "/settings/inventory/equipment-models": {
      "filePath": "settings/inventory/equipment-models.tsx"
    },
    "/settings/inventory/equipment-types": {
      "filePath": "settings/inventory/equipment-types.tsx"
    },
    "/settings/inventory/locations": {
      "filePath": "settings/inventory/locations.tsx"
    },
    "/settings/inventory/manufacturers": {
      "filePath": "settings/inventory/manufacturers.tsx"
    },
    "/settings/inventory/resources": {
      "filePath": "settings/inventory/resources.tsx"
    },
    "/settings/inventory/sterilization": {
      "filePath": "settings/inventory/sterilization.tsx"
    },
    "/stage/preview/$tasting_id": {
      "filePath": "stage/preview/$tasting_id.tsx"
    },
    "/stage/tasting/$tasting_id": {
      "filePath": "stage/tasting/$tasting_id.tsx"
    },
    "/analytics/blueprints/": {
      "filePath": "analytics/blueprints.index.tsx",
      "parent": "/analytics"
    },
    "/analytics/classic/": {
      "filePath": "analytics/classic/index.tsx",
      "parent": "/analytics"
    },
    "/analytics/external/": {
      "filePath": "analytics/external/index.tsx",
      "parent": "/analytics"
    },
    "/analytics/templates/": {
      "filePath": "analytics/templates/index.tsx",
      "parent": "/analytics"
    },
    "/brewcontrol/$nodeId/": {
      "filePath": "brewcontrol/$nodeId/index.tsx",
      "parent": "/brewcontrol/$nodeId"
    },
    "/brewcontrol/wirings/": {
      "filePath": "brewcontrol/wirings/index.tsx",
      "parent": "/brewcontrol"
    },
    "/fermentations/$group_id/": {
      "filePath": "fermentations/$group_id/index.tsx",
      "parent": "/fermentations/$group_id"
    },
    "/fermentations/dashboards/": {
      "filePath": "fermentations/dashboards/index.tsx"
    },
    "/fermentations/investigations/": {
      "filePath": "fermentations/investigations/index.tsx"
    },
    "/fermentations/medium-recipes/": {
      "filePath": "fermentations/medium-recipes/index.tsx"
    },
    "/fermentations/procedures/": {
      "filePath": "fermentations/procedures/index.tsx"
    },
    "/fermentations/protocols/": {
      "filePath": "fermentations/protocols/index.tsx"
    },
    "/food-app/ingredients/": {
      "filePath": "food-app/ingredients/index.tsx",
      "parent": "/food-app/ingredients"
    },
    "/food-app/projects/": {
      "filePath": "food-app/projects/index.tsx",
      "parent": "/food-app/projects"
    },
    "/food-app/sensory/": {
      "filePath": "food-app/sensory/index.tsx",
      "parent": "/food-app/sensory"
    },
    "/food-app/tasters/": {
      "filePath": "food-app/tasters/index.tsx",
      "parent": "/food-app/tasters"
    },
    "/food-app/tastings/": {
      "filePath": "food-app/tastings/index.tsx",
      "parent": "/food-app/tastings"
    },
    "/harvests/$session_id/": {
      "filePath": "harvests/$session_id/index.tsx",
      "parent": "/harvests/$session_id"
    },
    "/harvests/batches/": {
      "filePath": "harvests/batches/index.tsx"
    },
    "/harvests/operation-templates/": {
      "filePath": "harvests/operation-templates/index.tsx"
    },
    "/harvests/protocols/": {
      "filePath": "harvests/protocols/index.tsx"
    },
    "/inventory/equipment/": {
      "filePath": "inventory/equipment.index.tsx",
      "parent": "/inventory"
    },
    "/inventory/recipes/": {
      "filePath": "inventory/recipes/index.tsx",
      "parent": "/inventory"
    },
    "/settings/batch-clearance/": {
      "filePath": "settings/batch-clearance/index.tsx"
    },
    "/settings/cleaning-procedures/": {
      "filePath": "settings/cleaning-procedures/index.tsx"
    },
    "/settings/documents/": {
      "filePath": "settings/documents/index.tsx"
    },
    "/settings/formula-templates/": {
      "filePath": "settings/formula-templates/index.tsx"
    },
    "/analytics/external/imports/$import_id": {
      "filePath": "analytics/external/imports.$import_id.tsx",
      "parent": "/analytics"
    },
    "/analytics/external/orders/$session_id": {
      "filePath": "analytics/external/orders.$session_id.tsx",
      "parent": "/analytics"
    },
    "/analytics/templates/$template_id/attributes": {
      "filePath": "analytics/templates/$template_id/attributes.tsx",
      "parent": "/analytics/templates/$template_id"
    },
    "/analytics/templates/$template_id/blueprint": {
      "filePath": "analytics/templates/$template_id/blueprint.tsx",
      "parent": "/analytics/templates/$template_id"
    },
    "/analytics/templates/$template_id/curves": {
      "filePath": "analytics/templates/$template_id/curves.tsx",
      "parent": "/analytics/templates/$template_id"
    },
    "/brewcontrol/wirings/$modelId/calibration": {
      "filePath": "brewcontrol/wirings/$modelId/calibration.tsx",
      "parent": "/brewcontrol/wirings/$modelId"
    },
    "/fermentations/$group_id/aftercare/cip": {
      "filePath": "fermentations/$group_id/aftercare/cip.tsx",
      "parent": "/fermentations/$group_id/aftercare"
    },
    "/fermentations/$group_id/aftercare/weights": {
      "filePath": "fermentations/$group_id/aftercare/weights.tsx",
      "parent": "/fermentations/$group_id/aftercare"
    },
    "/fermentations/$group_id/planning/alerts": {
      "filePath": "fermentations/$group_id/planning/alerts.tsx",
      "parent": "/fermentations/$group_id/planning"
    },
    "/fermentations/$group_id/planning/general": {
      "filePath": "fermentations/$group_id/planning/general.tsx",
      "parent": "/fermentations/$group_id/planning"
    },
    "/fermentations/$group_id/planning/protocol": {
      "filePath": "fermentations/$group_id/planning/protocol.tsx",
      "parent": "/fermentations/$group_id/planning"
    },
    "/fermentations/$group_id/results/analysis": {
      "filePath": "fermentations/$group_id/results/analysis.tsx",
      "parent": "/fermentations/$group_id/results"
    },
    "/fermentations/$group_id/results/charts": {
      "filePath": "fermentations/$group_id/results/charts.tsx",
      "parent": "/fermentations/$group_id/results"
    },
    "/fermentations/$group_id/results/data": {
      "filePath": "fermentations/$group_id/results/data.tsx",
      "parent": "/fermentations/$group_id/results"
    },
    "/fermentations/$group_id/results/kpis": {
      "filePath": "fermentations/$group_id/results/kpis.tsx",
      "parent": "/fermentations/$group_id/results"
    },
    "/fermentations/$group_id/results/tests": {
      "filePath": "fermentations/$group_id/results/tests.tsx",
      "parent": "/fermentations/$group_id/results"
    },
    "/fermentations/$group_id/setup/calibration": {
      "filePath": "fermentations/$group_id/setup/calibration.tsx",
      "parent": "/fermentations/$group_id/setup"
    },
    "/fermentations/$group_id/setup/inoculation": {
      "filePath": "fermentations/$group_id/setup/inoculation.tsx",
      "parent": "/fermentations/$group_id/setup"
    },
    "/fermentations/$group_id/setup/pre-cleaning": {
      "filePath": "fermentations/$group_id/setup/pre-cleaning.tsx",
      "parent": "/fermentations/$group_id/setup"
    },
    "/fermentations/$group_id/setup/preparation": {
      "filePath": "fermentations/$group_id/setup/preparation.tsx",
      "parent": "/fermentations/$group_id/setup"
    },
    "/fermentations/$group_id/setup/seed-flask": {
      "filePath": "fermentations/$group_id/setup/seed-flask.tsx",
      "parent": "/fermentations/$group_id/setup"
    },
    "/fermentations/procedures/$procedure_id/alerts": {
      "filePath": "fermentations/procedures/$procedure_id/alerts.tsx",
      "parent": "/fermentations/procedures/$procedure_id"
    },
    "/fermentations/procedures/$procedure_id/dashboard": {
      "filePath": "fermentations/procedures/$procedure_id/dashboard.tsx",
      "parent": "/fermentations/procedures/$procedure_id"
    },
    "/fermentations/procedures/$procedure_id/kpis": {
      "filePath": "fermentations/procedures/$procedure_id/kpis.tsx",
      "parent": "/fermentations/procedures/$procedure_id"
    },
    "/fermentations/procedures/$procedure_id/lines": {
      "filePath": "fermentations/procedures/$procedure_id/lines.tsx",
      "parent": "/fermentations/procedures/$procedure_id"
    },
    "/fermentations/procedures/$procedure_id/overview": {
      "filePath": "fermentations/procedures/$procedure_id/overview.tsx",
      "parent": "/fermentations/procedures/$procedure_id"
    },
    "/fermentations/procedures/$procedure_id/protocols": {
      "filePath": "fermentations/procedures/$procedure_id/protocols.tsx",
      "parent": "/fermentations/procedures/$procedure_id"
    },
    "/fermentations/procedures/$procedure_id/tasks": {
      "filePath": "fermentations/procedures/$procedure_id/tasks.tsx",
      "parent": "/fermentations/procedures/$procedure_id"
    },
    "/fermentations/protocols/$protocol_id/overview": {
      "filePath": "fermentations/protocols/$protocol_id/overview.tsx",
      "parent": "/fermentations/protocols/$protocol_id"
    },
    "/fermentations/protocols/$protocol_id/parameters": {
      "filePath": "fermentations/protocols/$protocol_id/parameters.tsx",
      "parent": "/fermentations/protocols/$protocol_id"
    },
    "/food-app/sessions/$session_id/analysis": {
      "filePath": "food-app/sessions/$session_id/analysis.tsx",
      "parent": "/food-app/sessions/$session_id"
    },
    "/food-app/sessions/$session_id/general": {
      "filePath": "food-app/sessions/$session_id/general.tsx",
      "parent": "/food-app/sessions/$session_id"
    },
    "/food-app/sessions/$session_id/results": {
      "filePath": "food-app/sessions/$session_id/results.tsx",
      "parent": "/food-app/sessions/$session_id"
    },
    "/food-app/sessions/$session_id/running": {
      "filePath": "food-app/sessions/$session_id/running.tsx",
      "parent": "/food-app/sessions/$session_id"
    },
    "/food-app/sessions/$session_id/setup": {
      "filePath": "food-app/sessions/$session_id/setup.tsx",
      "parent": "/food-app/sessions/$session_id"
    },
    "/harvests/$session_id/stages/$stage_id": {
      "filePath": "harvests/$session_id/stages/$stage_id.tsx",
      "parent": "/harvests/$session_id"
    },
    "/harvests/operation-templates/$template_id/attributes": {
      "filePath": "harvests/operation-templates/$template_id/attributes.tsx",
      "parent": "/harvests/operation-templates/$template_id"
    },
    "/harvests/operation-templates/$template_id/kpis": {
      "filePath": "harvests/operation-templates/$template_id/kpis.tsx",
      "parent": "/harvests/operation-templates/$template_id"
    },
    "/harvests/operation-templates/$template_id/samples": {
      "filePath": "harvests/operation-templates/$template_id/samples.tsx",
      "parent": "/harvests/operation-templates/$template_id"
    },
    "/harvests/protocols/$protocol_id/cleaning": {
      "filePath": "harvests/protocols/$protocol_id/cleaning.tsx",
      "parent": "/harvests/protocols/$protocol_id"
    },
    "/harvests/protocols/$protocol_id/kpis": {
      "filePath": "harvests/protocols/$protocol_id/kpis.tsx",
      "parent": "/harvests/protocols/$protocol_id"
    },
    "/inventory/equipment/$equipment_id/maintenance": {
      "filePath": "inventory/equipment/$equipment_id/maintenance.tsx",
      "parent": "/inventory/equipment/$equipment_id"
    },
    "/sensory/join/brew/$sensory_session_id": {
      "filePath": "sensory/join/brew/$sensory_session_id.tsx"
    },
    "/settings/cleaning-procedures/$procedure_id/fields": {
      "filePath": "settings/cleaning-procedures/$procedure_id/fields.tsx",
      "parent": "/settings/cleaning-procedures/$procedure_id"
    },
    "/settings/inventory/suppliers/$id": {
      "filePath": "settings/inventory/suppliers.$id.tsx"
    },
    "/analytics/templates/$template_id/": {
      "filePath": "analytics/templates/$template_id/index.tsx",
      "parent": "/analytics/templates/$template_id"
    },
    "/brewcontrol/wirings/$modelId/": {
      "filePath": "brewcontrol/wirings/$modelId/index.tsx",
      "parent": "/brewcontrol/wirings/$modelId"
    },
    "/fermentations/$group_id/aftercare/": {
      "filePath": "fermentations/$group_id/aftercare/index.tsx",
      "parent": "/fermentations/$group_id/aftercare"
    },
    "/fermentations/$group_id/planning/": {
      "filePath": "fermentations/$group_id/planning/index.tsx",
      "parent": "/fermentations/$group_id/planning"
    },
    "/fermentations/$group_id/results/": {
      "filePath": "fermentations/$group_id/results/index.tsx",
      "parent": "/fermentations/$group_id/results"
    },
    "/fermentations/$group_id/setup/": {
      "filePath": "fermentations/$group_id/setup/index.tsx",
      "parent": "/fermentations/$group_id/setup"
    },
    "/fermentations/procedures/$procedure_id/": {
      "filePath": "fermentations/procedures/$procedure_id/index.tsx",
      "parent": "/fermentations/procedures/$procedure_id"
    },
    "/fermentations/protocols/$protocol_id/": {
      "filePath": "fermentations/protocols/$protocol_id/index.tsx",
      "parent": "/fermentations/protocols/$protocol_id"
    },
    "/food-app/projects/$project_id/": {
      "filePath": "food-app/projects/$project_id/index.tsx",
      "parent": "/food-app/projects/$project_id"
    },
    "/food-app/sessions/$session_id/": {
      "filePath": "food-app/sessions/$session_id/index.tsx",
      "parent": "/food-app/sessions/$session_id"
    },
    "/harvests/operation-templates/$template_id/": {
      "filePath": "harvests/operation-templates/$template_id/index.tsx",
      "parent": "/harvests/operation-templates/$template_id"
    },
    "/harvests/protocols/$protocol_id/": {
      "filePath": "harvests/protocols/$protocol_id/index.tsx",
      "parent": "/harvests/protocols/$protocol_id"
    },
    "/inventory/equipment/$equipment_id/": {
      "filePath": "inventory/equipment/$equipment_id/index.tsx",
      "parent": "/inventory/equipment/$equipment_id"
    },
    "/settings/cleaning-procedures/$procedure_id/": {
      "filePath": "settings/cleaning-procedures/$procedure_id/index.tsx",
      "parent": "/settings/cleaning-procedures/$procedure_id"
    },
    "/food-app/projects/$project_id/sensory/$sensory_session_id": {
      "filePath": "food-app/projects/$project_id/sensory.$sensory_session_id.tsx",
      "parent": "/food-app/projects/$project_id"
    },
    "/inventory/equipment/$equipment_id/cleaning/$record_id": {
      "filePath": "inventory/equipment/$equipment_id/cleaning/$record_id.tsx",
      "parent": "/inventory/equipment/$equipment_id"
    },
    "/inventory/equipment/$equipment_id/cleaning/new": {
      "filePath": "inventory/equipment/$equipment_id/cleaning/new.tsx",
      "parent": "/inventory/equipment/$equipment_id"
    },
    "/settings/cleaning-procedures/$procedure_id/forms/$form_id": {
      "filePath": "settings/cleaning-procedures/$procedure_id/forms/$form_id.tsx",
      "parent": "/settings/cleaning-procedures/$procedure_id"
    },
    "/inventory/equipment/$equipment_id/cleaning/": {
      "filePath": "inventory/equipment/$equipment_id/cleaning/index.tsx",
      "parent": "/inventory/equipment/$equipment_id"
    }
  }
}
ROUTE_MANIFEST_END */
